// AUTO-GENERATED chunk 'core-utils' by build_bundle.py
// Modules: feature-discovery.js, share-card.js, premium-gate.js, tier-preview.js, smart-insights.js, ticker-modules.js, ticker-suggestions.js, metric-insights.js, time-aware.js, data-freshness.js, cluster-badge.js, cluster-fire-banner.js, provenance-registry.js, feature-of-the-day.js, tab-reorder.js, pull-refresh.js, context-menu.js, system-messages.js, loading-states.js, data-cache.js, funnel-analytics.js, share-links.js, aria-labels.js, age-gate.js, tooltip-tour.js, cat-mascot.js, creator-mode.js, product/chrome/dark-topbar.js, product/chrome/ticker-strip.js, product/chrome/live-data-strip.js, product/chrome/panel-header.js, product/chrome/bottom-tab.js, product/chrome/swipe-gestures.js, product/chrome/sticky-resume-cta.js

// ═══ feature-discovery.js ═══
;"use strict";
// @ts-nocheck
// ═══════════════════════════════════════════════════════════════════
// FEATURE DISCOVERY, SKILL-LEVEL MODES & GUIDED TOUR
// Extracted from dashboard.html — all functions remain global.
//
// TS Migration Phase 2 PR 48 (2026-05-05): renamed .js → .ts as a
// `// @ts-nocheck` initial rename. Shares ~6 top-level identifiers
// with features-extra.ts (PR 43) — _levelMap, _levelViewBtnMap,
// _userLevel, _unlockedViews, _setUserLevel, _applyLevelDimming —
// by design (var-declared duplicates per the PR 43 hotfix lesson).
// Strict typing would force ambient-declaration churn between the
// two. Plus deep cross-chunk surface (setView, openCompare,
// togglePracticeMode, openGlossaryBrowse, toggleKbModal,
// openCommandPalette, _toggleAlertsPanel, _materializeView, escHtml,
// showToast). Tighten in a future consolidation PR that merges
// feature-discovery + features-extra's overlapping skill-level code.
// ═══════════════════════════════════════════════════════════════════
// ═══ SKILL-LEVEL MODES ═══
// 2026-06-08 beginner-orphan fix: 'screener' is now reachable at the
// beginner skill level. Previously beginners were gated out AND the
// beginner fallback button id 'more-screener' (_levelViewBtnMap) was a
// DELETED element, so beginners had no path to the screener at all.
// The watchlist screener-teaser (set-view → screener) is the on-ramp;
// allowing it here keeps the skill-level dimming consistent with that.
var _levelMap = { beginner: ['macro', 'news', 'ticker', 'portfolio', 'watchlist', 'screener'], learner: ['macro', 'news', 'ticker', 'portfolio', 'watchlist', 'fundamentals', 'screener', 'calendar'], expert: ['macro', 'news', 'ticker', 'portfolio', 'watchlist', 'fundamentals', 'screener', 'calendar', '13f', 'credit', 'bdc'] };
var _levelViewBtnMap = { macro: 'view-macro-btn', news: 'view-news-btn', ticker: 'view-ticker-btn', portfolio: 'view-portfolio-btn', watchlist: 'view-watchlist-btn', fundamentals: 'more-fundamentals', screener: 'more-screener', calendar: 'more-calendar', '13f': 'more-13f', credit: 'more-credit', bdc: 'more-bdc' };
var _userLevel = (function () { try {
    return OLStorage.getString('_userLevel', null) || 'beginner';
}
catch (e) {
    return 'beginner';
} })();
var _unlockedViews = OLStorage.get('_unlockedViews', []);
function _setUserLevel(level) { _userLevel = level; try {
    OLStorage.setString('_userLevel', level);
}
catch (e) { } document.querySelectorAll('.level-btn').forEach(function (b) { b.classList.toggle('active', b.dataset.level === level); }); _applyLevelDimming(); }
function _applyLevelDimming() { var allowed = _levelMap[_userLevel] || _levelMap.expert; var unlocked = new Set(_unlockedViews); Object.entries(_levelViewBtnMap).forEach(function (entry) { var view = entry[0], btnId = entry[1]; var btn = document.getElementById(btnId); if (!btn)
    return; var isAllowed = allowed.indexOf(view) >= 0 || unlocked.has(view); btn.classList.toggle('level-dimmed', !isAllowed); if (!isAllowed) {
    btn.title = 'This feature unlocks as you explore more. Click to preview it now, or complete lessons to level up.';
}
else if (btn._wasDimmed) {
    btn.title = '';
    btn._wasDimmed = false;
} if (!isAllowed && !btn._levelClickAttached) {
    btn._wasDimmed = true;
    btn._levelClickAttached = true;
    btn.addEventListener('click', function () { if (btn.classList.contains('level-dimmed')) {
        _unlockedViews.push(view);
        OLStorage.set('_unlockedViews', _unlockedViews);
        btn.classList.remove('level-dimmed');
        btn.title = '';
        btn._wasDimmed = false;
    } });
} }); }
_setUserLevel(_userLevel);
// Level dimming applied in the unified setView wrapper below (line ~89)
// ═══ FEATURE DISCOVERY COMPASS ═══
// Goal-based feature groups (audit #40: goal-driven discovery)
var _FEATURE_GOALS = {
    'learn': { label: 'Learn Investing', features: ['glossary', 'practice', 'live', 'news', 'ticker'] },
    'research': { label: 'Research a Company', features: ['ticker', 'fundamentals', 'compare', 'screener', 'intrinsic', 'anomalies'] },
    'portfolio': { label: 'Track My Portfolio', features: ['portfolio', 'watchlist', 'calendar', 'csvexport', 'alerts'] },
    'credit': { label: 'Fixed Income', features: ['credit', 'bdc', '13f'] },
    'all': { label: 'Show All', features: null },
};
var _activeGoal = 'all';
var PLATFORM_FEATURES = [
    { id: 'live', name: 'LIVE Markets', desc: 'Market pulse with S&P 500, Treasury yields, and VIX (delayed quotes)', key: '1', action: function () { setView('macro'); } },
    { id: 'news', name: 'NEWS Feed', desc: 'Aggregated headlines with sentiment scoring and source diversity', key: '2', action: function () { setView('news'); } },
    { id: 'ticker', name: 'Ticker Deep Dive', desc: 'Full single-stock analysis with price chart, metrics, and filings', key: '3', action: function () { setView('ticker'); } },
    { id: 'fundamentals', name: 'Company Financials', desc: 'Financial statements, margins, growth trends, and peer comparison', key: '4', action: function () { setView('fundamentals'); } },
    { id: 'portfolio', name: 'Portfolio Tracking', desc: 'Track your holdings with P&L, allocation, and correlation matrix', key: '5', action: function () { setView('portfolio'); } },
    { id: 'calendar', name: 'Calendar', desc: 'Earnings dates, ex-dividend dates, and economic releases', key: '6', action: function () { setView('calendar'); } },
    { id: 'watchlist', name: 'Watchlist', desc: 'Research pipeline with conviction scores and investment thesis notes', key: '7', action: function () { setView('watchlist'); } },
    { id: 'screener', name: 'Stock Screener', desc: 'Rank stocks by value and quality metrics across the full market', key: '8', action: function () { setView('screener'); } },
    { id: '13f', name: 'Institutional Holdings', desc: 'See what hedge funds and institutions own — quarterly 13F filings from 1,050+ managers', key: '9', action: function () { setView('13f'); } },
    { id: 'credit', name: 'Bonds & Yield Curves', desc: 'Corporate bond lookup, Treasury yields, and credit spreads', key: '0', action: function () { setView('credit'); } },
    { id: 'bdc', name: 'Private Credit (BDC)', desc: 'Business Development Company holdings and borrower search', key: 'B', action: function () { setView('bdc'); } },
    { id: 'options', name: 'Options Chain + Payoff', desc: 'Options chains with Greeks, IV surface, and payoff diagrams', key: null, action: function () { setView('ticker'); } },
    { id: 'compare', name: 'Peer Comparison', desc: 'Side-by-side comparison of up to 5 tickers on key metrics', key: 'C', action: function () { if (typeof openCompare === 'function')
            openCompare(); } },
    { id: 'practice', name: 'Practice Mode', desc: '6 games: sector guessing, over/under, metric matching, and more — with streaks', key: null, action: function () { if (typeof togglePracticeMode === 'function')
            togglePracticeMode(); } },
    { id: 'glossary', name: 'Glossary', desc: 'Financial term definitions with real-world context and formulas', key: null, action: function () { if (typeof openGlossaryBrowse === 'function')
            openGlossaryBrowse(); } },
    { id: 'shortcuts', name: 'Keyboard Shortcuts', desc: 'Full list of keyboard shortcuts for power-user navigation', key: '?', action: function () { if (typeof toggleKbModal === 'function')
            toggleKbModal(); } },
    { id: 'cmdpalette', name: 'Command Palette', desc: 'Search for any stock, view, or command with fuzzy matching', key: '/', action: function () { if (typeof openCommandPalette === 'function')
            openCommandPalette(); } },
    { id: 'anomalies', name: 'Anomaly Flags', desc: 'Automated alerts for unusual price moves, volume spikes, and gaps', key: null, action: function () { setView('ticker'); } },
    { id: 'intrinsic', name: 'Intrinsic Value Calculator', desc: 'DCF-based fair value estimate with adjustable assumptions', key: null, action: function () { setView('ticker'); } },
    { id: 'companydb', name: 'Company Database', desc: 'Searchable database of 8,000+ public companies with sectors', key: null, action: function () { if (typeof openCommandPalette === 'function')
            openCommandPalette(); } },
    { id: 'alerts', name: 'Alerts Panel', desc: 'Price alerts and notification center for your tracked tickers', key: 'N', action: function () { if (typeof _toggleAlertsPanel === 'function')
            _toggleAlertsPanel(); } },
    { id: 'csvexport', name: 'CSV Export', desc: 'Export portfolio, watchlist, and screening data to CSV files', key: null, action: function () { setView('portfolio'); } }
];
function _getDiscoveredFeatures() {
    return OLStorage.get('discoveredFeatures', []);
}
function _markFeatureDiscovered(id) {
    var disc = _getDiscoveredFeatures();
    if (disc.indexOf(id) === -1) {
        disc.push(id);
        OLStorage.set('discoveredFeatures', disc);
    }
}
function _renderFdGrid(goal) {
    _activeGoal = goal || 'all';
    var disc = _getDiscoveredFeatures();
    var goalConfig = _FEATURE_GOALS[_activeGoal];
    var allowedIds = goalConfig && goalConfig.features ? new Set(goalConfig.features) : null;
    var filtered = allowedIds ? PLATFORM_FEATURES.filter(function (f) { return allowedIds.has(f.id); }) : PLATFORM_FEATURES;
    var count = disc.length;
    var total = PLATFORM_FEATURES.length;
    var progText = document.getElementById('fd-progress-text');
    var progFill = document.getElementById('fd-progress-fill');
    if (progText)
        progText.textContent = count + ' of ' + total + ' discovered';
    if (progFill)
        progFill.style.width = (total > 0 ? Math.round(count / total * 100) : 0) + '%';
    var grid = document.getElementById('fd-grid');
    if (!grid)
        return;
    var h = '';
    filtered.forEach(function (f) {
        var isDisc = disc.indexOf(f.id) !== -1;
        h += '<div class="fd-card' + (isDisc ? ' discovered' : '') + '">';
        h += '<div class="fd-card-name">' + escHtml(f.name) + '</div>';
        h += '<div class="fd-card-desc">' + escHtml(f.desc) + '</div>';
        h += '<button class="fd-try-btn" data-fd-action="try-feature" data-fd-id="' + f.id + '">Try it \u2192</button>';
        h += '</div>';
    });
    grid.innerHTML = h;
    // Update goal button active states
    document.querySelectorAll('.fd-goal-btn').forEach(function (b) { b.classList.toggle('active', b.dataset.goal === _activeGoal); });
}
function openFeatureDiscovery() {
    // Delay compass for brand-new users: don't show for 3 days after first welcome
    // (reduces cognitive overload on first visit — same pattern as daily-goals delay)
    try {
        var _wts = OLStorage.getString('ol_welcome_ts', null);
        if (_wts) {
            var _daysSinceWelcome = (Date.now() - parseInt(_wts, 10)) / 86400000;
            if (_daysSinceWelcome < 3) {
                if (typeof showToast === 'function') {
                    showToast('Explore the platform first \u2014 the feature compass unlocks after 3 days', 'info', 3000);
                }
                return;
            }
        }
    }
    catch (e) { }
    // Materialize from <template> if not yet in live DOM (S24 multi-page routing)
    if (!document.getElementById('feat-disc-overlay')) {
        if (typeof _materializeView === 'function') {
            // #186: re-invoke openFeatureDiscovery (NOT renderFeatureDiscovery — a
            // phantom name that never existed: threw ReferenceError on the cold
            // overlay-materialize path, leaving "What's new" dead until a 2nd open).
            _materializeView('feat-disc-overlay').then(function () { openFeatureDiscovery(); });
            return;
        }
    }
    var overlay = document.getElementById('feat-disc-overlay');
    if (!overlay)
        return;
    // Render goal filter buttons (audit #40: goal-driven discovery)
    var goalBar = document.getElementById('fd-goal-bar');
    if (!goalBar) {
        goalBar = document.createElement('div');
        goalBar.id = 'fd-goal-bar';
        goalBar.className = 'fd-goal-bar';
        var gh = '';
        for (var gk in _FEATURE_GOALS) {
            var g = _FEATURE_GOALS[gk];
            gh += '<button class="fd-goal-btn' + (gk === _activeGoal ? ' active' : '') + '" data-goal="' + gk + '" data-action="fd-set-goal">' + escHtml(g.label) + '</button>';
        }
        goalBar.innerHTML = gh;
        var grid = document.getElementById('fd-grid');
        if (grid && grid.parentNode)
            grid.parentNode.insertBefore(goalBar, grid);
    }
    _renderFdGrid(_activeGoal);
    overlay.classList.add('open');
}
function closeFeatureDiscovery() {
    var overlay = document.getElementById('feat-disc-overlay');
    if (overlay)
        overlay.classList.remove('open');
}
function tryFeature(id) {
    _markFeatureDiscovered(id);
    closeFeatureDiscovery();
    var feat = PLATFORM_FEATURES.find(function (f) { return f.id === id; });
    if (feat && feat.action)
        feat.action();
}
// Lazy-init: all auto-executing code wrapped
window.initFeatureDiscovery = function () {
    (function () {
        var origSetView = setView;
        setView = function (view) {
            var map = { macro: 'live', news: 'news', ticker: 'ticker', fundamentals: 'fundamentals', portfolio: 'portfolio', calendar: 'calendar', watchlist: 'watchlist', screener: 'screener', '13f': '13f', credit: 'credit', bdc: 'bdc' };
            if (map[view])
                _markFeatureDiscovered(map[view]);
            var result = origSetView.apply(this, arguments);
            _applyLevelDimming(); // combined from previous separate wrapper
            return result;
        };
    })();
    // Escape to close feature discovery
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            var fdOverlay = document.getElementById('feat-disc-overlay');
            if (fdOverlay && fdOverlay.classList.contains('open')) {
                e.preventDefault();
                closeFeatureDiscovery();
                return;
            }
            // Close tour on Escape too
            if (document.querySelector('.tour-tooltip')) {
                e.preventDefault();
                _endTour();
                return;
            }
        }
    });
    // ═══ GUIDED TOUR (first-time only) ═══
    var _tourStep = 0;
    var _tourActive = false;
    var TOUR_STEPS = [
        { target: '#ticker-tabs', text: 'These are your stocks. Click any ticker to see its full analysis.', position: 'bottom' },
        { target: '#key-metrics-strip', text: 'Key metrics with signal colors. Hover any metric and press I for details.', position: 'bottom' },
        { target: '#cmd-trigger', text: 'Press / to search for any stock, view, or command.', position: 'bottom' },
        { target: '#view-macro-btn', text: '11 research tools. Use keys 1-9, 0, B to jump between them.', position: 'bottom' },
        { target: '#view-watchlist-btn', text: 'Track your research pipeline here with conviction scores and thesis notes.', position: 'bottom' }
    ];
    function _startTour() {
        try {
            if (OLStorage.getString('tourCompleted', null))
                return;
        }
        catch (e) {
            return;
        }
        _tourActive = true;
        _tourStep = 0;
        _showTourStep();
    }
    function _showTourStep() {
        // Remove previous tooltip and highlight
        var prev = document.querySelector('.tour-tooltip');
        if (prev)
            prev.remove();
        document.querySelectorAll('.tour-highlight').forEach(function (el) { el.classList.remove('tour-highlight'); });
        if (_tourStep >= TOUR_STEPS.length) {
            _endTour();
            return;
        }
        var step = TOUR_STEPS[_tourStep];
        var targetEl = document.querySelector(step.target);
        if (!targetEl) {
            _tourStep++;
            _showTourStep();
            return;
        }
        // Highlight target
        targetEl.classList.add('tour-highlight');
        // Create tooltip
        var tooltip = document.createElement('div');
        tooltip.className = 'tour-tooltip';
        tooltip.innerHTML =
            '<div class="tour-step-indicator">Step ' + (_tourStep + 1) + ' of ' + TOUR_STEPS.length + '</div>' +
                '<div class="tour-tooltip-text">' + escHtml(step.text) + '</div>' +
                '<div class="tour-actions">' +
                '<button class="tour-skip-link" data-fd-action="end-tour">Skip tour</button>' +
                '<button class="tour-next-btn" data-fd-action="next-tour-step">' + (_tourStep === TOUR_STEPS.length - 1 ? 'Done' : 'Next \u2192') + '</button>' +
                '</div>';
        document.body.appendChild(tooltip);
        // Position tooltip
        var rect = targetEl.getBoundingClientRect();
        var ttW = 320;
        var left = Math.max(8, Math.min(rect.left, window.innerWidth - ttW - 16));
        var top = rect.bottom + 10;
        if (top + 140 > window.innerHeight) {
            top = rect.top - 140;
        }
        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
    }
    function _nextTourStep() {
        _tourStep++;
        _showTourStep();
    }
    function _endTour() {
        _tourActive = false;
        var tt = document.querySelector('.tour-tooltip');
        if (tt)
            tt.remove();
        document.querySelectorAll('.tour-highlight').forEach(function (el) { el.classList.remove('tour-highlight'); });
        try {
            OLStorage.setString('tourCompleted', 'true');
        }
        catch (e) { }
    }
    // Trigger tour after onboarding completes (short delay to let UI settle)
    (function () {
        var _checkTourInterval = setInterval(function () {
            if ((function () { try {
                return OLStorage.getString('onboardingDone', null);
            }
            catch (e) {
                return null;
            } })() && !(function () { try {
                return OLStorage.getString('tourCompleted', null);
            }
            catch (e) {
                return null;
            } })()) {
                // Wait until the onboard overlay is gone
                var ob = document.getElementById('onboard-overlay');
                if (!ob || !ob.classList.contains('open')) {
                    clearInterval(_checkTourInterval);
                    setTimeout(_startTour, 1500);
                }
            }
            else {
                clearInterval(_checkTourInterval);
            }
        }, 500);
    })();
}; // end initFeatureDiscovery
// CSP-clean event delegation for the feature-discovery tour UI
// (CYCLE5 #49, 2026-05-05). Replaces 3 inline onclick handlers
// blocked by strict script-src CSP.
let _fdDelegationInstalled = false;
function _fdInstallDelegation() {
    if (_fdDelegationInstalled)
        return;
    _fdDelegationInstalled = true;
    document.addEventListener('click', function (ev) {
        const tgt = ev.target;
        if (!tgt || !tgt.closest)
            return;
        const el = tgt.closest('[data-fd-action]');
        if (!el)
            return;
        const action = el.getAttribute('data-fd-action');
        switch (action) {
            case 'try-feature': {
                const id = el.getAttribute('data-fd-id') || '';
                if (id && typeof tryFeature === 'function')
                    tryFeature(id);
                return;
            }
            case 'end-tour':
                if (typeof _endTour === 'function')
                    _endTour();
                return;
            case 'next-tour-step':
                if (typeof _nextTourStep === 'function')
                    _nextTourStep();
                return;
        }
    });
}
_fdInstallDelegation();
//# sourceMappingURL=feature-discovery.js.map
;
// ═══ share-card.js ═══
;"use strict";
// ── SHARE CARD GENERATOR ──
//
// TS Migration Phase 2 PR 31 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; share-card.js is the build
// artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
// CHAOS 2026-10-03 F6: the card drew `p.change || 0` -- a NULL change (a
// one-bar snapshot, or a typed previous close, api/quote_kind.py) printed as a
// confident flat day, "+0.00 (+0.00%)", and a previous close was drawn as if it
// were the current session's quote. Same rule as the ticker hero: a previous
// close names its session; an unknown change is a dash; only a real 0 is flat.
function _shareCardChangeLine(price) {
    const p = price || {};
    if (p.quoteKind === 'previous_close') {
        return { text: 'Prev close' + (p.previousCloseDate ? ' (' + String(p.previousCloseDate) + ')' : ''), tone: 'neu' };
    }
    if (p.change == null || p.changePct == null)
        return { text: '—', tone: 'neu' };
    const chg = Number(p.change);
    const pct = Number(p.changePct);
    if (!isFinite(chg) || !isFinite(pct))
        return { text: '—', tone: 'neu' };
    const sign = chg >= 0 ? '+' : '';
    return { text: sign + fmt(chg) + ' (' + sign + fmt(pct) + '%)', tone: chg > 0 ? 'pos' : chg < 0 ? 'neg' : 'neu' };
}
function generateShareCard() {
    const w = window;
    if (typeof w._closeShareDropdown === 'function')
        w._closeShareDropdown();
    if (typeof trackUniqueAchievement === 'function')
        trackUniqueAchievement('shares_total', (activeTicker || '') + '_card');
    if (!activeTicker) {
        showToast('No ticker selected', 'warning');
        return;
    }
    const d = getData(activeTicker);
    if (!d) {
        showToast('No data available for ' + activeTicker, 'warning');
        return;
    }
    const W = 600;
    const _enh = (typeof w.getShareCardEnhancements === 'function') ? w.getShareCardEnhancements() : {};
    const _hasEnhancements = !!(_enh.valueScore || _enh.achievementTier || _enh.broker);
    const H = _hasEnhancements ? 450 : 400;
    const canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext('2d');
    if (!ctx)
        return;
    const BG = '#0d1117';
    const TEXT_PRIMARY = '#e8edf2';
    const TEXT_SECONDARY = '#8fa3b8';
    const GREEN = '#c9a961';
    const RED = '#c87466';
    const ACCENT = '#3d7ab8';
    const CARD_BG = '#131920';
    ctx.fillStyle = BG;
    ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = ACCENT;
    ctx.fillRect(0, 0, W, 3);
    ctx.fillStyle = CARD_BG;
    roundRect(ctx, 16, 16, W - 32, H - 32, 8);
    ctx.fill();
    ctx.fillStyle = ACCENT;
    ctx.fillRect(16, 16, 3, H - 32);
    ctx.font = '600 42px "Instrument Serif", "Geist Mono", "SF Mono", Consolas, monospace';
    ctx.fillStyle = TEXT_PRIMARY;
    ctx.textBaseline = 'top';
    ctx.fillText(d.ticker || activeTicker, 36, 32);
    const companyName = String(d.company || '').toUpperCase();
    ctx.font = '13px -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';
    ctx.fillStyle = TEXT_SECONDARY;
    ctx.fillText(companyName.length > 50 ? companyName.slice(0, 47) + '...' : companyName, 36, 80);
    if (d.sector) {
        const sectorText = String(d.sector).toUpperCase();
        ctx.font = '10px -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';
        const sectorW = ctx.measureText(sectorText).width + 12;
        const sectorX = 36;
        const sectorY = 100;
        ctx.fillStyle = 'rgba(35, 134, 54, 0.15)';
        roundRect(ctx, sectorX, sectorY, sectorW, 18, 3);
        ctx.fill();
        ctx.fillStyle = GREEN;
        ctx.fillText(sectorText, sectorX + 6, sectorY + 4);
    }
    const p = (d.price || {});
    const priceStr = p.current ? '$' + fmt(p.current) : '--';
    ctx.font = 'bold 36px "SF Mono", "Cascadia Code", "Fira Code", Consolas, monospace';
    ctx.fillStyle = TEXT_PRIMARY;
    const priceX = W - 40;
    ctx.textAlign = 'right';
    ctx.fillText(priceStr, priceX, 32);
    const chgLine = _shareCardChangeLine(d.price);
    const chgColor = chgLine.tone === 'pos' ? GREEN : chgLine.tone === 'neg' ? RED : TEXT_SECONDARY;
    ctx.font = 'bold 16px "SF Mono", "Cascadia Code", "Fira Code", Consolas, monospace';
    ctx.fillStyle = chgColor;
    ctx.fillText(chgLine.text, priceX, 74);
    ctx.textAlign = 'left';
    ctx.strokeStyle = 'rgba(48, 54, 61, 0.8)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(36, 130);
    ctx.lineTo(W - 36, 130);
    ctx.stroke();
    const m = (d.metrics || {});
    const f = (d.financials || {});
    const metrics = [];
    if (m.pe != null)
        metrics.push({ label: 'P/E', value: fmt(m.pe, 1) + 'x', color: m.pe < 15 ? GREEN : m.pe < 25 ? TEXT_PRIMARY : RED });
    if (m.forwardPe != null)
        metrics.push({ label: 'Fwd P/E', value: fmt(m.forwardPe, 1) + 'x', color: m.forwardPe < 15 ? GREEN : m.forwardPe < 25 ? TEXT_PRIMARY : RED });
    if (f.revenueGrowth != null)
        metrics.push({ label: 'Rev Growth', value: (f.revenueGrowth >= 0 ? '+' : '') + fmt(f.revenueGrowth, 1) + '%', color: f.revenueGrowth > 10 ? GREEN : f.revenueGrowth > 0 ? TEXT_PRIMARY : RED });
    if (d.roic != null)
        metrics.push({ label: 'ROIC', value: fmt(d.roic, 1) + '%', color: d.roic > 15 ? GREEN : d.roic > 8 ? TEXT_PRIMARY : RED });
    if (m.roe != null && metrics.length < 4)
        metrics.push({ label: 'ROE', value: fmt(m.roe, 1) + '%', color: m.roe > 15 ? GREEN : m.roe > 0 ? TEXT_PRIMARY : RED });
    if (m.dividendYield != null && metrics.length < 4)
        metrics.push({ label: 'Div Yield', value: fmt(m.dividendYield, 1) + '%', color: GREEN });
    if (m.evEbitda != null && metrics.length < 4)
        metrics.push({ label: 'EV/EBITDA', value: fmt(m.evEbitda, 1) + 'x', color: m.evEbitda < 10 ? GREEN : m.evEbitda < 15 ? TEXT_PRIMARY : RED });
    if (m.pb != null && metrics.length < 4)
        metrics.push({ label: 'P/B', value: fmt(m.pb, 2) + 'x', color: m.pb < 1 ? GREEN : m.pb < 3 ? TEXT_PRIMARY : RED });
    const displayMetrics = metrics.slice(0, 3);
    const metricY = 148;
    const metricColW = (W - 72) / 3;
    displayMetrics.forEach(function (met, i) {
        const mx = 36 + i * metricColW;
        ctx.font = '11px -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';
        ctx.fillStyle = TEXT_SECONDARY;
        ctx.fillText(met.label, mx, metricY);
        ctx.font = 'bold 20px "SF Mono", "Cascadia Code", "Fira Code", Consolas, monospace';
        ctx.fillStyle = met.color;
        ctx.fillText(met.value, mx, metricY + 18);
    });
    const spark = (d.sparkline || {});
    const prices = spark.prices || [];
    if (prices.length >= 2) {
        const chartX = 36;
        const chartY = 205;
        const chartW = W - 72;
        const chartH = 120;
        ctx.fillStyle = 'rgba(13, 17, 23, 0.5)';
        roundRect(ctx, chartX - 4, chartY - 4, chartW + 8, chartH + 8, 4);
        ctx.fill();
        const pMin = prices.reduce(function (a, b) { return a < b ? a : b; }, Infinity);
        const pMax = prices.reduce(function (a, b) { return a > b ? a : b; }, -Infinity);
        const pRange = pMax - pMin || 1;
        const n = prices.length;
        const isUp = prices[n - 1] >= prices[0];
        const lineColor = isUp ? GREEN : RED;
        const fillColor = isUp ? 'rgba(63, 185, 80, 0.08)' : 'rgba(248, 81, 73, 0.08)';
        ctx.strokeStyle = 'rgba(48, 54, 61, 0.3)';
        ctx.lineWidth = 0.5;
        for (let g = 0; g < 4; g++) {
            const gy = chartY + (chartH / 3) * g;
            ctx.beginPath();
            ctx.moveTo(chartX, gy);
            ctx.lineTo(chartX + chartW, gy);
            ctx.stroke();
        }
        const points = prices.map(function (price, i) {
            return {
                x: chartX + (i / (n - 1)) * chartW,
                y: chartY + chartH - ((price - pMin) / pRange) * chartH,
            };
        });
        ctx.beginPath();
        ctx.moveTo(points[0].x, chartY + chartH);
        points.forEach(function (pt) { ctx.lineTo(pt.x, pt.y); });
        ctx.lineTo(points[n - 1].x, chartY + chartH);
        ctx.closePath();
        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        for (let i = 1; i < n; i++)
            ctx.lineTo(points[i].x, points[i].y);
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = 2;
        ctx.lineJoin = 'round';
        ctx.stroke();
        const last = points[n - 1];
        ctx.beginPath();
        ctx.arc(last.x, last.y, 3, 0, Math.PI * 2);
        ctx.fillStyle = lineColor;
        ctx.fill();
        ctx.font = '10px "SF Mono", "Cascadia Code", "Fira Code", Consolas, monospace';
        ctx.fillStyle = TEXT_SECONDARY;
        ctx.textAlign = 'right';
        ctx.fillText('$' + fmt(pMax), chartX + chartW, chartY - 6);
        ctx.fillText('$' + fmt(pMin), chartX + chartW, chartY + chartH + 12);
        ctx.textAlign = 'left';
        ctx.fillText('30D', chartX, chartY + chartH + 12);
        ctx.textAlign = 'left';
    }
    ctx.strokeStyle = 'rgba(48, 54, 61, 0.8)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(36, H - 48);
    ctx.lineTo(W - 36, H - 48);
    ctx.stroke();
    const footerY = H - 34;
    ctx.font = '11px -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';
    ctx.fillStyle = TEXT_SECONDARY;
    if (p.marketCap != null) {
        ctx.fillText('Mkt Cap: ' + fmtMktCap(p.marketCap), 36, footerY);
    }
    if (p.volume != null) {
        ctx.fillText('Vol: ' + fmtVol(p.volume), 200, footerY);
    }
    if (_hasEnhancements) {
        const enhY = H - 80;
        ctx.strokeStyle = 'rgba(48, 54, 61, 0.5)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(36, enhY);
        ctx.lineTo(W - 36, enhY);
        ctx.stroke();
        let enhX = 36;
        ctx.font = '10px -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';
        ctx.textAlign = 'left';
        if (_enh.valueScore) {
            ctx.fillStyle = TEXT_SECONDARY;
            ctx.fillText('VALUE SCORE', enhX, enhY + 14);
            ctx.font = 'bold 16px "SF Mono", "Cascadia Code", "Fira Code", Consolas, monospace';
            ctx.fillStyle = ACCENT;
            ctx.fillText(String(_enh.valueScore), enhX, enhY + 32);
            enhX += 120;
        }
        if (_enh.achievementTier) {
            ctx.font = '10px -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';
            ctx.fillStyle = TEXT_SECONDARY;
            ctx.fillText('ACHIEVEMENTS', enhX, enhY + 14);
            ctx.font = 'bold 12px -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';
            ctx.fillStyle = GREEN;
            ctx.fillText(_enh.achievementTier + ' (' + _enh.achievementCount + ')', enhX, enhY + 32);
            enhX += 180;
        }
        if (_enh.broker) {
            ctx.font = '10px -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';
            ctx.fillStyle = TEXT_SECONDARY;
            ctx.fillText('BROKER', enhX, enhY + 14);
            ctx.font = 'bold 12px -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';
            ctx.fillStyle = TEXT_PRIMARY;
            ctx.fillText(_enh.broker, enhX, enhY + 32);
        }
    }
    ctx.textAlign = 'right';
    ctx.font = 'italic 10px "Instrument Serif", Georgia, serif';
    ctx.fillStyle = 'rgba(201, 168, 76, 0.45)';
    ctx.fillText('Deep Insights, Deep Conviction', W - 28, H - 34);
    ctx.font = '11px -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';
    ctx.fillStyle = 'rgba(139, 148, 158, 0.5)';
    ctx.fillText('oxfordledge.com', W - 28, H - 22);
    ctx.textAlign = 'left';
    canvas.toBlob(function (blob) {
        if (!blob) {
            showToast('Unable to generate share card. Please try again.', 'error');
            return;
        }
        const wc = window;
        if (navigator.clipboard && typeof wc.ClipboardItem !== 'undefined' && wc.ClipboardItem) {
            const ItemCtor = wc.ClipboardItem;
            navigator.clipboard.write([new ItemCtor({ 'image/png': blob })]).then(function () {
                showToast('Share card copied to clipboard', 'success');
            }).catch(function (err) {
                /* @__PURE__ */ _olDebugWarn('Clipboard write failed, offering download:', err);
                _downloadShareBlob(blob, d.ticker || activeTicker);
            });
        }
        else {
            _downloadShareBlob(blob, d.ticker || activeTicker);
        }
    }, 'image/png');
}
function _downloadShareBlob(blob, ticker) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = (ticker || 'share') + '-card.png';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    showToast('Share card downloaded as PNG', 'success');
}
function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
}
void generateShareCard;
//# sourceMappingURL=share-card.js.map
;
// ═══ premium-gate.js ═══
;"use strict";
/**
 * Premium Feature Gate UI.
 *
 * TS Migration Phase 2 PR 31 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is the SOURCE OF TRUTH; premium-gate.js is the build
 * artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
 *
 * Top-level showPremiumGate / closePremiumGate / checkPremiumAccess +
 * PREMIUM_FEATURES catalogue stay global so app.js + tier-preview can
 * reach them cross-chunk.
 */
const PREMIUM_FEATURES = {
    // F4.2 (SF-23 audit 2026-05-07): '13f' entry removed. OWNER policy
    // per pricing.html:150-154 ratifies 13F as public SEC data — both
    // /api/institutional-holders and /api/institutional-holders/changes
    // are anon-OK. The catalogue entry caused any showPremiumGate('13f')
    // caller to render an upgrade modal against policy. The single FE
    // gate site at app.ts:6366 ('f13-show-all') was unconditionalized
    // in the same commit. tests/test_premium_gate_anon_routes_contract.py
    // pins this with a cross-validation: every key in PREMIUM_FEATURES
    // must map to a backend route that requires a tier higher than 'free'.
    'credit': {
        name: 'Bond & Credit Research',
        desc: 'Analyze corporate bonds by CUSIP, track credit spreads, view debt maturity schedules, and monitor rating events. 2,003 bonds across 33 sectors.',
        tier: 'plus',
        icon: '■',
        learnMore: [
            { label: 'FINRA Bond Center', url: 'https://www.finra.org/finra-data/fixed-income/bonds' },
            { label: 'FRED Credit Spreads', url: 'https://fred.stlouisfed.org/series/BAMLH0A0HYM2' },
        ],
    },
    'bdc': {
        name: 'Private Credit / BDC Analysis',
        desc: 'Explore 60+ Business Development Companies with loan-level portfolio data, borrower details across 17 industries, and mark-to-market analysis.',
        tier: 'plus',
        icon: '◆',
        learnMore: [
            { label: 'What is a BDC?', url: 'https://www.sec.gov/education/capitalraising/building-blocks/business-development-company' },
            { label: 'SEC EDGAR BDC Filings', url: 'https://www.sec.gov/cgi-bin/browse-edgar?type=10-K&dateb=&owner=include&count=40&search_text=&action=getcompany' },
        ],
    },
    'screener': {
        name: 'Stock Screener',
        desc: 'Screen thousands of stocks by combining earnings yield and return on capital to find undervalued quality companies. Customizable filters and CSV export.',
        tier: 'plus',
        icon: '●',
        learnMore: [
            { label: 'The Little Book That Beats the Market', url: 'https://www.amazon.com/Little-Book-That-Beats-Market/dp/0471733067?tag=oxfordledge-20' },
            { label: 'EDGAR Company Search', url: 'https://www.sec.gov/cgi-bin/browse-edgar?company=&CIK=&type=10-K&dateb=&owner=include&count=40&search_text=&action=getcompany' },
        ],
    },
    // 2026-09-26 (OWNER "Fix + give it bulk export"): the screener's "Export
    // all fundamentals" file, GET /api/data/bulk.csv, and its JSON sibling
    // GET /api/data/bulk -- both require_min_tier("pro"). The screener button
    // opens this overlay BEFORE any request for a reader below Investor, and
    // tier-gate.ts maps the /api/data/bulk prefix here for its interceptor.
    'bulk-export': {
        name: 'Bulk Fundamentals Export',
        desc: 'Download one spreadsheet of annual figures taken from SEC filings (revenue, earnings, cash flow, debt, margins and returns) for every company in your screen results, up to 500 at a time.',
        tier: 'pro',
        icon: '■',
        learnMore: [
            { label: 'EDGAR Company Search', url: 'https://www.sec.gov/edgar/searchedgar/companysearch' },
        ],
    },
    'portfolio-analytics': {
        // 2026-05-11 SF-PORTFOLIO-OPENING: OWNER ratified that all 3
        // gated portfolio tabs (Analytics, vs Benchmarks,
        // Correlations) belong on the plus tier (Researcher, $9/mo).
        // Benchmark + correlation render fns were extracted from
        // features-extra.ts (premium chunk) into portfolio-extra.ts
        // (core-portfolio chunk) so plus users get them loaded. The
        // separate 'portfolio-advanced-analytics' entry that briefly
        // existed for the pro-tier scenario was removed since the
        // architectural decision collapses both into one plus-tier
        // feature.
        name: 'Portfolio Analytics',
        desc: 'Sharpe ratio, Sortino ratio, max drawdown, benchmark comparison against the S&P 500, and a multi-asset correlation matrix with diversification scoring. Understand your risk-adjusted performance and concentration risk.',
        tier: 'plus',
        icon: '▲',
        learnMore: [
            { label: 'Investopedia: Sharpe Ratio', url: 'https://www.investopedia.com/terms/s/sharperatio.asp' },
            { label: 'Investopedia: Correlation', url: 'https://www.investopedia.com/terms/c/correlation.asp' },
            { label: 'Portfolio Visualizer (free tool)', url: 'https://www.portfoliovisualizer.com/' },
        ],
    },
    'ai': {
        name: 'AI-Powered Analysis',
        desc: 'Ask intelligent questions about any company. The AI analyzes fundamentals, recent filings, and market data to provide contextual insights with "Why this matters" explanations.',
        tier: 'plus',
        icon: '◆',
        learnMore: [
            { label: 'Oxford Ledge AI Guide', url: '/llm-guide' },
            { label: 'SEC EDGAR Full-Text Search', url: 'https://efts.sec.gov/LATEST/search-index' },
        ],
    },
    'bond-screener': {
        name: 'Bond Screener',
        desc: 'Filter corporate bonds by yield, maturity, rating, sector, and coupon. Export results and compare spreads across issuers.',
        tier: 'plus',
        icon: '■',
        learnMore: [
            { label: 'FINRA Bond Center', url: 'https://www.finra.org/finra-data/fixed-income/bonds' },
            { label: 'FRED Credit Spreads', url: 'https://fred.stlouisfed.org/series/BAMLH0A0HYM2' },
        ],
    },
    'live-data-lessons': {
        // OWNER 2026-09-26 (CHAOS RTQ round 2 F3): was 'Live Data in Lessons' /
        // 'lessons show live metrics'. Quotes are delayed on every plan, and 44 of
        // the 46 lesson market-figure sections are free; what Investor adds is
        // the formula-calculator pre-fill.
        name: 'Current Market Figures in Lessons',
        desc: 'Formula calculators in lessons pre-fill with current market figures for the company you study. Stock quotes are delayed on every plan.',
        tier: 'pro',
        icon: '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>',
        learnMore: [
            { label: 'Browse the lesson library', url: '/learn/' },
        ],
    },
    'ai-quiz-feedback': {
        name: 'AI Quiz Feedback',
        desc: 'Get personalized AI explanations after every quiz. The AI connects your answer to real-world examples and suggests what to review next.',
        tier: 'plus',
        icon: '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="2"></rect><rect x="9" y="9" width="6" height="6"></rect><path d="M9 1v3M15 1v3M9 20v3M15 20v3M20 9h3M20 14h3M1 9h3M1 14h3"></path></svg>',
        learnMore: [
            { label: 'Browse the lesson library', url: '/learn/' },
        ],
    },
    'portfolio-practicum': {
        name: 'Portfolio Practicum',
        desc: 'Build a mock portfolio with AI coaching. Set your investment goal, select stocks, and get a structured AI review of your choices.',
        tier: 'professional',
        icon: '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 10 12 5 2 10l10 5 10-5z"></path><path d="M6 12v5c0 1 2.7 3 6 3s6-2 6-3v-5"></path></svg>',
        learnMore: [
            { label: 'Browse the lesson library', url: '/learn/' },
        ],
    },
    // 'api' entry REMOVED 2026-09-24 (audit M5, OWNER decision of the same
    // date): it sold "API & Developer Access -- REST API, Python SDK, and MCP
    // tools" as an Investor ('pro') feature. MCP, the Python SDK and API
    // credentials are FREE on every tier; paid tiers differ only in the hourly
    // MCP cap (free 100 / Researcher 500 / Investor 2,000 / Power User 5,000),
    // AI credits and the plus-gated data features. A catalogue entry is an
    // upgrade modal, so a free feature must not have one (the same rule that
    // removed '13f' above). It had no caller: no showPremiumGate('api') and no
    // tier-gate.ts _FEATURE_BY_PREFIX mapping.
    'transcripts': {
        name: 'Earnings Call Transcripts',
        desc: 'Full transcripts of quarterly earnings calls with keyword search across every quarter. Read what management said, when, and find patterns across years.',
        tier: 'plus',
        icon: '●',
        learnMore: [
            { label: 'SEC earnings filings', url: 'https://www.sec.gov/edgar/searchedgar/companysearch' },
            { label: 'Seeking Alpha transcripts (free, limited)', url: 'https://seekingalpha.com/earnings/earnings-call-transcripts' },
        ],
    },
    'options': {
        name: 'Options Chain & Flow',
        desc: 'Full options chain with implied volatility, open interest, and volume. Track unusual options activity and multi-expiry flow across the curve.',
        tier: 'plus',
        icon: '◇',
        learnMore: [
            { label: 'Cboe Options Institute', url: 'https://www.cboe.com/optionsinstitute/' },
            { label: 'OCC volume & open interest', url: 'https://www.theocc.com/market-data/market-data-reports' },
        ],
    },
    // M1-1 FE follow-on (2026-05-27): catalogue entry for the CSV
    // portfolio uploader. Backend ratified Plus tier in
    // routes/routes_portfolio_fastapi/broker_sync.py
    // (`require_min_tier("plus")` on both /api/portfolio/import-csv
    // and /api/portfolio/import-csv/commit). The csv-import.ts module
    // calls showPremiumGate('csv-import') for free-tier users; without
    // this catalogue entry the call returns false and the fallback
    // route to /pricing#plus fires.
    //
    // Audience framing: lifelong students and investors (FOUNDATIONAL
    // audience_framing). No M1-by-name in user-facing copy per W3
    // OWNER default #4 — "M1 Finance, Fidelity, Schwab, others" lives
    // in the in-app drop-zone description, not in the marketing pitch.
    'csv-import': {
        name: 'Import portfolio from CSV',
        desc: 'Bulk-add up to 500 positions from a CSV export from your brokerage. Saves a manual entry session and gets your holdings into Oxford Ledge in seconds.',
        tier: 'plus',
        icon: '⇪',
        learnMore: [
            { label: 'How to export a CSV from your broker', url: '/learn/' },
        ],
    },
};
// >>> OL-PREMIUM-RESOLVER (executed under node by
// tests/test_premium_gate_keys_resolve_contract.py -- keep this block free of
// DOM reads).
//
// P1-16 (external review 2026-09-26, revenue): showPremiumGate used to return
// false for any id missing from PREMIUM_FEATURES, and almost no caller checked
// the return, so the upgrade click did nothing. The ids the app actually passes
// include keys that were never catalogue entries: the consolidated and session
// banners' `paywall_consolidated_<tier>` / `paywall_session_<tier>`, the BDC
// CTAs' `paywall_bdc*`, the credit view's `credit-refi-wall`, Settings'
// `billing`, the 13F change tracker's `institutional-holders-changes`. They
// resolve HERE, in one place, so every caller opens a real overlay.
//
// The generic entries are NOT in PREMIUM_FEATURES on purpose: that catalogue
// is cross-validated against backend-gated routes
// (tests/test_premium_gate_anon_routes_contract.py) and read by tier-preview
// as "this feature is gated", which a plan-level entry is not.
// The plan-level overlay is about Oxford Ledge itself, not one feature, so its
// icon slot shows the brand mark. It used to be the '■' glyph, which renders as a
// flat 36px square and reads as a broken logo (OWNER, 2026-09-28). The pair is
// the header's: CSS in oxford-dashboard.css shows the light variant under
// [data-theme="light"], so no DOM read happens here (this block runs under node).
const _PREMIUM_BRAND_MARK = '<img class="ol-brand-mark--dark pg-gate-brand-mark" src="/static/img/brand-v2/favicon-dark.svg" alt="" width="36" height="36">'
    + '<img class="ol-brand-mark--light pg-gate-brand-mark" src="/static/img/brand-v2/favicon-light.svg" alt="" width="36" height="36" hidden>';
const _PREMIUM_GENERIC_BY_TIER = {
    plus: {
        name: 'What this plan includes',
        desc: 'Bond and credit research, private credit (BDC) portfolios, the stock screener, options data, earnings call transcripts and portfolio analytics.',
        tier: 'plus',
        icon: _PREMIUM_BRAND_MARK,
    },
    pro: {
        name: 'What this plan includes',
        desc: 'Current market figures in lesson calculators and a larger monthly AI credit allowance, plus everything in the plan below it.',
        tier: 'pro',
        icon: _PREMIUM_BRAND_MARK,
    },
    professional: {
        name: 'What this plan includes',
        desc: 'The Portfolio Practicum with AI coaching and the largest monthly AI credit allowance, plus everything in the plans below it.',
        tier: 'professional',
        icon: _PREMIUM_BRAND_MARK,
    },
};
// id -> catalogue key, or 'generic:<tier>' for a plan-level overlay.
const _PREMIUM_ALIASES = {
    'credit-refi-wall': 'credit',
    'billing': 'generic:plus',
    'institutional-holders-changes': 'generic:plus',
};
function _premiumTierKey(tier) {
    const t = String(tier || '').toLowerCase().replace(/_trial$/, '');
    if (t === 'pro-ai')
        return 'professional';
    return Object.prototype.hasOwnProperty.call(_PREMIUM_GENERIC_BY_TIER, t) ? t : 'plus';
}
// The catalogue key (or 'generic:<tier>') and entry an id opens, or null when
// nothing matches. Own-property reads only: a bare `PREMIUM_FEATURES[id]`
// answered 'constructor' with Object's constructor.
function _resolvePremiumFeature(featureId) {
    const id = String(featureId || '');
    const own = function (o, k) {
        return Object.prototype.hasOwnProperty.call(o, k);
    };
    if (own(PREMIUM_FEATURES, id))
        return { key: id, feature: PREMIUM_FEATURES[id] };
    let alias = own(_PREMIUM_ALIASES, id) ? _PREMIUM_ALIASES[id] : '';
    if (!alias) {
        const m = /^paywall_(?:consolidated|session)_([a-z_-]+)$/.exec(id);
        if (m)
            alias = 'generic:' + _premiumTierKey(m[1]);
        else if (/^paywall_bdc(?:_[a-z_]+)?$/.test(id))
            alias = 'bdc';
    }
    if (alias.indexOf('generic:') === 0) {
        const t = _premiumTierKey(alias.slice('generic:'.length));
        return { key: 'generic:' + t, feature: _PREMIUM_GENERIC_BY_TIER[t] };
    }
    if (alias && own(PREMIUM_FEATURES, alias))
        return { key: alias, feature: PREMIUM_FEATURES[alias] };
    return null;
}
// The control that opened the gate; closePremiumGate returns focus to it.
let _pgReturnFocus = null;
// Kept boolean for every existing caller (csv-import, checkPremiumAccess):
// true only when the overlay opened.
function showPremiumGate(featureId) {
    return showPremiumGateResult(featureId) === 'shown';
}
function showPremiumGateResult(featureId) {
    const resolved = _resolvePremiumFeature(featureId);
    if (!resolved)
        return 'unknown';
    const feature = resolved.feature;
    const w = window;
    const tc = (typeof w._getTierConfig === 'function' ? w._getTierConfig() : {}) || {};
    // Fallback names match tier-lock-chip.ts._TIER_DISPLAY post-Wave 1
    // Q8 rename (2026-05-10): Analyst → Researcher, Investor + AI →    // tier-rename-history: ok
    // Power User. _getTierConfig() (server-driven) still overrides
    // these when available — these are last-resort fallbacks. Sync any
    // future tier-name change here AND in tier-lock-chip.ts +
    // tier-preview.ts simultaneously.
    const tierInfo = {
        plus: { name: (tc.plus && tc.plus.name) || 'Researcher', price: tc.plus ? ('$' + tc.plus.price_mo + '/mo') : '$9/mo', annual: tc.plus ? ('$' + (tc.plus.price_yr || 81) + '/yr') : '$81/yr', color: 'var(--oxford-blue-vivid)' },
        pro: { name: (tc.pro && tc.pro.name) || 'Investor', price: tc.pro ? ('$' + tc.pro.price_mo + '/mo') : '$19/mo', annual: tc.pro ? ('$' + (tc.pro.price_yr || 171) + '/yr') : '$171/yr', color: 'var(--gold-brand)' },
        professional: { name: (tc.professional && tc.professional.name) || 'Power User', price: tc.professional ? ('$' + tc.professional.price_mo + '/mo') : '$29/mo', annual: tc.professional ? ('$' + (tc.professional.price_yr || 261) + '/yr') : '$261/yr', color: 'var(--gold-brand)' },
    };
    const tier = tierInfo[feature.tier] || tierInfo.plus;
    let fotdUnlocked = false;
    if (typeof isFOTDUnlocked === 'function') {
        // F4.2 (SF-23 audit 2026-05-07): '13f' removed from endpoint map
        // alongside the catalogue entry — 13F is anon-OK so FOTD lookup
        // doesn't apply (FOTD is a paywall-bypass for premium endpoints).
        const endpointMap = { 'credit': '/api/credit', 'screener': '/api/screener', 'bdc': '/api/bdc', 'portfolio-analytics': '/api/portfolio-analytics' };
        // Keyed by the RESOLVED catalogue key, so an alias ('paywall_bdc_holdings'
        // -> 'bdc') sees the same Feature of the Day as the key itself.
        fotdUnlocked = isFOTDUnlocked(endpointMap[resolved.key] || '');
    }
    if (fotdUnlocked) {
        if (typeof showToast === 'function') {
            showToast('Free Feature of the Day: ' + feature.name + ' is unlocked today!', 'success', 4000);
        }
        return 'fotd';
    }
    let overlay = document.getElementById('premium-gate-overlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'premium-gate-overlay';
        document.body.appendChild(overlay);
    }
    // QA 2026-10-17: remember the control that opened the gate, so closing it
    // returns focus there instead of dropping it on <body>.
    const _opener = document.activeElement;
    if (_opener && _opener !== document.body && !overlay.contains(_opener))
        _pgReturnFocus = _opener;
    overlay.className = 'pg-gate-overlay pg-gate-banner-mode';
    overlay.onclick = function (e) {
        if (e.target === overlay)
            closePremiumGate();
    };
    let html = '<div class="pg-gate-card pg-gate-card-banner">';
    html += '<button data-pg-action="close" class="pg-gate-close" aria-label="Close">×</button>';
    html += '<div class="pg-gate-feature-header">';
    html += '<div class="pg-gate-feature-icon">' + feature.icon + '</div>';
    html += '<div class="pg-gate-feature-name" id="pg-gate-title">' + feature.name + '</div>';
    html += '</div>';
    html += '<div class="pg-gate-desc">' + feature.desc + '</div>';
    const isAuthenticated = !!(_userTier && _userTier !== 'anonymous');
    html += '<div class="pg-gate-tier-box" data-bc="' + tier.color + '">';
    if (!isAuthenticated) {
        html += '<div class="pg-gate-signup-label">Create a free account</div>';
        // Audit 2026-09-24: read "a 7-day trial of every feature, including
        // <X>". The signup trial is a Researcher ('plus_trial') trial
        // (services/billing/tiers.py start_trial); it does not include an
        // Investor or Power User feature. Name the trial truthfully and only
        // promise the gated feature when the trial actually covers it.
        // A plan-level entry ('generic:<tier>') is named 'What this plan
        // includes', which is not a feature name: appending it read "...trial,
        // which includes What this plan includes." (ticker BOARD cycle
        // 2026-09-28, T1). Name only a real feature.
        const _trialCovers = (feature.tier || 'plus') === 'plus'
            && resolved.key.indexOf('generic:') !== 0;
        html += '<div class="pg-gate-signup-body">A free account includes a 7-day Researcher trial'
            + (_trialCovers ? ', which includes ' + feature.name : '') + '.</div>';
        // MA #49 (2026-07-26): carry the ORIGINATING VIEW through the auth
        // join — a bare /?signup=1 booted post-auth users onto the default
        // view, dropping them away from the gated feature they came for.
        // ?view= routes natively alongside the ?signup=1 modal (existing
        // machinery, no new plumbing); ticker deep-links already carry
        // ?ticker= via the stock-CTA path.
        let _joinHref = '/?signup=1';
        try {
            const _v = new URLSearchParams(window.location.search).get('view');
            if (_v && /^[a-z0-9_-]{1,32}$/i.test(_v))
                _joinHref += '&view=' + encodeURIComponent(_v);
        }
        catch (_e) { /* ok-swallow: URL parsing must never break the gate render */ }
        html += '<a href="' + _joinHref + '" class="btn-primary pg-gate-cta-btn">Create a free account</a>';
        html += '<div class="pg-gate-no-cc">No credit card required</div>';
    }
    else {
        html += '<div class="pg-gate-tier-label" data-fg="' + tier.color + '">Available on ' + tier.name + '</div>';
        html += '<div class="pg-gate-tier-price">' + tier.price + ' <span class="pg-gate-tier-annual">or ' + tier.annual + '</span></div>';
        html += '<a href="/?upgrade=' + encodeURIComponent(feature.tier || 'plus') + '" class="btn-primary pg-gate-upgrade-btn">Upgrade to ' + tier.name + '</a>';
    }
    html += '</div>';
    if (feature.learnMore && feature.learnMore.length > 0) {
        html += '<div class="pg-gate-resources">';
        html += '<div class="pg-gate-resources-label">Free Public Resources</div>';
        let _hasAmazonAffiliate = false;
        feature.learnMore.forEach(function (link) {
            if (link.url && link.url.indexOf('amazon.com') !== -1) {
                _hasAmazonAffiliate = true;
            }
            html += '<a href="' + link.url + '" target="_blank" rel="noopener" class="pg-gate-resource-link">' + link.label + ' →</a>';
        });
        if (_hasAmazonAffiliate) {
            html += '<div class="pg-gate-affiliate-disclaimer">(paid link) As an Amazon Associate, Oxford Ledge earns from qualifying purchases.</div>';
        }
        html += '</div>';
    }
    if (isAuthenticated) {
        // Audit 2026-09-24: read "Start a 7-day free trial of all paid
        // features." No in-app action starts a trial for a signed-in account
        // (the Researcher trial begins at signup), and it never covered every
        // paid tier. State what is true about the upgrade instead: monthly
        // plans are cancelled from the Stripe billing portal (Settings ->
        // Usage & Billing -> Manage subscription).
        html += '<div class="pg-gate-trial-note">Monthly plans can be cancelled anytime from Settings &rarr; Usage &amp; Billing.</div>';
    }
    html += '</div>';
    overlay.innerHTML = html;
    overlay.querySelectorAll('[data-bc]').forEach(function (n) {
        const html = n;
        if (html.dataset.bc)
            html.style.borderColor = html.dataset.bc;
    });
    overlay.querySelectorAll('[data-fg]').forEach(function (n) {
        const html = n;
        if (html.dataset.fg)
            html.style.color = html.dataset.fg;
    });
    // QA 2026-10-17: the overlay is a dialog -- announce it as one, name it by
    // the feature heading, and move focus into it (the close button) so
    // Escape, Tab and screen readers start inside the gate, not on the trigger.
    // NOT aria-modal (CHAOS 2026-10-17): the gate always renders in banner mode
    // (.pg-gate-banner-mode: transparent, pointer-events:none, no blur, no focus
    // trap), so the page behind stays live and clickable. aria-modal="true"
    // tells a screen reader that page is inert and hides it from the virtual
    // cursor while a sighted user can still click it.
    overlay.setAttribute('role', 'dialog');
    overlay.removeAttribute('aria-modal');
    overlay.setAttribute('aria-labelledby', 'pg-gate-title');
    const _first = overlay.querySelector('.pg-gate-close');
    if (_first && typeof _first.focus === 'function') {
        try {
            _first.focus();
        }
        catch (_e) { /* ok-swallow: focus is best-effort */ }
    }
    return 'shown';
}
// For click handlers in other chunks: open the overlay, or -- when nothing
// matches -- go to /pricing. Never redirects on the Feature-of-the-Day path.
function openPremiumGateOrPricing(featureId) {
    if (showPremiumGateResult(featureId) === 'unknown')
        window.location.href = '/pricing';
}
void openPremiumGateOrPricing;
function closePremiumGate() {
    const overlay = document.getElementById('premium-gate-overlay');
    if (overlay)
        overlay.classList.add('hidden');
    const viewContent = document.getElementById('main') || document.querySelector('.view-panel.active');
    if (viewContent)
        viewContent.classList.remove('pg-gate-blurred');
    const back = _pgReturnFocus;
    _pgReturnFocus = null;
    if (back && typeof back.focus === 'function' && document.body && document.body.contains(back)) {
        try {
            back.focus();
        }
        catch (_e) { /* ok-swallow: focus is best-effort */ }
    }
}
// True unless another surface sits over the gate card's centre (a drawer or
// modal opened after the gate, above it in the z ladder). The overlay itself is
// pointer-events:none in banner mode, so the CARD is what elementFromPoint can
// hit. No layout (zero rect, no elementFromPoint): treat the gate as topmost.
function _pgGateIsTopmost(overlay) {
    try {
        const card = overlay.querySelector('.pg-gate-card');
        if (!card || typeof document.elementFromPoint !== 'function' || typeof card.getBoundingClientRect !== 'function')
            return true;
        const r = card.getBoundingClientRect();
        if (!r || !r.width || !r.height)
            return true;
        const hit = document.elementFromPoint(r.left + r.width / 2, r.top + r.height / 2);
        return !hit || overlay.contains(hit);
    }
    catch (_e) {
        return true; /* ok-swallow: geometry is best-effort; default to closing the gate */
    }
}
// Escape closes the gate. Registered at module load (QA 2026-10-17): it used to
// sit inside window.initPremiumGate, which nothing ever called, so Escape did
// nothing on prod. Idempotent, like the click delegation below.
// CHAOS 2026-10-17: on WINDOW in the CAPTURE phase, and the key is spent
// (stopImmediatePropagation + preventDefault). The gate is raised OVER the
// surface the user was on (tier-gate's 402 interceptor fires from Ask AI, the
// compare modal, the comps builder ...). A bubble listener on document ran
// AFTER the central Escape chain, which closed that surface first -- one key,
// two surfaces -- and never ran at all under the Ask AI panel's capture-phase
// handler, which closed the panel beneath the gate and left the gate open.
// Same precedent as the Ask AI drawers (ask-ai-provenance.ts _askAiDrawerKeys).
// docs/board/audit/2026-10-17_CHAOS_screener_cache_preset_gate.md
let _pgEscapeInstalled = false;
function _pgInstallEscape() {
    if (_pgEscapeInstalled)
        return;
    _pgEscapeInstalled = true;
    window.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape')
            return;
        const overlay = document.getElementById('premium-gate-overlay');
        if (!overlay || overlay.classList.contains('hidden'))
            return;
        if (!_pgGateIsTopmost(overlay))
            return;
        e.preventDefault();
        e.stopImmediatePropagation();
        closePremiumGate();
    }, true);
}
_pgInstallEscape();
function checkPremiumAccess(view) {
    const viewToFeature = {
        'screener': 'screener',
        'portfolio-analytics': 'portfolio-analytics',
    };
    const featureId = viewToFeature[view];
    if (!featureId)
        return false;
    const tier = typeof _userTier !== 'undefined' ? _userTier : 'free';
    if (tier !== 'free')
        return false;
    if (typeof isFOTDUnlocked === 'function') {
        const endpointMap = { 'screener': '/api/screener', 'portfolio-analytics': '/api/portfolio-analytics' };
        if (isFOTDUnlocked(endpointMap[featureId] || ''))
            return false;
    }
    return showPremiumGate(featureId);
}
void checkPremiumAccess;
// CSP-clean delegation (CYCLE5 #49, 2026-05-05). 1 inline onclick.
let _pgDelegationInstalled = false;
function _pgInstallDelegation() {
    if (_pgDelegationInstalled)
        return;
    _pgDelegationInstalled = true;
    document.addEventListener('click', function (ev) {
        const tgt = ev.target;
        if (!tgt || !tgt.closest)
            return;
        if (tgt.closest('[data-pg-action="close"]'))
            closePremiumGate();
    });
}
_pgInstallDelegation();
//# sourceMappingURL=premium-gate.js.map
;
// ═══ tier-preview.js ═══
;"use strict";
/**
 * TierPreview — hover/focus tooltip for tier-gated entry points.
 *
 * TS Migration Phase 2 PR 30 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is the SOURCE OF TRUTH; tier-preview.js is the build
 * artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
 *
 * Adds an Oxford-brand tooltip with feature name, 1-2 line description,
 * tier + price, and a "See more" affordance that delegates to
 * showPremiumGate. UX-only — backend require_min_tier still enforces.
 */
(function () {
    'use strict';
    if (typeof document === 'undefined')
        return;
    const ATTR = 'data-tier-preview';
    const ATTACHED_KEY = '_olTierPreviewAttached';
    const TOOLTIP_ID = 'ol-tier-preview-tooltip';
    const SHOW_DELAY_MS = 250;
    const HIDE_DELAY_MS = 120;
    let _showTimer = null;
    let _hideTimer = null;
    let _activeEl = null;
    let _activeFeatureId = null;
    function _getTier() {
        const w = window;
        return (typeof w._userTier === 'string' && w._userTier) || 'anonymous';
    }
    function _hasTierMet(required) {
        const rank = { anonymous: 0, free: 0, plus_trial: 1, plus: 1, pro_trial: 2, pro: 2, professional_trial: 3, professional: 3 };
        return (rank[_getTier()] || 0) >= (rank[required] || 0);
    }
    function _getFeature(featureId) {
        const w = window;
        if (typeof w.PREMIUM_FEATURES !== 'object' || !w.PREMIUM_FEATURES)
            return null;
        return w.PREMIUM_FEATURES[featureId] || null;
    }
    function _tierDisplay(tierKey) {
        // 2026-05-11 reconciliation: post-Wave-1 Q8 rename. Names must
        // match tier-lock-chip.ts._TIER_DISPLAY + premium-gate.ts.tierInfo
        // canonical map. Source of truth for any new tier-name surface is
        // tier-lock-chip.ts._TIER_DISPLAY.
        const map = { free: 'Learner', plus: 'Researcher', pro: 'Investor', professional: 'Power User' };
        return map[tierKey] || (tierKey.charAt(0).toUpperCase() + tierKey.slice(1));
    }
    function _tierPrice(tierKey) {
        const fallback = { plus: '$9/mo', pro: '$19/mo', professional: '$29/mo' };
        try {
            const w = window;
            if (typeof w._getTierConfig === 'function') {
                const tc = w._getTierConfig();
                if (tc && tc[tierKey] && tc[tierKey].price_mo)
                    return '$' + tc[tierKey].price_mo + '/mo';
            }
        }
        catch (_e) { }
        return fallback[tierKey] || '';
    }
    function _ensureTooltip() {
        let tip = document.getElementById(TOOLTIP_ID);
        if (tip)
            return tip;
        tip = document.createElement('div');
        tip.id = TOOLTIP_ID;
        tip.className = 'ol-tier-preview';
        tip.setAttribute('role', 'tooltip');
        tip.setAttribute('aria-hidden', 'true');
        document.body.appendChild(tip);
        tip.addEventListener('mouseenter', function () {
            if (_hideTimer) {
                clearTimeout(_hideTimer);
                _hideTimer = null;
            }
        });
        tip.addEventListener('mouseleave', _scheduleHide);
        return tip;
    }
    function _populate(tip, featureId, feature) {
        const iconHtml = feature.icon ? '<span class="ol-tip-icon" aria-hidden="true">' + feature.icon + '</span>' : '';
        const tierKey = feature.tier || 'plus';
        const price = _tierPrice(tierKey);
        const tierName = _tierDisplay(tierKey);
        tip.innerHTML = '<div class="ol-tip-head">'
            + iconHtml
            + '<span class="ol-tip-title"></span>'
            + '</div>'
            + '<div class="ol-tip-desc"></div>'
            + '<div class="ol-tip-foot">'
            + '<span class="ol-tip-tier"></span>'
            + '<span class="ol-tip-cta">See what\u2019s included →</span>'
            + '</div>';
        const titleEl = tip.querySelector('.ol-tip-title');
        if (titleEl)
            titleEl.textContent = feature.name || featureId;
        const descEl = tip.querySelector('.ol-tip-desc');
        if (descEl)
            descEl.textContent = feature.desc || '';
        const tierEl = tip.querySelector('.ol-tip-tier');
        if (tierEl)
            tierEl.textContent = tierName + (price ? ' — ' + price : '');
    }
    function _position(tip, anchor) {
        const rect = anchor.getBoundingClientRect();
        const tipH = tip.offsetHeight || 120;
        const tipW = tip.offsetWidth || 280;
        const vw = window.innerWidth || document.documentElement.clientWidth;
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const pad = 8;
        let top = rect.bottom + pad;
        if (top + tipH > vh - pad)
            top = Math.max(pad, rect.top - tipH - pad);
        let left = rect.left + (rect.width / 2) - (tipW / 2);
        left = Math.max(pad, Math.min(left, vw - tipW - pad));
        tip.style.top = (top + window.scrollY) + 'px';
        tip.style.left = (left + window.scrollX) + 'px';
    }
    function _show(el, featureId) {
        const feature = _getFeature(featureId);
        if (!feature)
            return;
        const tip = _ensureTooltip();
        _populate(tip, featureId, feature);
        tip.classList.add('open');
        tip.setAttribute('aria-hidden', 'false');
        _position(tip, el);
        _activeEl = el;
        _activeFeatureId = featureId;
        void _activeEl;
        void _activeFeatureId;
        try {
            if (typeof _track === 'function') {
                _track('tier_preview_shown', { featureId: featureId, currentTier: _getTier() });
            }
        }
        catch (_e) { }
    }
    function _hide() {
        const tip = document.getElementById(TOOLTIP_ID);
        if (!tip)
            return;
        tip.classList.remove('open');
        tip.setAttribute('aria-hidden', 'true');
        _activeEl = null;
        _activeFeatureId = null;
    }
    function _scheduleShow(el, featureId) {
        if (_showTimer)
            clearTimeout(_showTimer);
        if (_hideTimer) {
            clearTimeout(_hideTimer);
            _hideTimer = null;
        }
        _showTimer = setTimeout(function () { _show(el, featureId); }, SHOW_DELAY_MS);
    }
    function _scheduleHide() {
        if (_showTimer) {
            clearTimeout(_showTimer);
            _showTimer = null;
        }
        if (_hideTimer)
            clearTimeout(_hideTimer);
        _hideTimer = setTimeout(_hide, HIDE_DELAY_MS);
    }
    function _onClick(e) {
        const target = e.target;
        if (!target || !target.closest)
            return;
        const el = target.closest('[' + ATTR + ']');
        if (!el)
            return;
        const featureId = el.getAttribute(ATTR);
        if (!featureId)
            return;
        const feature = _getFeature(featureId);
        if (!feature)
            return;
        if (_hasTierMet(feature.tier || 'plus'))
            return;
        e.preventDefault();
        e.stopPropagation();
        _hide();
        const w = window;
        if (typeof w.showPremiumGate === 'function') {
            w.showPremiumGate(featureId);
        }
        else {
            window.location.href = '/?upgrade=' + encodeURIComponent((feature && feature.tier) || 'plus');
        }
        try {
            if (typeof _track === 'function') {
                _track('tier_preview_click', { featureId: featureId, currentTier: _getTier() });
            }
        }
        catch (_e) { }
    }
    function _attachOne(el) {
        if (el[ATTACHED_KEY])
            return;
        el[ATTACHED_KEY] = true;
        const featureId = el.getAttribute(ATTR);
        if (!featureId)
            return;
        const feature = _getFeature(featureId);
        if (!feature)
            return;
        if (_hasTierMet(feature.tier || 'plus')) {
            el.removeAttribute(ATTR);
            return;
        }
        el.addEventListener('mouseenter', function () { _scheduleShow(el, featureId); });
        el.addEventListener('mouseleave', _scheduleHide);
        el.addEventListener('focus', function () { _scheduleShow(el, featureId); });
        el.addEventListener('blur', _scheduleHide);
        el.classList.add('ol-tier-gated-cta');
    }
    function scan(root) {
        const scope = root || document;
        const nodes = scope.querySelectorAll('[' + ATTR + ']');
        for (let i = 0; i < nodes.length; i++)
            _attachOne(nodes[i]);
    }
    window.addEventListener('ol-tier-changed', function () {
        const nodes = document.querySelectorAll('[' + ATTR + ']');
        for (let i = 0; i < nodes.length; i++) {
            nodes[i][ATTACHED_KEY] = false;
        }
        scan();
    });
    document.addEventListener('click', _onClick, true);
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { scan(); });
    }
    else {
        scan();
    }
    window.TierPreview = {
        scan: scan,
        show: _show,
        hide: _hide,
    };
})();
//# sourceMappingURL=tier-preview.js.map
;
// ═══ smart-insights.js ═══
;"use strict";
// ── smart-insights.js ────────────────────────────────────────────────────
//
// TS Migration Phase 2 PR 37 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; smart-insights.js is the build
// artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
//
// Smart Insights — shows ONE data-backed insight per ticker, rotated
// daily. Also handles breathing whitespace: hides empty sections,
// collapses empty metric rows.
window.initSmartInsights = function () {
    'use strict';
    // 2026-09-26 (external review P0-1): renderData() calls this on EVERY render.
    // Without a one-shot guard each call built a fresh closure -- its own cache,
    // timers and six MutationObservers on persistent nodes -- so N renders meant
    // N copies, each re-fetching /api/company-financials per ticker switch and
    // each re-arming applyBreathingWhitespace on every mutation. One instance is
    // enough: its #company-name observer already follows ticker changes.
    const _siWin = window;
    if (_siWin.__olSmartInsightsInited)
        return;
    _siWin.__olSmartInsightsInited = true;
    const _insightCache = {};
    let _currentInsightTicker = null;
    let _siTimers = [];
    function dailySeed(ticker) {
        const d = new Date();
        const dayNum = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
        let hash = 0;
        const str = ticker + ':' + dayNum;
        for (let i = 0; i < str.length; i++) {
            hash = ((hash << 5) - hash) + str.charCodeAt(i);
            hash |= 0;
        }
        return Math.abs(hash);
    }
    function fmtDollar(val) {
        if (val == null)
            return null; // caller checks === null; keep the sentinel
        return fmtAbbrev(val); // DS-P2a: canonical $ K/M/B (sign + rollup)
    }
    function fmtPctOrNull(val, decimals) {
        if (val == null)
            return null; // callers branch on null; the global fmtPct owns the digits
        return fmtPct(val, decimals != null ? decimals : 1);
    }
    function generateInsightPool(data) {
        const pool = [];
        const annual = data.annual || [];
        if (annual.length < 1)
            return pool;
        const latest = annual[0];
        const prev = annual.length > 1 ? annual[1] : null;
        const entity = data.entity || data.ticker;
        let shortName = entity.split(/[,.]| Inc| Corp| Ltd| LLC| Group| Holdings/)[0].trim();
        if (shortName.length > 20)
            shortName = data.ticker;
        if (latest.revenue && prev && prev.revenue && prev.revenue > 0) {
            const revGrowth = ((latest.revenue - prev.revenue) / Math.abs(prev.revenue)) * 100;
            if (Math.abs(revGrowth) > 0.5) {
                const direction = revGrowth > 0 ? 'grew' : 'declined';
                let consecutiveGrowth = 0;
                for (let i = 0; i < annual.length - 1; i++) {
                    const a = annual[i].revenue;
                    const b = annual[i + 1].revenue;
                    if (a != null && b != null && a > b) {
                        consecutiveGrowth++;
                    }
                    else
                        break;
                }
                const suffix = consecutiveGrowth >= 3 ? ' — ' + consecutiveGrowth + ' consecutive years of growth' : '';
                pool.push({
                    text: shortName + "'s revenue " + direction + ' ' + fmtPctOrNull(Math.abs(revGrowth)) + ' to ' + fmtDollar(latest.revenue) + suffix,
                    metric: 'revenue_growth',
                    confidence: 'high',
                });
            }
        }
        if (latest.gross_margin_pct != null) {
            const gm = latest.gross_margin_pct;
            let isHighest = true;
            for (let i = 1; i < annual.length; i++) {
                if (annual[i].gross_margin_pct != null && annual[i].gross_margin_pct >= gm) {
                    isHighest = false;
                    break;
                }
            }
            if (isHighest && annual.length >= 3) {
                pool.push({
                    text: shortName + "'s gross margin hit " + fmtPctOrNull(gm) + ' — highest in ' + annual.length + '-year history',
                    metric: 'gross_margin',
                    confidence: 'high',
                });
            }
            else if (gm > 50) {
                pool.push({
                    text: shortName + ' earns ' + fmtPctOrNull(gm) + ' gross margin — keeping over half of every dollar of revenue',
                    metric: 'gross_margin',
                    confidence: 'medium',
                });
            }
        }
        if (latest.free_cash_flow && latest.free_cash_flow > 0) {
            pool.push({
                text: shortName + ' generated ' + fmtDollar(latest.free_cash_flow) + ' in free cash flow in FY' + latest.fiscal_year,
                metric: 'fcf',
                confidence: 'high',
            });
        }
        if (latest.net_margin_pct != null) {
            const nm = latest.net_margin_pct;
            if (nm > 20) {
                pool.push({
                    text: shortName + ' converts ' + fmtPctOrNull(nm) + ' of revenue to profit — well above the S&P 500 median of ~10%',
                    metric: 'net_margin',
                    confidence: 'high',
                });
            }
            else if (nm > 0 && nm < 5) {
                pool.push({
                    text: shortName + ' operates on thin ' + fmtPctOrNull(nm) + ' net margins — typical of its industry',
                    metric: 'net_margin',
                    confidence: 'medium',
                });
            }
        }
        if (annual.length >= 3) {
            const latestEPS = latest.eps_diluted;
            const oldestEPS = annual[annual.length - 1].eps_diluted;
            const yearsSpan = latest.fiscal_year - annual[annual.length - 1].fiscal_year;
            if (latestEPS && oldestEPS && oldestEPS > 0 && latestEPS > 0 && yearsSpan > 0) {
                const cagr = (Math.pow(latestEPS / oldestEPS, 1 / yearsSpan) - 1) * 100;
                if (cagr > 3) {
                    pool.push({
                        text: 'EPS grew from $' + oldestEPS.toFixed(2) + ' to $' + latestEPS.toFixed(2) + ' over ' + yearsSpan + ' years — a ' + fmtPctOrNull(cagr) + ' CAGR',
                        metric: 'eps_cagr',
                        confidence: 'high',
                    });
                }
            }
        }
        if (latest.buybacks && Math.abs(latest.buybacks) > 0) {
            const buybackAmt = Math.abs(latest.buybacks);
            if (prev && prev.shares_diluted && latest.shares_diluted && prev.shares_diluted > latest.shares_diluted) {
                const reduction = ((prev.shares_diluted - latest.shares_diluted) / prev.shares_diluted) * 100;
                pool.push({
                    text: shortName + ' spent ' + fmtDollar(buybackAmt) + ' on buybacks — reducing share count by ' + fmtPctOrNull(reduction),
                    metric: 'buybacks',
                    confidence: 'high',
                });
            }
            else if (buybackAmt > 1e9) {
                pool.push({
                    text: shortName + ' returned ' + fmtDollar(buybackAmt) + ' to shareholders via buybacks in FY' + latest.fiscal_year,
                    metric: 'buybacks',
                    confidence: 'medium',
                });
            }
        }
        if (latest.roe_pct != null) {
            const roe = latest.roe_pct;
            if (roe > 40) {
                pool.push({
                    text: 'Return on equity of ' + fmtPctOrNull(roe, 0) + ' — well above the S&P 500 average of ~15%',
                    metric: 'roe',
                    confidence: 'high',
                });
            }
        }
        if (latest.total_liabilities != null && latest.stockholders_equity != null && latest.stockholders_equity > 0) {
            const de = latest.total_liabilities / latest.stockholders_equity;
            if (prev && prev.total_liabilities != null && prev.stockholders_equity != null && prev.stockholders_equity > 0) {
                const prevDE = prev.total_liabilities / prev.stockholders_equity;
                if (de < prevDE && prevDE - de > 0.1) {
                    pool.push({
                        text: shortName + "'s leverage improved from " + prevDE.toFixed(2) + 'x to ' + de.toFixed(2) + 'x debt-to-equity',
                        metric: 'leverage',
                        confidence: 'high',
                    });
                }
            }
            if (de < 0.5) {
                pool.push({
                    text: shortName + ' carries minimal debt at ' + de.toFixed(2) + 'x debt-to-equity — below the S&P 500 median of ~1.2x debt-to-equity',
                    metric: 'leverage',
                    confidence: 'medium',
                });
            }
        }
        if (latest.operating_cash_flow && latest.net_income && latest.net_income > 0) {
            const ratio = latest.operating_cash_flow / latest.net_income;
            if (ratio > 1.3) {
                pool.push({
                    text: 'Operating cash flow of ' + fmtDollar(latest.operating_cash_flow) + ' exceeds net income by ' + Math.round((ratio - 1) * 100) + '% — a sign of cash-based rather than accrual-based earnings',
                    metric: 'cash_quality',
                    confidence: 'high',
                });
            }
        }
        if (latest.rd_expense && latest.revenue && latest.revenue > 0) {
            const rdPct = (latest.rd_expense / latest.revenue) * 100;
            if (rdPct > 10) {
                pool.push({
                    text: shortName + ' invests ' + fmtPctOrNull(rdPct) + ' of revenue in R&D (' + fmtDollar(latest.rd_expense) + ') — a significant innovation bet',
                    metric: 'rd_intensity',
                    confidence: 'high',
                });
            }
        }
        if (annual.length >= 4) {
            const latestRev = latest.revenue;
            const oldestRev = annual[annual.length - 1].revenue;
            const yrs = latest.fiscal_year - annual[annual.length - 1].fiscal_year;
            if (latestRev && oldestRev && oldestRev > 0 && yrs > 0) {
                const revCAGR = (Math.pow(latestRev / oldestRev, 1 / yrs) - 1) * 100;
                if (revCAGR > 5) {
                    pool.push({
                        text: 'Revenue compounded at ' + fmtPctOrNull(revCAGR) + ' annually over ' + yrs + ' years, from ' + fmtDollar(oldestRev) + ' to ' + fmtDollar(latestRev),
                        metric: 'revenue_cagr',
                        confidence: 'high',
                    });
                }
            }
        }
        return pool;
    }
    function pickInsight(ticker, pool) {
        if (!pool || pool.length === 0)
            return null;
        const seed = dailySeed(ticker);
        return pool[seed % pool.length];
    }
    function renderInsightCard(ticker, insight) {
        // RETIRED 2026-06-04 (OWNER prod-QA #141): the per-ticker smart-insight
        // card was removed — OWNER found it "out of place" at the bottom of the
        // ticker view, and it rendered a light-bulb emoji glyph (Brand v2
        // no-emoji foundational rule). This is now a no-op that removes any
        // stray card; the upstream insight computation (generateInsightPool /
        // pickInsight, still called by showSmartInsight) is retained but
        // UNRENDERED so the bundle entry + #company-name observer wiring stay
        // valid. The prior render implementation (incl. the emoji line) is in
        // git history if a dedicated insight surface is ever reinstated.
        void ticker;
        void insight;
        const card = document.getElementById('smart-insight-card');
        if (card)
            card.remove();
    }
    function escapeHtml(str) {
        if (!str)
            return '';
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    async function showSmartInsight(ticker) {
        if (!ticker)
            return;
        ticker = ticker.toUpperCase().trim();
        if (_currentInsightTicker === ticker)
            return;
        _currentInsightTicker = ticker;
        // #102 (2026-06-03 OWNER prod-QA): ETFs have no company-financials, so the
        // fetch below 404s for every ETF (ARKF/ARKG/...). This path fires on the
        // #company-name MutationObserver (onTickerChange), not user action, so the
        // 404 was swallowed (hideInsightCard on !res.ok) but still spammed the
        // console/Network tab on every ETF open. _currentIsETF is set by
        // renderData (ticker-renderer.ts:536) BEFORE the #company-name mutation
        // that drives this observer, so it is reliably current here.
        if (window._currentIsETF) {
            hideInsightCard();
            return;
        }
        if (_insightCache[ticker]) {
            renderInsightCard(ticker, _insightCache[ticker]);
            return;
        }
        try {
            const server = typeof SERVER !== 'undefined' ? SERVER : '';
            const res = await fetch(server + '/api/company-financials?ticker=' + encodeURIComponent(ticker), { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(15000) : AbortSignal.timeout(15000)) });
            if (!res.ok) {
                hideInsightCard();
                return;
            }
            const data = await res.json();
            if (!data || data.error || !data.annual || data.annual.length === 0) {
                hideInsightCard();
                return;
            }
            const pool = generateInsightPool(data);
            const insight = pickInsight(ticker, pool);
            if (insight) {
                _insightCache[ticker] = insight;
                if (_currentInsightTicker === ticker) {
                    renderInsightCard(ticker, insight);
                }
            }
            else {
                hideInsightCard();
            }
        }
        catch (_e) {
            hideInsightCard();
        }
    }
    function hideInsightCard() {
        const card = document.getElementById('smart-insight-card');
        if (card)
            card.classList.add('hidden');
    }
    function isEffectivelyEmpty(el) {
        if (!el)
            return true;
        const text = el.textContent || '';
        const vals = el.querySelectorAll('.hero-stat-val, .div-row, .analyst-cell, td, .metric-val, [data-value]');
        if (vals.length === 0) {
            const cleaned = text.replace(/[^a-zA-Z0-9$.%]/g, ' ').trim();
            return !cleaned || /^(No\s+\w+\s+data|N\/A|\s)*$/i.test(cleaned);
        }
        let allEmpty = true;
        for (let i = 0; i < vals.length; i++) {
            const v = (vals[i].textContent || '').trim();
            if (v && v !== '—' && v !== '-' && v !== '--' && v !== 'N/A') {
                allEmpty = false;
                break;
            }
        }
        return allEmpty;
    }
    const SECTION_CHECKS = [
        { id: 'credit-metrics-section', label: 'Credit Metrics' },
        { contentId: 'dividend-rows', label: 'Dividends' },
        { contentId: 'analyst-bar', label: 'Analyst' },
        { contentId: 'short-info', label: 'Short Interest' },
        { contentId: 'insider-activity', label: 'Insider Transactions (Form 4)' },
    ];
    function applyBreathingWhitespace() {
        SECTION_CHECKS.forEach(function (check) {
            let contentEl = null;
            let sectionEl = null;
            if (check.id) {
                sectionEl = document.getElementById(check.id);
                contentEl = sectionEl;
            }
            else if (check.contentId) {
                contentEl = document.getElementById(check.contentId);
                sectionEl = contentEl;
                while (sectionEl && !sectionEl.classList.contains('data-section')) {
                    sectionEl = sectionEl.parentElement;
                }
            }
            if (!sectionEl || !contentEl)
                return;
            const empty = isEffectivelyEmpty(contentEl);
            if (empty) {
                if (!sectionEl.classList.contains('section-empty')) {
                    sectionEl.classList.add('section-empty');
                }
            }
            else {
                if (sectionEl.classList.contains('section-empty')) {
                    sectionEl.classList.remove('section-empty');
                    sectionEl.classList.add('section-reveal');
                    const sec = sectionEl;
                    _siTimers.push(setTimeout(function () { sec.classList.remove('section-reveal'); }, 400));
                }
            }
        });
        compactEmptyMetricRows();
    }
    function compactEmptyMetricRows() {
        const metricsEl = document.getElementById('metrics-rows');
        if (!metricsEl)
            return;
        const rows = metricsEl.querySelectorAll('.metric-row, .kv-row');
        if (rows.length === 0)
            return;
        let emptyRun = [];
        const runs = [];
        for (let i = 0; i < rows.length; i++) {
            const valEl = rows[i].querySelector('.metric-val, .kv-val, td:last-child');
            const valText = valEl ? (valEl.textContent || '').trim() : '';
            const isEmpty = !valText || valText === '—' || valText === '-' || valText === '--' || valText === 'N/A';
            if (isEmpty) {
                emptyRun.push(rows[i]);
            }
            else {
                if (emptyRun.length >= 3) {
                    runs.push(emptyRun.slice());
                }
                emptyRun = [];
            }
        }
        if (emptyRun.length >= 3) {
            runs.push(emptyRun.slice());
        }
        // 2026-09-26 (external review P0-1): #metrics-rows is observed (childList,
        // subtree) and a mutation re-schedules applyBreathingWhitespace -> here. The
        // hidden rows keep their '—' text, so the same runs are found every pass;
        // unconditionally removing + re-inserting the notices re-fired the observer
        // and looped every 200ms for as long as a run of 3+ existed (any ETF). Only
        // touch the DOM when the notices on the page differ from the ones wanted.
        const existing = metricsEl.querySelectorAll('.metrics-collapsed-notice');
        let unchanged = existing.length === runs.length;
        for (let r = 0; unchanged && r < runs.length; r++) {
            const ex = existing[r];
            const run = runs[r];
            unchanged = ex.previousElementSibling === run[run.length - 1]
                && ex.textContent === run.length + ' additional metrics available with more data';
        }
        if (unchanged) {
            runs.forEach(function (run) {
                run.forEach(function (row) { row.classList.add('hidden'); });
            });
            return;
        }
        for (let e = 0; e < existing.length; e++) {
            const ex = existing[e];
            if (ex.parentNode)
                ex.parentNode.removeChild(ex);
        }
        runs.forEach(function (run) {
            const count = run.length;
            run.forEach(function (row) { row.classList.add('hidden'); });
            const notice = document.createElement('div');
            notice.className = 'metrics-collapsed-notice';
            notice.textContent = count + ' additional metrics available with more data';
            notice.title = 'These metrics will appear when data is available';
            const lastRow = run[run.length - 1];
            if (lastRow.parentNode) {
                if (lastRow.nextSibling) {
                    lastRow.parentNode.insertBefore(notice, lastRow.nextSibling);
                }
                else {
                    lastRow.parentNode.appendChild(notice);
                }
            }
        });
    }
    let _lastObservedTicker = '';
    function getCurrentTicker() {
        if (typeof activeTicker !== 'undefined' && activeTicker)
            return activeTicker;
        const el = document.getElementById('ticker-hero');
        if (el) {
            const t = (el.textContent || '').trim();
            if (t && t !== '—')
                return t;
        }
        return '';
    }
    function onTickerChange() {
        const ticker = getCurrentTicker();
        if (!ticker || ticker === _lastObservedTicker)
            return;
        _lastObservedTicker = ticker;
        _currentInsightTicker = null;
        void showSmartInsight(ticker);
        _siTimers.push(setTimeout(applyBreathingWhitespace, 800));
        _siTimers.push(setTimeout(applyBreathingWhitespace, 2500));
        _siTimers.push(setTimeout(applyBreathingWhitespace, 5000));
    }
    function init() {
        const companyNameEl = document.getElementById('company-name');
        if (companyNameEl) {
            new MutationObserver(function () {
                _siTimers.push(setTimeout(onTickerChange, 100));
            }).observe(companyNameEl, { childList: true, subtree: true, characterData: true });
        }
        ['dividend-rows', 'metrics-rows', 'analyst-bar', 'short-info', 'insider-activity'].forEach(function (id) {
            const el = document.getElementById(id);
            if (el) {
                new MutationObserver(function () {
                    _siTimers.push(setTimeout(applyBreathingWhitespace, 200));
                }).observe(el, { childList: true, subtree: true });
            }
        });
        _siTimers.push(setTimeout(onTickerChange, 500));
    }
    window.cleanupSmartInsights = function () {
        _siTimers.forEach(clearTimeout);
        _siTimers = [];
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    }
    else {
        init();
    }
};
//# sourceMappingURL=smart-insights.js.map
;
// ═══ ticker-modules.js ═══
;"use strict";
/**
 * ticker-modules.js — User-customizable ticker view module ordering + hiding.
 *
 * TS Migration Phase 2 PR 34 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is the SOURCE OF TRUTH; ticker-modules.js is the build
 * artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
 */
/* Tearsheet-v2 reading order (TICKER_TEARSHEET_REDESIGN.md SS3-SS9, order_v 2):
   hero/chart -> Snapshot cluster (overview, management, profile) -> the #main
   grid (Financials & Valuation + News columns) -> peers + financial detail
   panels -> events/analysis -> options -> Your Notes LAST (SS9 — was 4th).
   _defaultPrefs() emits ARRAY order; defaultOrder numbers mirror it for
   readability. Bump TICKER_ORDER_VERSION whenever this order changes. */
const TICKER_MODULES = [
    { id: 'hero', label: 'Price Hero', defaultOrder: 0, alwaysVisible: true, group: 'core' },
    { id: 'chart-panel', label: 'Price Chart', defaultOrder: 1, alwaysVisible: true, group: 'core' },
    { id: 'stale-data-banner', label: 'Stale Data Banner', defaultOrder: 2, alwaysVisible: false, group: 'core' },
    { id: 'summary-panel', label: 'Company Overview', defaultOrder: 3, alwaysVisible: false, group: 'core' },
    { id: 'management-score-panel', label: 'Management Score', defaultOrder: 4, alwaysVisible: false, group: 'analysis' },
    { id: 'company-profile-panel', label: 'Company Profile', defaultOrder: 5, alwaysVisible: false, group: 'core' },
    { id: 'main', label: 'Main Grid (Valuation / Earnings / News)', defaultOrder: 6, alwaysVisible: true, group: 'core' },
    { id: 'peers-panel', label: 'Peer Comparison', defaultOrder: 7, alwaysVisible: false, group: 'analysis' },
    { id: 'fiveyear-prominent', label: '5-Year Financials', defaultOrder: 8, alwaysVisible: false, group: 'financials' },
    { id: 'consensus-estimates-panel', label: 'Consensus Estimates', defaultOrder: 9, alwaysVisible: false, group: 'analysis' },
    { id: 'debt-maturity-panel', label: 'Debt Maturity', defaultOrder: 10, alwaysVisible: false, group: 'financials' },
    { id: 'capital-structure-panel', label: 'Capital Structure', defaultOrder: 11, alwaysVisible: false, group: 'financials' },
    { id: 'rating-events-panel', label: 'Rating & Credit Events', defaultOrder: 12, alwaysVisible: false, group: 'financials' },
    { id: 'ma-comps-panel', label: 'M&A Comps', defaultOrder: 13, alwaysVisible: false, group: 'analysis' },
    { id: 'etf-holdings-panel', label: 'ETF Holdings', defaultOrder: 14, alwaysVisible: false, group: 'analysis' },
    { id: 'corporate-events-panel', label: 'Corporate Events', defaultOrder: 15, alwaysVisible: false, group: 'analysis' },
    { id: 'options-panel', label: 'Options Chain', defaultOrder: 16, alwaysVisible: false, group: 'options' },
    { id: 'payoff-calculator', label: 'Options Payoff', defaultOrder: 17, alwaysVisible: false, group: 'options' },
    { id: 'vol-skew-panel', label: 'Volatility Skew', defaultOrder: 18, alwaysVisible: false, group: 'options' },
    { id: 'data-freshness-panel', label: 'Data Freshness', defaultOrder: 19, alwaysVisible: false, group: 'core' },
    { id: 'annotations-panel', label: 'Your Notes', defaultOrder: 20, alwaysVisible: false, group: 'core' },
];
/* Bumping this re-seeds every stored `order` from _defaultPrefs() on next
   load (hidden choices are PRESERVED). Without it, any user who ever saved
   a module order — including via the customize modal — would keep the old
   layout forever and the redesign would silently never apply to them. */
const TICKER_ORDER_VERSION = 2;
const _TICKER_SKIP_IDS = new Set([
    'ticker-skeleton',
    'quick-links-bar',
    'anomaly-flags',
    'key-metrics-strip',
    'credit-toggle-wrap',
    'multi-expiry-panel',
    'spread-builder-panel',
    'iv-skew-panel',
]);
(function () {
    const TickerModulesImpl = (function () {
        const LS_KEY = 'ol_ticker_module_order';
        const SERVER_PATH = '/api/user/preferences/ticker-modules';
        function _defaultPrefs() {
            const order = [];
            const hidden = [];
            TICKER_MODULES.forEach(function (m) {
                order.push(m.id);
                if (['multi-expiry-panel', 'spread-builder-panel', 'iv-skew-panel',
                    'data-freshness-panel', 'stale-data-banner'].indexOf(m.id) !== -1) {
                    hidden.push(m.id);
                }
            });
            return { order: order, hidden: hidden, order_v: TICKER_ORDER_VERSION };
        }
        let _prefs = null;
        function _loadFromLocalStorage() {
            try {
                const raw = OLStorage.getString(LS_KEY, null);
                if (raw) {
                    const parsed = JSON.parse(raw);
                    return _mergeWithDefaults(parsed);
                }
            }
            catch (_e) { }
            return _defaultPrefs();
        }
        function _saveToLocalStorage(prefs) {
            try {
                OLStorage.set(LS_KEY, prefs);
            }
            catch (_e) { }
        }
        /* Set by _mergeWithDefaults when a version re-seed happened; load() then
           persists the migrated prefs so the re-seed runs ONCE per store, not on
           every load (the server round-trip is what makes it stick for authed
           users — routes_settings_fastapi.py persists order_v alongside order). */
        let _migrated = false;
        function _mergeWithDefaults(saved) {
            const defaults = _defaultPrefs();
            const validIds = new Set(TICKER_MODULES.map(function (m) { return m.id; }));
            if ((saved.order_v || 1) < TICKER_ORDER_VERSION) {
                // Stored order predates the current default layout: re-seed the ORDER
                // from defaults, PRESERVE the user's hidden choices. Without this, a
                // saved order pins the pre-tearsheet layout forever (plan SS"CRITICAL
                // gotcha").
                _migrated = true;
                const hidden = (saved.hidden || []).filter(function (id) { return validIds.has(id); });
                return { order: defaults.order.slice(), hidden: hidden, order_v: TICKER_ORDER_VERSION };
            }
            const savedIds = new Set(saved.order || []);
            defaults.order.forEach(function (id) {
                if (!savedIds.has(id) && saved.order)
                    saved.order.push(id);
            });
            saved.order = (saved.order || []).filter(function (id) { return validIds.has(id); });
            saved.hidden = (saved.hidden || []).filter(function (id) { return validIds.has(id); });
            return { order: saved.order, hidden: saved.hidden, order_v: TICKER_ORDER_VERSION };
        }
        // QA-07 / QA-18 (anonymous browser audit 2026-09-28): the server copy of
        // these prefs is account-only -- an anonymous GET answers a constant
        // {order: null} and an anonymous POST is a 401 -- yet both fired on every
        // ticker load and reorder, spending the reader's shared-IP request budget on
        // nothing. The anonymous check comes FIRST; the device copy (localStorage)
        // is the whole store for a signed-out reader.
        function _isAnon() {
            const w = window;
            return typeof w.olIsAnonymous === 'function' && w.olIsAnonymous();
        }
        function load() {
            if (_isAnon()) {
                _prefs = _loadFromLocalStorage();
                return Promise.resolve(_prefs);
            }
            return fetch(SERVER_PATH, { credentials: 'include', signal: AbortSignal.timeout(15000) })
                .then(function (r) {
                if (!r.ok)
                    throw new Error('not-auth');
                return r.json();
            })
                .then(function (data) {
                if (data && data.order) {
                    _migrated = false;
                    _prefs = _mergeWithDefaults(data);
                    _saveToLocalStorage(_prefs);
                    if (_migrated)
                        save(_prefs); // persist the one-time re-seed server-side
                    return _prefs;
                }
                throw new Error('empty');
            })
                .catch(function () {
                _prefs = _loadFromLocalStorage();
                return _prefs;
            });
        }
        function save(prefs) {
            _prefs = prefs;
            _saveToLocalStorage(prefs);
            if (_isAnon())
                return;
            fetch(SERVER_PATH, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(prefs),
                signal: AbortSignal.timeout(30000),
            }).catch(function () { });
        }
        function applyOrder(prefsArg) {
            const prefs = prefsArg || _prefs || _defaultPrefs();
            const container = document.getElementById('ticker-view');
            if (!container)
                return;
            const hiddenSet = new Set(prefs.hidden || []);
            const orderedEls = [];
            prefs.order.forEach(function (id) {
                const el = document.getElementById(id);
                if (el && el.parentElement === container && !_TICKER_SKIP_IDS.has(id)) {
                    orderedEls.push({ id: id, el: el });
                }
            });
            orderedEls.forEach(function (item) {
                container.appendChild(item.el);
                const meta = _getMeta(item.id);
                const shouldHide = hiddenSet.has(item.id) && !(meta && meta.alwaysVisible);
                item.el.classList.toggle('tm-hidden', shouldHide);
            });
        }
        function _getMeta(id) {
            for (let i = 0; i < TICKER_MODULES.length; i++) {
                if (TICKER_MODULES[i].id === id)
                    return TICKER_MODULES[i];
            }
            return null;
        }
        let _dragSrcIndex = null;
        function openModal() {
            const _doOpen = function () {
                const overlay = document.getElementById('tm-modal-overlay');
                if (!overlay)
                    return;
                const prefs = _prefs || _defaultPrefs();
                _renderModalList(prefs);
                overlay.classList.remove('d-none');
                overlay.style.display = 'flex';
                const modal = document.getElementById('tm-modal');
                if (modal)
                    modal.focus();
            };
            const w = window;
            if (typeof w._materializeView === 'function') {
                w._materializeView('tm-modal-overlay').then(_doOpen);
            }
            else {
                _doOpen();
            }
        }
        function closeModal() {
            const overlay = document.getElementById('tm-modal-overlay');
            if (overlay) {
                overlay.classList.add('d-none');
                overlay.style.display = '';
            }
        }
        function _isContentGatedOff(id) {
            const el = document.getElementById(id);
            return !!(el && typeof el.getAttribute === 'function' && el.getAttribute('data-content-gate') === 'off');
        }
        function _renderModalList(prefs) {
            const list = document.getElementById('tm-module-list');
            if (!list)
                return;
            const hiddenSet = new Set(prefs.hidden || []);
            list.innerHTML = prefs.order.map(function (id, idx) {
                const meta = _getMeta(id);
                if (!meta)
                    return '';
                // OWNER ruling 2026-10-26 (Q4): a panel held dark by a content gate
                // (its renderer sets data-content-gate="off" and returns before any
                // fetch) gets no toggle -- it would do nothing for any ticker. The
                // renderer removes the attribute when its gate is ON, so the toggle
                // comes back the day the gate flips. `idx` stays the prefs.order index,
                // so drag-reorder is unaffected by the skipped row.
                if (_isContentGatedOff(id))
                    return '';
                const isHidden = hiddenSet.has(id) && !meta.alwaysVisible;
                const eyeTitle = isHidden ? 'Show this module' : 'Hide this module';
                const eyeLabel = isHidden ? 'Show' : 'Hide';
                return '<div class="tm-item' + (isHidden ? ' tm-item-hidden' : '') + '"'
                    + ' draggable="' + (meta.alwaysVisible ? 'false' : 'true') + '"'
                    + ' data-id="' + _escHtml(id) + '"'
                    + ' data-index="' + idx + '"'
                    + ' role="listitem"'
                    + ' aria-label="' + _escHtml(meta.label) + (isHidden ? ' (hidden)' : '') + '">'
                    + '<span class="tm-drag-handle" aria-hidden="true" title="Drag to reorder">☰</span>'
                    + '<span class="tm-item-label">' + _escHtml(meta.label) + '</span>'
                    + (meta.alwaysVisible
                        ? '<span class="tm-always-badge">always on</span>'
                        : '<button class="tm-eye-btn" data-tm-id="' + _escHtml(id) + '"'
                            + ' title="' + eyeTitle + '" aria-label="' + eyeLabel + ' ' + _escHtml(meta.label) + '">'
                            + (isHidden ? '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17.9 17.9A10 10 0 0 1 12 20C5 20 1 12 1 12a18.5 18.5 0 0 1 5.1-5.9M9.9 4.2A9 9 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.2 3.2M14.1 14.1a3 3 0 1 1-4.2-4.2"></path><path d="M1 1l22 22"></path></svg>' : '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>')
                            + '</button>')
                    + '</div>';
            }).join('');
            _bindDragHandlers(list, prefs);
            _bindEyeHandlers(list, prefs);
        }
        function _bindEyeHandlers(list, prefs) {
            list.querySelectorAll('.tm-eye-btn').forEach(function (btn) {
                btn.addEventListener('click', function () {
                    const id = btn.getAttribute('data-tm-id') || '';
                    const hiddenSet = new Set(prefs.hidden || []);
                    if (hiddenSet.has(id))
                        hiddenSet.delete(id);
                    else
                        hiddenSet.add(id);
                    prefs.hidden = Array.from(hiddenSet);
                    _renderModalList(prefs);
                });
            });
        }
        function _bindDragHandlers(list, prefs) {
            const items = list.querySelectorAll('.tm-item[draggable="true"]');
            items.forEach(function (item) {
                const html = item;
                html.addEventListener('dragstart', function (e) {
                    const dragE = e;
                    _dragSrcIndex = parseInt(html.getAttribute('data-index') || '0', 10);
                    html.classList.add('tm-dragging');
                    if (dragE.dataTransfer) {
                        dragE.dataTransfer.effectAllowed = 'move';
                        dragE.dataTransfer.setData('text/plain', String(_dragSrcIndex));
                    }
                });
                html.addEventListener('dragend', function () {
                    html.classList.remove('tm-dragging');
                    list.querySelectorAll('.tm-drop-target').forEach(function (el) {
                        el.classList.remove('tm-drop-target');
                    });
                });
                html.addEventListener('dragover', function (e) {
                    e.preventDefault();
                    const dragE = e;
                    if (dragE.dataTransfer)
                        dragE.dataTransfer.dropEffect = 'move';
                    list.querySelectorAll('.tm-drop-target').forEach(function (el) {
                        el.classList.remove('tm-drop-target');
                    });
                    html.classList.add('tm-drop-target');
                });
                html.addEventListener('dragleave', function () {
                    html.classList.remove('tm-drop-target');
                });
                html.addEventListener('drop', function (e) {
                    e.preventDefault();
                    const destIndex = parseInt(html.getAttribute('data-index') || '0', 10);
                    if (_dragSrcIndex === null || _dragSrcIndex === destIndex)
                        return;
                    const order = prefs.order.slice();
                    const moved = order.splice(_dragSrcIndex, 1)[0];
                    order.splice(destIndex, 0, moved);
                    prefs.order = order;
                    _dragSrcIndex = null;
                    _renderModalList(prefs);
                });
            });
        }
        function _saveModal() {
            const list = document.getElementById('tm-module-list');
            if (!list)
                return;
            const order = [];
            const hidden = [];
            list.querySelectorAll('.tm-item').forEach(function (item) {
                const id = item.getAttribute('data-id');
                if (id) {
                    order.push(id);
                    if (item.classList.contains('tm-item-hidden'))
                        hidden.push(id);
                }
            });
            const finalPrefs = { order: order, hidden: hidden };
            save(finalPrefs);
            applyOrder(finalPrefs);
            closeModal();
            if (typeof showToast === 'function')
                showToast('Layout saved', '', 2000);
        }
        function _resetModal() {
            const def = _defaultPrefs();
            _prefs = def;
            save(def);
            _renderModalList(def);
            if (typeof showToast === 'function')
                showToast('Layout reset to defaults', '', 2000);
        }
        function _escHtml(str) {
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        }
        function init() {
            document.addEventListener('click', function (e) {
                const t = e.target;
                if (!t)
                    return;
                if (t.id === 'tm-customize-btn') {
                    openModal();
                    return;
                }
                if (t.id === 'tm-save-btn') {
                    _saveModal();
                    return;
                }
                if (t.id === 'tm-cancel-btn') {
                    closeModal();
                    return;
                }
                if (t.id === 'tm-reset-btn') {
                    _resetModal();
                    return;
                }
                if (t.id === 'tm-modal-overlay') {
                    closeModal();
                    return;
                }
            });
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') {
                    const overlay = document.getElementById('tm-modal-overlay');
                    if (overlay && !overlay.classList.contains('d-none'))
                        closeModal();
                }
            });
            load().then(function (prefs) {
                applyOrder(prefs);
            });
        }
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        }
        else {
            init();
        }
        return {
            load: load,
            save: save,
            applyOrder: applyOrder,
            openModal: openModal,
            closeModal: closeModal,
            saveModal: _saveModal,
            resetModal: _resetModal,
            MODULES: TICKER_MODULES,
        };
    })();
    if (typeof window !== 'undefined') {
        window.TickerModules = TickerModulesImpl;
        window._tickerModulesApply = function () {
            TickerModulesImpl.load().then(function (prefs) {
                TickerModulesImpl.applyOrder(prefs);
            });
        };
    }
})();
//# sourceMappingURL=ticker-modules.js.map
;
// ═══ ticker-suggestions.js ═══
;"use strict";
/**
 * ticker-suggestions.js — Smart ticker anticipation + research breadcrumb trail.
 *
 * TS Migration Phase 2 PR 33 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is the SOURCE OF TRUTH; ticker-suggestions.js is the
 * build artifact produced by `npx tsc -p tsconfig.build.json`
 * (gitignored).
 *
 * Part 1: Predicts next ticker based on sector peers, watchlist
 * gaps, hardcoded map. Part 2: Tracks research path as clickable
 * breadcrumbs below ticker tabs.
 */
(function () {
    'use strict';
    const SECTOR_PEERS = {
        AAPL: ['MSFT', 'GOOG', 'AMZN', 'META', 'NVDA'],
        MSFT: ['AAPL', 'GOOG', 'AMZN', 'META', 'ORCL'],
        GOOG: ['META', 'MSFT', 'AMZN', 'AAPL', 'SNAP'],
        GOOGL: ['META', 'MSFT', 'AMZN', 'AAPL', 'SNAP'],
        AMZN: ['MSFT', 'GOOG', 'AAPL', 'SHOP', 'WMT'],
        META: ['GOOG', 'SNAP', 'PINS', 'MSFT', 'AAPL'],
        NVDA: ['AMD', 'INTC', 'AVGO', 'QCOM', 'TSM'],
        AMD: ['NVDA', 'INTC', 'QCOM', 'AVGO', 'TSM'],
        INTC: ['AMD', 'NVDA', 'QCOM', 'TXN', 'AVGO'],
        AVGO: ['QCOM', 'NVDA', 'TXN', 'AMD', 'MRVL'],
        QCOM: ['AVGO', 'AMD', 'NVDA', 'INTC', 'TXN'],
        TSM: ['NVDA', 'AMD', 'INTC', 'AVGO', 'ASML'],
        CRM: ['NOW', 'WDAY', 'ORCL', 'SAP', 'ADBE'],
        ORCL: ['CRM', 'SAP', 'MSFT', 'NOW', 'IBM'],
        ADBE: ['CRM', 'INTU', 'NOW', 'MSFT', 'WDAY'],
        NOW: ['CRM', 'WDAY', 'ADBE', 'ORCL', 'SAP'],
        JPM: ['BAC', 'GS', 'MS', 'C', 'WFC'],
        BAC: ['JPM', 'WFC', 'C', 'GS', 'USB'],
        GS: ['MS', 'JPM', 'BAC', 'C', 'SCHW'],
        MS: ['GS', 'JPM', 'BAC', 'SCHW', 'C'],
        WFC: ['BAC', 'JPM', 'C', 'USB', 'PNC'],
        C: ['BAC', 'JPM', 'WFC', 'GS', 'MS'],
        V: ['MA', 'PYPL', 'AXP', 'SQ', 'FIS'],
        MA: ['V', 'PYPL', 'AXP', 'SQ', 'FIS'],
        JNJ: ['PFE', 'UNH', 'MRK', 'ABT', 'LLY'],
        UNH: ['JNJ', 'CVS', 'CI', 'HUM', 'ELV'],
        PFE: ['JNJ', 'MRK', 'ABBV', 'LLY', 'BMY'],
        MRK: ['PFE', 'LLY', 'ABBV', 'JNJ', 'BMY'],
        LLY: ['MRK', 'PFE', 'NVO', 'ABBV', 'JNJ'],
        ABBV: ['PFE', 'MRK', 'JNJ', 'LLY', 'BMY'],
        XOM: ['CVX', 'COP', 'SLB', 'EOG', 'OXY'],
        CVX: ['XOM', 'COP', 'SLB', 'EOG', 'OXY'],
        COP: ['XOM', 'CVX', 'EOG', 'OXY', 'DVN'],
        WMT: ['TGT', 'COST', 'AMZN', 'KR', 'DG'],
        COST: ['WMT', 'TGT', 'KR', 'BJ', 'AMZN'],
        TGT: ['WMT', 'COST', 'KR', 'DG', 'DLTR'],
        KO: ['PEP', 'MNST', 'KDP', 'STZ', 'DEO'],
        PEP: ['KO', 'MNST', 'KDP', 'STZ', 'DEO'],
        MCD: ['SBUX', 'YUM', 'CMG', 'DPZ', 'QSR'],
        SBUX: ['MCD', 'YUM', 'CMG', 'DPZ', 'DNKN'],
        NKE: ['LULU', 'ADDYY', 'UAA', 'VFC', 'PVH'],
        BA: ['LMT', 'RTX', 'GD', 'NOC', 'GE'],
        CAT: ['DE', 'EMR', 'HON', 'MMM', 'IR'],
        HON: ['GE', 'MMM', 'EMR', 'CAT', 'ITW'],
        DIS: ['NFLX', 'CMCSA', 'WBD', 'PARA', 'FOX'],
        NFLX: ['DIS', 'CMCSA', 'WBD', 'ROKU', 'PARA'],
        TSLA: ['F', 'GM', 'RIVN', 'LCID', 'NIO'],
        F: ['GM', 'TSLA', 'TM', 'STLA', 'HMC'],
        SPG: ['O', 'PLD', 'AMT', 'CCI', 'EQIX'],
        O: ['SPG', 'NNN', 'WPC', 'VICI', 'STOR'],
    };
    const _viewedThisSession = new Set();
    function _getPeers(ticker) {
        if (!ticker)
            return [];
        let peers = [];
        const w = window;
        if (w._peerData && w._peerData.peerTickers) {
            peers = peers.concat(w._peerData.peerTickers);
        }
        const d = (typeof getData === 'function') ? getData(ticker) : null;
        if (d && d.companyInfo) {
            const ci = d.companyInfo;
            if (ci.peers && Array.isArray(ci.peers)) {
                peers = peers.concat(ci.peers);
            }
        }
        if (SECTOR_PEERS[ticker]) {
            peers = peers.concat(SECTOR_PEERS[ticker]);
        }
        const seen = {};
        const result = [];
        for (let i = 0; i < peers.length; i++) {
            const p = (peers[i] || '').toUpperCase().trim();
            if (p && p !== ticker && !seen[p]) {
                seen[p] = true;
                result.push(p);
            }
        }
        return result;
    }
    function _filterSessionTabs(candidates) {
        if (typeof tickers === 'undefined')
            return candidates;
        const tabSet = {};
        for (let i = 0; i < tickers.length; i++)
            tabSet[tickers[i]] = true;
        return candidates.filter(function (t) { return !tabSet[t]; });
    }
    function _getSuggestions(ticker) {
        const peers = _getPeers(ticker);
        const filtered = _filterSessionTabs(peers);
        if (filtered.length >= 2)
            return filtered.slice(0, 3);
        if (typeof tickers !== 'undefined' && tickers.length > 0) {
            const unviewed = tickers.filter(function (t) {
                return t !== ticker && !_viewedThisSession.has(t);
            });
            if (unviewed.length >= 2)
                return unviewed.slice(0, 3);
        }
        const allPeers = [];
        const keys = Object.keys(SECTOR_PEERS);
        for (let i = 0; i < keys.length; i++) {
            if (keys[i] !== ticker) {
                const p = SECTOR_PEERS[keys[i]];
                for (let j = 0; j < p.length; j++) {
                    if (p[j] === ticker) {
                        allPeers.push(keys[i]);
                        break;
                    }
                }
            }
        }
        const relatedFiltered = _filterSessionTabs(allPeers);
        if (relatedFiltered.length >= 2)
            return relatedFiltered.slice(0, 3);
        if (filtered.length > 0)
            return filtered.slice(0, 3);
        return [];
    }
    function updateTickerSuggestions() {
        const ticker = (typeof activeTicker !== 'undefined') ? activeTicker : null;
        if (!ticker)
            return;
        _viewedThisSession.add(ticker);
        const suggestions = _getSuggestions(ticker);
        const input = document.getElementById('ticker-input');
        if (!input)
            return;
        if (suggestions.length === 0) {
            input.placeholder = 'TICKER';
            return;
        }
        let text;
        if (suggestions.length === 1) {
            text = 'Try ' + suggestions[0];
        }
        else if (suggestions.length === 2) {
            text = 'Try ' + suggestions[0] + ' or ' + suggestions[1];
        }
        else {
            text = 'Try ' + suggestions[0] + ', ' + suggestions[1] + ', or ' + suggestions[2];
        }
        input.placeholder = text;
    }
    const MAX_BREADCRUMBS = 8;
    const FADE_DELAY_MS = 600000;
    let _breadcrumbs = [];
    let _breadcrumbContainer = null;
    let _fadeTimer = null;
    function _recordBreadcrumb(ticker, view) {
        if (!ticker)
            return;
        const v = view || 'ticker';
        if (_breadcrumbs.length > 0) {
            const last = _breadcrumbs[_breadcrumbs.length - 1];
            if (last.ticker === ticker && last.view === v)
                return;
        }
        if (_breadcrumbs.length > 0) {
            const lastEntry = _breadcrumbs[_breadcrumbs.length - 1];
            if (lastEntry.ticker === ticker) {
                lastEntry.view = v;
                lastEntry.timestamp = Date.now();
                _renderBreadcrumbs();
                return;
            }
        }
        _breadcrumbs.push({ ticker: ticker, view: v, timestamp: Date.now() });
        if (_breadcrumbs.length > MAX_BREADCRUMBS) {
            _breadcrumbs = _breadcrumbs.slice(_breadcrumbs.length - MAX_BREADCRUMBS);
        }
        _renderBreadcrumbs();
    }
    function _ensureContainer() {
        if (_breadcrumbContainer && document.body.contains(_breadcrumbContainer))
            return _breadcrumbContainer;
        const tickerTabs = document.getElementById('ticker-tabs');
        if (!tickerTabs)
            return null;
        const row = tickerTabs.closest('div');
        if (!row || !row.parentNode)
            return null;
        _breadcrumbContainer = document.createElement('div');
        _breadcrumbContainer.className = 'research-breadcrumbs';
        _breadcrumbContainer.id = 'research-breadcrumbs';
        _breadcrumbContainer.setAttribute('role', 'navigation');
        _breadcrumbContainer.setAttribute('aria-label', 'Research trail');
        row.parentNode.insertBefore(_breadcrumbContainer, row.nextSibling);
        return _breadcrumbContainer;
    }
    function _renderBreadcrumbs() {
        const container = _ensureContainer();
        if (!container)
            return;
        if (_breadcrumbs.length < 2) {
            container.classList.add('hidden');
            container.textContent = '';
            return;
        }
        container.classList.remove('hidden');
        _resetFadeTimer();
        const currentTicker = (typeof activeTicker !== 'undefined') ? activeTicker : null;
        let html = '';
        for (let i = 0; i < _breadcrumbs.length; i++) {
            if (i > 0) {
                html += '<span class="bc-arrow" aria-hidden="true">→</span>';
            }
            const bc = _breadcrumbs[i];
            const isActive = bc.ticker === currentTicker;
            // 2026-09-26 (external review P1-12): escaped -- this strip rendered
            // the raw switchTicker argument, the reachable half of a share-link
            // injection (switchTicker now also refuses non-ticker shapes).
            const _t = escHtml(bc.ticker);
            html += '<span class="bc-item' + (isActive ? ' active' : '') + '" '
                + 'data-ticker="' + _t + '" '
                + 'tabindex="0" role="link" '
                + 'aria-label="Jump to ' + _t + '"'
                + '>' + _t + '</span>';
        }
        container.innerHTML = html;
    }
    function _resetFadeTimer() {
        const container = _ensureContainer();
        if (!container)
            return;
        container.classList.remove('bc-fading');
        void container.offsetWidth;
        container.classList.add('bc-fading');
        if (_fadeTimer)
            clearTimeout(_fadeTimer);
        _fadeTimer = setTimeout(function () {
            if (container)
                container.classList.add('hidden');
        }, FADE_DELAY_MS + 1000);
    }
    function _installHooks() {
        const w = window;
        if (typeof w.switchTicker === 'function') {
            const origSwitch = w.switchTicker;
            w.switchTicker = function (t) {
                origSwitch.call(this, t);
                const view = (typeof currentView !== 'undefined') ? currentView : 'ticker';
                _recordBreadcrumb(t, view);
                updateTickerSuggestions();
            };
        }
        if (typeof w.setView === 'function') {
            const origSetView = w.setView;
            // Forward EVERY argument (popstate's skipHistory) -- see bottom-tab.ts.
            w.setView = function (...args) {
                const result = origSetView.apply(this, args);
                const v = args[0];
                const ticker = (typeof activeTicker !== 'undefined') ? activeTicker : null;
                if (ticker && (v === 'ticker' || v === 'fundamentals')) {
                    _recordBreadcrumb(ticker, v);
                }
                return result;
            };
        }
    }
    function _onBreadcrumbClick(e) {
        const target = e.target;
        if (!target || !target.closest)
            return;
        const item = target.closest('.bc-item');
        if (!item)
            return;
        const ticker = item.getAttribute('data-ticker');
        if (ticker && typeof switchTicker === 'function') {
            switchTicker(ticker);
        }
    }
    function _onBreadcrumbKey(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            _onBreadcrumbClick(e);
        }
    }
    function _init() {
        _installHooks();
        document.addEventListener('click', function (e) {
            const t = e.target;
            if (t && t.closest && t.closest('.research-breadcrumbs'))
                _onBreadcrumbClick(e);
        });
        document.addEventListener('keydown', function (e) {
            const t = e.target;
            if (t && t.closest && t.closest('.research-breadcrumbs'))
                _onBreadcrumbKey(e);
        });
        const ticker = (typeof activeTicker !== 'undefined') ? activeTicker : null;
        const view = (typeof currentView !== 'undefined') ? currentView : 'ticker';
        if (ticker) {
            _viewedThisSession.add(ticker);
            _recordBreadcrumb(ticker, view);
            updateTickerSuggestions();
        }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { setTimeout(_init, 200); });
    }
    else {
        setTimeout(_init, 200);
    }
    window._tickerSuggestions = {
        update: updateTickerSuggestions,
        SECTOR_PEERS: SECTOR_PEERS,
    };
})();
//# sourceMappingURL=ticker-suggestions.js.map
;
// ═══ metric-insights.js ═══
;"use strict";
/**
 * metric-insights.js — Contextual "So what?" insights for financial metrics.
 *
 * TS Migration Phase 2 PR 25 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is the SOURCE OF TRUTH; metric-insights.js is the build
 * artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
 *
 * Generates plain-English context based on the user's skill level:
 *   beginner  — Full explanation + what it means + context
 *   learner   — Historical context + relative positioning
 *   expert    — null (no extra text)
 *
 * Uses the data already fetched from /api/data (metrics, price, derived).
 * No additional API calls required.
 */
// Wrapped in outer IIFE so the local const doesn't collide with the
// ambient `declare var MetricInsights` in globals.d.ts. Window
// assignment at the bottom is the canonical cross-chunk export.
(function () {
    const MetricInsightsImpl = (function () {
        'use strict';
        let _level = (function () {
            try {
                return OLStorage.getString('_userLevel', null) || 'beginner';
            }
            catch (_e) {
                return 'beginner';
            }
        })();
        function setLevel(lvl) {
            _level = lvl;
        }
        function getLevel() {
            return _level;
        }
        function fmtN(n, dec) {
            if (n == null || isNaN(n))
                return null;
            return Number(n).toFixed(dec != null ? dec : 1);
        }
        const _benchmarks = {
            pe: { low: 15, mid: 20, high: 30, unit: 'x' },
            forwardPe: { low: 12, mid: 18, high: 28, unit: 'x' },
            evEbitda: { low: 8, mid: 12, high: 20, unit: 'x' },
            pb: { low: 1, mid: 2, high: 5, unit: 'x' },
            ps: { low: 1, mid: 3, high: 8, unit: 'x' },
            debtEquity: { low: 0.3, mid: 0.8, high: 1.5, unit: '' },
            dividendYield: { low: 1, mid: 2, high: 4, unit: '%' },
            roe: { low: 8, mid: 15, high: 25, unit: '%' },
            roa: { low: 3, mid: 5, high: 10, unit: '%' },
            roic: { low: 8, mid: 15, high: 25, unit: '%' },
            fcfYield: { low: 2, mid: 5, high: 8, unit: '%' },
        };
        const _metricMap = {
            'P/E (TTM)': { key: 'pe', src: 'm' },
            'P/E (Fwd)': { key: 'forwardPe', src: 'm' },
            'EV/EBITDA': { key: 'evEbitda', src: 'm' },
            'P/B': { key: 'pb', src: 'm' },
            'P/S': { key: 'ps', src: 'm' },
            'Debt/Equity': { key: 'debtEquity', src: 'm' },
            'Div Yield': { key: 'dividendYield', src: 'm' },
            'ROE': { key: 'roe', src: 'm' },
            'ROA': { key: 'roa', src: 'm' },
            'ROIC': { key: 'roic', src: 'd' },
            'FCF Yield': { key: 'fcfYield', src: 'd' },
        };
        function getInsight(ticker, label, m, d, p) {
            if (_level === 'expert')
                return null;
            const info = _metricMap[label];
            if (!info)
                return null;
            const raw = info.src === 'm' ? (m && m[info.key]) : (d && d[info.key]);
            if (raw == null || raw === 0)
                return null;
            const bench = _benchmarks[info.key];
            if (!bench)
                return null;
            const numVal = Number(raw);
            if (isNaN(numVal))
                return null;
            let position;
            if (numVal <= bench.low)
                position = 'low';
            else if (numVal <= bench.mid)
                position = 'moderate';
            else if (numVal <= bench.high)
                position = 'elevated';
            else
                position = 'high';
            const mb = m;
            const db = d;
            const pb = p;
            if (_level === 'beginner')
                return _beginnerInsight(ticker, label, info.key, numVal, bench, position, mb, db, pb);
            if (_level === 'learner')
                return _learnerInsight(ticker, label, info.key, numVal, bench, position, mb, db, pb);
            return null;
        }
        function _beginnerInsight(_ticker, _label, key, val, _bench, pos, m, _d, _p) {
            switch (key) {
                case 'pe':
                    if (val < 0)
                        return 'This company is currently unprofitable, so the P/E ratio does not apply.';
                    return 'Investors pay $' + fmtN(val, 1) + ' for every $1 of earnings. ' +
                        (pos === 'low' ? 'This is relatively cheap compared to the broader market.' :
                            pos === 'moderate' ? 'This is in line with the market average.' :
                                pos === 'elevated' ? 'This is above average, suggesting investors expect growth.' :
                                    'This is well above average — the market expects strong future growth.');
                case 'forwardPe': {
                    if (val < 0)
                        return 'Analysts expect the company to be unprofitable next year.';
                    const trailing = m && m.pe ? Number(m.pe) : null;
                    const comparison = (trailing && trailing > 0) ?
                        (val < trailing ? ' Lower than the trailing P/E, suggesting earnings are expected to grow.' :
                            ' Higher than trailing P/E, suggesting earnings may slow.') : '';
                    return 'Based on analyst estimates, the stock trades at ' + fmtN(val, 1) + 'x next year\'s earnings.' + comparison;
                }
                case 'evEbitda':
                    return 'The company is valued at ' + fmtN(val, 1) + 'x its operating profit (including debt). ' +
                        (pos === 'low' ? 'This is relatively inexpensive.' :
                            pos === 'moderate' ? 'This is a reasonable valuation.' :
                                'This is on the expensive side, typical for fast-growing companies.');
                case 'pb':
                    return (val < 1 ? 'Trading below book value — the stock costs less than the company\'s net assets. ' +
                        'This can signal a bargain or reflect concerns about future performance.' :
                        'Investors pay $' + fmtN(val, 2) + ' for every $1 of the company\'s net assets. ' +
                            (pos === 'low' ? 'This is modest, typical for mature businesses.' :
                                pos === 'moderate' ? 'A moderate premium over book value.' :
                                    'A significant premium, usually justified by strong intangible assets or growth.'));
                case 'ps':
                    return 'The market values the company at ' + fmtN(val, 2) + 'x its annual revenue. ' +
                        (pos === 'low' ? 'This is lean, common for slower-growth or cyclical businesses.' :
                            pos === 'moderate' ? 'A moderate valuation relative to revenue.' :
                                'A high revenue multiple, typical for high-margin or fast-growing companies.');
                case 'debtEquity':
                    return (val < 0.3 ? 'Very low leverage — the company relies mostly on equity, not debt. Conservative balance sheet.' :
                        val < 1 ? 'Moderate leverage. Debt is ' + fmtN(val * 100, 0) + '% of equity, a manageable level for most industries.' :
                            val < 2 ? 'Significant leverage — more debt than equity. Common in capital-intensive industries but increases risk.' :
                                'Highly leveraged. Debt is ' + fmtN(val, 1) + 'x equity. This magnifies returns but also increases financial risk.');
                case 'dividendYield':
                    return 'The stock pays ' + fmtN(val, 1) + '% annually in dividends. ' +
                        (val < 1 ? 'A modest yield; the company may be reinvesting in growth instead.' :
                            val < 3 ? 'A moderate income stream for investors.' :
                                val < 6 ? 'An attractive yield. Verify the payout is sustainable.' :
                                    'A very high yield — check whether the dividend is sustainable.');
                case 'roe':
                    return 'The company generates ' + fmtN(val, 1) + '% return on shareholders\' equity. ' +
                        (val < 8 ? 'Below average; the company may not be using equity efficiently.' :
                            val < 15 ? 'Solid returns, in line with a well-run business.' :
                                'Strong performance — the business generates high returns on equity.');
                case 'roa':
                    return 'Every dollar of assets produces ' + fmtN(val, 1) + ' cents of profit. ' +
                        (val < 3 ? 'Below average, though asset-heavy industries often show lower ROA.' :
                            val < 8 ? 'Healthy asset efficiency.' :
                                'Excellent asset utilization, typical of asset-light business models.');
                case 'roic':
                    return 'The company earns ' + fmtN(val, 1) + '% on all capital invested (debt + equity). ' +
                        (val < 8 ? 'Below the typical cost of capital — the company may be destroying value.' :
                            val < 15 ? 'Reasonable returns above most companies\' cost of capital.' :
                                'Strong value creation — well above the cost of capital.');
                case 'fcfYield':
                    return 'Free cash flow equals ' + fmtN(val, 1) + '% of the company\'s market value. ' +
                        (val < 2 ? 'Low FCF yield; the company may be investing heavily for growth.' :
                            val < 5 ? 'A solid cash generation rate.' :
                                'High free cash flow relative to price — attractive for value investors.');
                default:
                    return null;
            }
        }
        function _learnerInsight(_ticker, _label, key, val, _bench, pos, m, _d, _p) {
            const tag = (pos === 'low' ? 'below avg' : pos === 'moderate' ? 'avg range' : pos === 'elevated' ? 'above avg' : 'well above avg');
            switch (key) {
                case 'pe':
                    if (val < 0)
                        return 'Negative earnings; P/E not meaningful.';
                    return fmtN(val, 1) + 'x (' + tag + ', market ~15-20x). ' +
                        (m && m.forwardPe && Number(m.forwardPe) > 0 ? 'Fwd P/E: ' + fmtN(Number(m.forwardPe), 1) + 'x.' : '');
                case 'forwardPe': {
                    if (val < 0)
                        return 'Expected unprofitable.';
                    const trail = m && m.pe ? Number(m.pe) : null;
                    return fmtN(val, 1) + 'x forward (' + tag + ').' +
                        (trail && trail > 0 ? ' TTM: ' + fmtN(trail, 1) + 'x.' : '');
                }
                case 'evEbitda':
                    return fmtN(val, 1) + 'x (' + tag + ', market ~10-14x).';
                case 'pb':
                    return fmtN(val, 2) + 'x book (' + (val < 1 ? 'below book value' : tag) + ').';
                case 'ps':
                    return fmtN(val, 2) + 'x revenue (' + tag + ').';
                case 'debtEquity':
                    return fmtN(val, 2) + 'x D/E (' + (val < 0.5 ? 'conservative' : val < 1 ? 'moderate' : 'aggressive') + ' leverage).';
                case 'dividendYield':
                    return fmtN(val, 1) + '% yield (' + (val < 1 ? 'minimal' : val < 3 ? 'moderate' : 'high') + ' income).';
                case 'roe':
                    return fmtN(val, 1) + '% ROE (' + tag + ', strong >15%).';
                case 'roa':
                    return fmtN(val, 1) + '% ROA (' + tag + ', strong >8%).';
                case 'roic':
                    return fmtN(val, 1) + '% ROIC (' + (val > 15 ? 'value creator' : val > 8 ? 'above cost of capital' : 'below cost of capital') + ').';
                case 'fcfYield':
                    return fmtN(val, 1) + '% FCF yield (' + (val > 5 ? 'cash-rich' : val > 2 ? 'solid' : 'reinvesting') + ').';
                default:
                    return null;
            }
        }
        // #137 (OWNER 2026-06-04): the valuation panel used to render a full
        // plain-English sentence under EVERY metric row (~9 stacked paragraphs —
        // "way too much"). The new layout is a compact metric TABLE + a brief
        // ~3-bullet summary of the MOST IMPACTFUL characteristics underneath.
        // getTopInsights() picks the most notable metrics (extreme readings
        // first) and returns their beginner-level sentences as the summary
        // bullets. Always beginner copy (the summary is the consolidated
        // plain-English explanation; level no longer gates per-row text).
        // Value-investing relevance order for tie-breaking when several metrics
        // share the same extremity score (lower = surfaced first).
        const _summaryPriority = {
            pe: 0, roe: 1, debtEquity: 2, fcfYield: 3, pb: 4, evEbitda: 5,
            roic: 6, ps: 7, dividendYield: 8, roa: 9, forwardPe: 10,
        };
        function getTopInsights(ticker, m, d, p, max) {
            const cap = max != null ? max : 3;
            const scored = [];
            const mb = m;
            const db = d;
            const pb = p;
            for (const label in _metricMap) {
                const info = _metricMap[label];
                const raw = info.src === 'm' ? (m && m[info.key]) : (d && d[info.key]);
                if (raw == null || raw === 0)
                    continue;
                const numVal = Number(raw);
                if (isNaN(numVal))
                    continue;
                const bench = _benchmarks[info.key];
                if (!bench)
                    continue;
                let position;
                let score;
                if (numVal <= bench.low) {
                    position = 'low';
                    score = 3;
                }
                else if (numVal <= bench.mid) {
                    position = 'moderate';
                    score = 1;
                }
                else if (numVal <= bench.high) {
                    position = 'elevated';
                    score = 2;
                }
                else {
                    position = 'high';
                    score = 3;
                }
                const sentence = _beginnerInsight(ticker, label, info.key, numVal, bench, position, mb, db, pb);
                if (sentence) {
                    scored.push({
                        score: score,
                        priority: _summaryPriority[info.key] != null ? _summaryPriority[info.key] : 99,
                        sentence: sentence,
                    });
                }
            }
            scored.sort(function (a, b) { return (b.score - a.score) || (a.priority - b.priority); });
            return scored.slice(0, cap).map(function (s) { return s.sentence; });
        }
        return {
            setLevel: setLevel,
            getLevel: getLevel,
            getInsight: getInsight,
            getTopInsights: getTopInsights,
        };
    })();
    if (typeof window !== 'undefined') {
        window.MetricInsights = MetricInsightsImpl;
    }
})();
//# sourceMappingURL=metric-insights.js.map
;
// ═══ time-aware.js ═══
;"use strict";
/* Oxford Ledge — Time-Aware Layout & Market Mood
 *
 * TS Migration Phase 2 PR 29 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is the SOURCE OF TRUTH; time-aware.js is the build
 * artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
 *
 * Ambient adaptation: body classes for time-of-day + market mood.
 * Reorders content via CSS order, shows subtle closed-market tips.
 * Auto-initializes on DOMContentLoaded (init handle exposed for tests).
 */
(function () {
    const TimeAwareImpl = (function () {
        'use strict';
        const TIME_CLASSES = ['market-preopen', 'market-open', 'market-afterhours', 'market-closed'];
        const MOOD_CLASSES = ['market-stress', 'market-euphoria', 'market-neutral'];
        const MOOD_THRESHOLD = 2.0;
        const UPDATE_INTERVAL = 60000;
        const MOOD_INTERVAL = 120000;
        const TIP_STORAGE_KEY = 'ol_time_tip_dismissed';
        const TIP_DISMISS_HOURS = 4;
        const CLOSED_TIPS = [
            'Markets closed — good time to review your watchlist',
            'Weekend research: explore the Stock Screener or Learning paths',
            'Markets are closed — catch up on recent SEC filings',
            'Off-hours: review your portfolio allocation and rebalancing',
            'Quiet hours — dig into earnings transcripts or analyst estimates',
            'Markets closed — good time to study sector performance trends',
            'No rush — explore the Macro view for economic context',
        ];
        let _tipEl = null;
        let _intervalTime = null;
        let _intervalMood = null;
        let _taTimers = [];
        function getET() {
            const now = new Date();
            const etStr = now.toLocaleString('en-US', { timeZone: 'America/New_York' });
            return new Date(etStr);
        }
        function getTimePhase() {
            const et = getET();
            const day = et.getDay();
            const mins = et.getHours() * 60 + et.getMinutes();
            if (day === 0 || day === 6)
                return 'market-closed';
            if (mins >= 420 && mins < 570)
                return 'market-preopen';
            if (mins >= 570 && mins < 960)
                return 'market-open';
            if (mins >= 960 && mins < 1140)
                return 'market-afterhours';
            return 'market-closed';
        }
        function setTimeClass() {
            const phase = getTimePhase();
            const body = document.body;
            TIME_CLASSES.forEach(function (cls) {
                body.classList.remove(cls);
            });
            body.classList.add(phase);
            return phase;
        }
        function setMoodClass(mood) {
            const body = document.body;
            MOOD_CLASSES.forEach(function (cls) {
                body.classList.remove(cls);
            });
            body.classList.add(mood);
        }
        function detectMood() {
            const spChange = _getSPChange();
            if (spChange === null) {
                setMoodClass('market-neutral');
                return;
            }
            if (spChange <= -MOOD_THRESHOLD) {
                setMoodClass('market-stress');
            }
            else if (spChange >= MOOD_THRESHOLD) {
                setMoodClass('market-euphoria');
            }
            else {
                setMoodClass('market-neutral');
            }
        }
        function _getSPChange() {
            if (typeof indicatorsCache !== 'undefined' && indicatorsCache) {
                const groups = ['Indexes', 'Futures'];
                for (let g = 0; g < groups.length; g++) {
                    const items = indicatorsCache[groups[g]];
                    if (!Array.isArray(items))
                        continue;
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].symbol === '^GSPC' || items[i].symbol === 'ES=F') {
                            if (items[i].changePct != null)
                                return items[i].changePct;
                        }
                    }
                }
            }
            const pulseEl = document.getElementById('pulse-content');
            if (pulseEl) {
                const spans = pulseEl.querySelectorAll('[data-symbol="^GSPC"], [data-sym="^GSPC"]');
                if (spans.length > 0) {
                    const text = spans[0].textContent || '';
                    const match = text.match(/([+-]?\d+\.?\d*)%/);
                    if (match)
                        return parseFloat(match[1]);
                }
            }
            return null;
        }
        function _isTipDismissed() {
            try {
                const ts = OLStorage.getString(TIP_STORAGE_KEY, null);
                if (!ts)
                    return false;
                const elapsed = Date.now() - parseInt(ts, 10);
                return elapsed < TIP_DISMISS_HOURS * 3600000;
            }
            catch (_e) {
                return false;
            }
        }
        function _dismissTip() {
            try {
                OLStorage.setString(TIP_STORAGE_KEY, String(Date.now()));
            }
            catch (_e) { }
            if (_tipEl) {
                _tipEl.style.opacity = '0';
                _taTimers.push(setTimeout(function () {
                    if (_tipEl && _tipEl.parentNode)
                        _tipEl.parentNode.removeChild(_tipEl);
                    _tipEl = null;
                }, 400));
            }
        }
        function _pickTip() {
            const now = new Date();
            const start = new Date(now.getFullYear(), 0, 0);
            const dayOfYear = Math.floor((now.getTime() - start.getTime()) / 86400000);
            return CLOSED_TIPS[dayOfYear % CLOSED_TIPS.length];
        }
        function showClosedTip() {
            const phase = getTimePhase();
            const isClosed = (phase === 'market-closed' || phase === 'market-afterhours');
            if (!isClosed) {
                if (_tipEl && _tipEl.parentNode) {
                    _tipEl.parentNode.removeChild(_tipEl);
                    _tipEl = null;
                }
                return;
            }
            if (_isTipDismissed())
                return;
            if (_tipEl && _tipEl.parentNode)
                return;
            const anchor = document.getElementById('market-pulse-bar') || document.getElementById('hero');
            if (!anchor || !anchor.parentNode)
                return;
            _tipEl = document.createElement('div');
            _tipEl.className = 'time-aware-tip';
            _tipEl.setAttribute('role', 'status');
            _tipEl.setAttribute('aria-live', 'polite');
            const tipText = document.createElement('span');
            tipText.className = 'time-aware-tip-text';
            tipText.textContent = _pickTip();
            const dismissBtn = document.createElement('button');
            dismissBtn.className = 'time-aware-tip-dismiss';
            dismissBtn.setAttribute('aria-label', 'Dismiss tip');
            dismissBtn.textContent = '×';
            dismissBtn.addEventListener('click', _dismissTip);
            _tipEl.appendChild(tipText);
            _tipEl.appendChild(dismissBtn);
            anchor.parentNode.insertBefore(_tipEl, anchor.nextSibling);
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    if (_tipEl)
                        _tipEl.style.opacity = '1';
                });
            });
        }
        function update() {
            setTimeClass();
            showClosedTip();
        }
        function init() {
            update();
            _taTimers.push(setTimeout(detectMood, 5000));
            // P1-3 (2026-07-01 network-storm audit): skip the clock/mood display refresh while
            // the tab is backgrounded (pure-display work, no reason to run hidden — CPU/battery).
            _intervalTime = setInterval(function () { if (document.hidden)
                return; update(); }, UPDATE_INTERVAL);
            _intervalMood = setInterval(function () { if (document.hidden)
                return; detectMood(); }, MOOD_INTERVAL);
        }
        function cleanup() {
            _taTimers.forEach(function (t) { clearTimeout(t); });
            _taTimers = [];
            if (_intervalTime) {
                clearInterval(_intervalTime);
                _intervalTime = null;
            }
            if (_intervalMood) {
                clearInterval(_intervalMood);
                _intervalMood = null;
            }
        }
        return {
            init: init,
            getTimePhase: getTimePhase,
            detectMood: detectMood,
            update: update,
            cleanup: cleanup,
        };
    })();
    if (typeof window !== 'undefined') {
        const w = window;
        w.TimeAware = TimeAwareImpl;
        w.initTimeAware = function () { TimeAwareImpl.init(); };
    }
})();
function cleanupTimeAware() {
    const w = window;
    if (w.TimeAware && w.TimeAware.cleanup)
        w.TimeAware.cleanup();
}
void cleanupTimeAware;
//# sourceMappingURL=time-aware.js.map
;
// ═══ data-freshness.js ═══
;"use strict";
/**
 * Data Freshness Dashboard — shows staleness of each data source per ticker.
 *
 * TS Migration Phase 2 PR 24 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is now the SOURCE OF TRUTH; the sibling data-freshness.js
 * is the build artifact produced by `npx tsc -p tsconfig.build.json`
 * (gitignored).
 *
 * PanelAsof — lightweight helper that populates .panel-asof timestamp slots
 * in every panel-title row. Call PanelAsof.update(timestamp) after any render
 * cycle that replaces panel content.
 */
// Wrapped in outer IIFE so the local const doesn't collide with the
// ambient `declare var PanelAsof` in globals.d.ts.
(function () {
    const PanelAsofImpl = (function () {
        // UX-7 (M6): single shared live region announces dashboard freshness state
        // once per cycle.
        let _liveRegion = null;
        let _lastAnnouncedState = null;
        function _ensureLiveRegion() {
            if (_liveRegion || typeof document === 'undefined')
                return _liveRegion;
            if (!document.body)
                return null;
            let el = document.getElementById('ol-freshness-live');
            if (!el) {
                el = document.createElement('div');
                el.id = 'ol-freshness-live';
                el.setAttribute('role', 'status');
                el.setAttribute('aria-atomic', 'true');
                el.className = 'sr-only';
                document.body.appendChild(el);
            }
            _liveRegion = el;
            return el;
        }
        function _announce(state, label) {
            if (state === _lastAnnouncedState)
                return;
            const el = _ensureLiveRegion();
            if (!el)
                return;
            _lastAnnouncedState = state;
            el.textContent = state === 'stale'
                ? 'Data may be outdated, last refreshed ' + label
                : 'Data refreshed';
        }
        // Format a timestamp into a human-readable "as of" string.
        function _format(epochMs) {
            if (!epochMs || isNaN(epochMs))
                return '';
            const now = Date.now();
            const diffMs = now - epochMs;
            const diffMin = Math.floor(diffMs / 60000);
            if (diffMs < 10000)
                return 'live'; // < 10 seconds
            if (diffMin < 1)
                return 'just now';
            if (diffMin === 1)
                return 'refreshed 1 min ago';
            if (diffMin < 60)
                return 'refreshed ' + diffMin + ' min ago';
            // Older than 1 hour: show clock time
            const d = new Date(epochMs);
            const h = d.getHours(), m = d.getMinutes();
            const ampm = h >= 12 ? 'PM' : 'AM';
            const hr12 = h % 12 || 12;
            const mm = m < 10 ? '0' + m : m;
            return 'as of ' + hr12 + ':' + mm + ' ' + ampm;
        }
        return {
            update: function (epochMs) {
                const ts = epochMs || Date.now();
                const isStale = (Date.now() - ts) > 300000; // >5 min
                // 2026-06-02 (OWNER browser-pass): the per-panel "live"/"just now"/
                // "refreshed N min" label is duplicative with the bottom-bar "UPDATED …"
                // status. Surface NOTHING per-panel when fresh; show only the genuinely-
                // stale (>5min) warning, which is actionable per-panel.
                const label = isStale ? _format(ts) : '';
                const slots = document.querySelectorAll('.panel-asof');
                for (let i = 0; i < slots.length; i++) {
                    const slot = slots[i];
                    if (slot.textContent !== label)
                        slot.textContent = label;
                    if (isStale && label) {
                        slot.classList.add('panel-asof-stale');
                        slot.title = 'Data may be outdated — last refreshed ' + label;
                    }
                    else {
                        slot.classList.remove('panel-asof-stale');
                        slot.title = '';
                    }
                }
                if (isStale && label)
                    _announce('stale', label);
            },
            updatePanel: function (container, epochMs) {
                const el = typeof container === 'string'
                    ? document.querySelector(container)
                    : container;
                if (!el)
                    return;
                const ts = epochMs || Date.now();
                // Same rule as update(): fresh -> empty (a fresh panel needs no label;
                // the ticker's .freshness-label and #stale-data-banner carry age, and
                // the bottom bar that once showed it was removed 2026-09-28);
                // stale -> per-panel "as of …" warning.
                const label = ((Date.now() - ts) > 300000) ? _format(ts) : '';
                const slots = el.querySelectorAll('.panel-asof');
                for (let i = 0; i < slots.length; i++) {
                    if (slots[i].textContent !== label)
                        slots[i].textContent = label;
                }
            },
            clear: function () {
                const slots = document.querySelectorAll('.panel-asof');
                for (let i = 0; i < slots.length; i++) {
                    slots[i].textContent = '';
                }
            },
            _format: _format,
        };
    }());
    window.PanelAsof = PanelAsofImpl;
})();
async function renderDataFreshness(ticker) {
    if (!ticker)
        ticker = typeof activeTicker !== 'undefined' ? activeTicker : undefined;
    if (!ticker)
        return;
    let el = null;
    try {
        const base = typeof SERVER !== 'undefined' ? SERVER : '';
        const res = await fetch(base + '/api/data-coverage?ticker=' + encodeURIComponent(ticker), { signal: AbortSignal.timeout(15000) });
        if (!res.ok)
            return;
        const data = await res.json();
        el = document.getElementById('data-freshness-panel');
        if (!el) {
            el = document.createElement('div');
            el.id = 'data-freshness-panel';
            el.className = 'detail-section';
            const settingsArea = document.getElementById('settings-panel') || document.getElementById('details-panel');
            if (settingsArea)
                settingsArea.appendChild(el);
            else
                return;
        }
        el.classList.remove('hidden');
        let html = '<h2 class="panel-title df-title">DATA COVERAGE</h2>';
        html += '<div class="df-grid">';
        if (data.sources) {
            for (const source in data.sources) {
                const s = data.sources[source];
                const dotClass = s.available ? 'color-positive' : 'color-negative';
                html += '<div class="df-card">';
                html += '<div class="df-card-header"><span class="' + dotClass + '">●</span><span class="df-card-name">' + source + '</span></div>';
                html += '<div class="df-card-source">' + (s.source || '') + '</div>';
                html += '</div>';
            }
        }
        html += '</div>';
        if (data.lastUpdated) {
            html += '<div class="df-updated">Last updated: ' + data.lastUpdated + ' | Phase: ' + (data.dataPhase || 0) + '</div>';
        }
        el.innerHTML = html;
    }
    catch (e) {
        /* @__PURE__ */ _olDebugError('DataFreshness: fetch error:', e);
        if (el) {
            el.innerHTML = '<div class="df-error">Unable to load data coverage. Check your connection and try again.</div>';
        }
    }
}
// Suppress "declared but never read" — public top-level surface.
void renderDataFreshness;
// ── I-16: Share dropdown "More options" toggle handler ─────────────────────
// Handler moved to app.js _delegatedActions['share-toggle-more'] so the
// central dispatcher owns it.  Standalone listener removed to prevent
// double-toggle (both document listeners would have fired simultaneously).
//# sourceMappingURL=data-freshness.js.map
;
// ═══ cluster-badge.js ═══
;"use strict";
// cluster-badge.ts — SF-5 5C / 5E.1 insider-cluster header badge.
//
// Reads the FREE 5D endpoint GET /api/insiders/<T>/cluster and renders a
// small TIERED badge near the ticker hero when an unusual insider-buying (or
// -selling) cluster has fired. DESCRIPTIVE only — distinct-actor count + the
// magnitude vs the 24-month baseline + sector context; NEVER a predictive /
// return claim (the §3.5 forbidden set; the marketed track-record is the
// survivorship-gated 5C.5 fast-follow). The #16 CI gate
// (tests/test_sf5_informational_only_contract.py) enforces that.
//
// Tiering (high/med/low, per the 5E spec — NOT a "0-100") is informed by the
// 2026-06-02 prod diagnostic: of the fired events, 69% cleared BOTH the z>=2.5
// and the >=95th-percentile bars and 41% had >=5 insiders, while the soft tail
// was percentile-only count-3 events. So:
//   high   — z >= 3.0  OR  insider_count >= 5      (statistically strong / many actors)
//   medium — z >= 2.5  OR  insider_count >= 4
//   low    — otherwise (the count-3 / percentile-only tail)
//
// DOM: createElement/appendChild only — NEVER innerHTML on a parent that may
// hold canvas/WS widgets (feedback_never_destroy_dom). Fails closed: any
// non-200 / network error / empty result => no badge.
(function () {
    'use strict';
    const SLOT_ID = 'hero-cluster-badge-chip';
    const _cache = {}; // ticker -> top cluster | null
    // FE P1-2 (2026-07-11): both cluster surfaces (badge render + thesis card)
    // and the verify panel issued RAW fetches — no dedup (three independent
    // insider fetches co-mount on every ticker view), no timeout (a stalled
    // socket hung the promise until the OS TCP error). These helpers prefer
    // the typed + deduped window.OLApi wrappers (in-flight share + 30s TTL +
    // 429 cooldown, api-client.ts) and keep a timeout-bounded raw fallback
    // ONLY for the cold-start chunk race (this badge evaluates before the
    // deferred api-client ES module registers OLApi — the b74549eb load-order
    // class). Both paths fail closed to null.
    function _clusterFetch(t) {
        const w = window;
        if (w.OLApi && typeof w.OLApi.getInsiderCluster === 'function') {
            return w.OLApi.getInsiderCluster(t).catch(function () { return null; });
        }
        // raw-fetch fallback: cold-start fallback before the deferred api-client module registers OLApi (b74549eb); timeout-bounded, fails closed
        return fetch('/api/insiders/' + encodeURIComponent(t) + '/cluster', { credentials: 'same-origin', signal: AbortSignal.timeout(15000) })
            .then(function (r) {
            return r.ok ? r.json() : null;
        })
            .catch(function () { return null; });
    }
    function _insidersFetch(t) {
        const w = window;
        if (w.OLApi && typeof w.OLApi.getInsiders === 'function') {
            return w.OLApi.getInsiders(t).catch(function () { return null; });
        }
        // eslint-disable-next-line ol/prefer-typed-api-client -- cold-start fallback before the deferred api-client module registers OLApi (b74549eb); the branch above prefers the typed getInsiders; timeout-bounded, fails closed
        return fetch('/api/insiders?ticker=' + encodeURIComponent(t), { credentials: 'same-origin', signal: AbortSignal.timeout(15000) })
            .then(function (r) {
            return r.ok ? r.json() : null;
        })
            .catch(function () { return null; });
    }
    function tier(c) {
        const z = typeof c.z_score === 'number' ? c.z_score : null;
        const n = typeof c.insider_count === 'number' ? c.insider_count : 0;
        if ((z !== null && z >= 3.0) || n >= 5)
            return 'high';
        if ((z !== null && z >= 2.5) || n >= 4)
            return 'medium';
        return 'low';
    }
    // PLAIN-FIRST copy (OWNER 2026-06-02 panel ruling): the chip leads with
    // plain language — the precise σ-vs-baseline magnitude lives in the
    // verification panel (5E.2), not the chip. DESCRIPTIVE state, never a
    // forecast (§3.5 / the #16 gate). "Strong/Light" describe the buying VOLUME
    // (our tier read), not a claim about the people.
    function buildText(c) {
        const n = typeof c.insider_count === 'number' ? c.insider_count : 0;
        const t = tier(c);
        const sell = c.direction === 'sell';
        let head;
        if (t === 'high')
            head = sell ? 'Heavy insider selling' : 'Strong insider buying';
        else if (t === 'medium')
            head = sell ? 'Insider selling' : 'Insider buying';
        else
            head = sell ? 'Light insider selling' : 'Light insider buying';
        head += ' · ' + n + (sell ? ' sell' : ' insider') + (n === 1 ? '' : 's');
        if (t !== 'high')
            head += ', last 30d';
        // sector context — factual comparison, not a claim. (Greek/σ omitted.)
        const z = typeof c.z_score === 'number' ? c.z_score : null;
        const sz = typeof c.sector_z_score === 'number' ? c.sector_z_score : null;
        if (z !== null && z >= 2.5 && sz !== null) {
            if (sz < 0.5)
                head += ' · contra-sector';
            else if (sz >= 2.5)
                head += ' · sector-wide';
        }
        return head;
    }
    function _host() {
        // Prefer a dedicated slot; else mount beside the insider net-flow chip.
        const slot = document.getElementById('hero-cluster-badge');
        if (slot)
            return slot;
        const chip = document.getElementById('hero-insider-net-chip');
        if (chip && chip.parentElement)
            return chip.parentElement;
        return null;
    }
    function _paint(ticker, c) {
        const stale = document.getElementById(SLOT_ID);
        if (stale)
            stale.remove();
        if (!c)
            return;
        const host = _host();
        if (!host)
            return;
        const el = document.createElement('button');
        el.id = SLOT_ID;
        el.type = 'button';
        // DS-4c: canonical .pill base + .cluster-badge (positioning + the 44px
        // tappable ::after hook) + the severity modifier. DESIGN CYCLE 2026-06-25:
        // the label is prose -> .pill's Geist Sans is brand-correct (was Mono).
        el.className = 'pill cluster-badge cluster-badge--' + tier(c);
        el.setAttribute('aria-label', 'Insider cluster: ' + buildText(c) + ' — open details');
        el.title = 'View cluster detail + source filings';
        const dot = document.createElement('span');
        dot.className = 'pill__dot';
        const text = document.createElement('span');
        text.className = 'cluster-badge-text';
        text.textContent = buildText(c);
        el.appendChild(dot);
        el.appendChild(text);
        el.onclick = function () { openDetail(ticker, c); }; // 5E.2 verify panel
        host.appendChild(el);
    }
    // ── 5E.2 verification panel (the COUNSEL receipt) ───────────────────────────
    // Clicking the chip opens a slide-over: the descriptive σ/component breakdown
    // (moved off the chip per the OWNER plain-first ruling) + the per-transaction
    // Form-4 rows, each linking to its SEC EDGAR source, + the mandatory audit
    // disclaimer. Descriptive only (§3.5 / #16 gate). DOM is createElement only.
    const OVERLAY_ID = 'cluster-detail-overlay';
    function _closeDetail() {
        const ov = document.getElementById(OVERLAY_ID);
        if (ov)
            ov.remove();
        document.removeEventListener('keydown', _onKey);
    }
    function _onKey(e) {
        if (e.key === 'Escape')
            _closeDetail();
    }
    function _row(label, value) {
        const r = document.createElement('div');
        r.className = 'cluster-detail-row';
        const k = document.createElement('span');
        k.className = 'cluster-detail-k';
        k.textContent = label;
        const v = document.createElement('span');
        v.className = 'cluster-detail-v';
        v.textContent = value;
        r.appendChild(k);
        r.appendChild(v);
        return r;
    }
    function _explain(c) {
        const n = typeof c.insider_count === 'number' ? c.insider_count : 0;
        const act = c.direction === 'sell' ? 'open-market sells' : 'open-market purchases';
        let s = n + ' distinct insider' + (n === 1 ? '' : 's') + ' filed ' + act
            + ' in the last 30 days';
        if (typeof c.z_score === 'number') {
            s += ' — ' + c.z_score.toFixed(1) + 'σ above its own 2-year average for a 30-day window';
        }
        else if (typeof c.percentile === 'number') {
            s += ' — in the ' + Math.round(c.percentile) + 'th percentile of its own 2-year history';
        }
        return s + '.';
    }
    function _txnRows(panel, ticker) {
        if (typeof fetch === 'undefined')
            return;
        // FE P1-2: routed through _insidersFetch (typed+deduped OLApi wrapper
        // preferred; timeout-bounded fallback). Panel still fails closed.
        _insidersFetch(ticker)
            .then(function (data) {
            const txns = (data && Array.isArray(data.transactions)) ? data.transactions : [];
            const wrap = panel.querySelector('.cluster-detail-txns');
            if (!wrap)
                return;
            if (txns.length === 0) {
                const empty = document.createElement('div');
                empty.className = 'cluster-detail-muted';
                empty.textContent = 'Source filings load from SEC EDGAR.';
                wrap.appendChild(empty);
                return;
            }
            txns.slice(0, 10).forEach(function (t) {
                const row = document.createElement('div');
                row.className = 'cluster-detail-txn';
                const pos = String(t.position || t.title || 'Insider');
                const typ = String(t.transType || '');
                const sh = (typeof t.shares === 'number') ? Math.round(t.shares).toLocaleString() + ' sh' : '';
                const dt = String(t.filingDate || '');
                // OWNER 2026-09-24 (label on lists, exclude from counts): the
                // cluster never counted this row; the list says why. Same sentence
                // as pg_db/queries/form4_issuer_as_insider.py ISSUER_SELF_FILED_NOTE.
                const selfFiled = t.issuerSelfFiled === true
                    ? "Filed under the company's own SEC ID: the reporting-owner field names the company, not a person." + ' Not counted in the cluster.'
                    : '';
                row.textContent = [pos, typ, sh, dt, selfFiled].filter(Boolean).join(' · ');
                const url = t.url ? String(t.url) : '';
                if (url) {
                    const a = document.createElement('a');
                    a.href = url;
                    a.target = '_blank';
                    a.rel = 'noopener';
                    a.className = 'cluster-detail-src';
                    a.textContent = 'Form 4 →';
                    row.appendChild(document.createTextNode(' '));
                    row.appendChild(a);
                }
                wrap.appendChild(row);
            });
        })
            .catch(function () { });
    }
    function openDetail(ticker, c) {
        _closeDetail();
        const ov = document.createElement('div');
        ov.id = OVERLAY_ID;
        ov.className = 'cluster-detail-overlay';
        ov.addEventListener('click', function (e) {
            if (e.target === ov)
                _closeDetail();
        });
        const panel = document.createElement('div');
        panel.className = 'cluster-detail-panel';
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('aria-label', 'Insider cluster detail for ' + ticker);
        const head = document.createElement('div');
        head.className = 'cluster-detail-head';
        const h = document.createElement('span');
        h.className = 'cluster-detail-title';
        h.textContent = 'Insider cluster · ' + ticker;
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'cluster-detail-close';
        close.setAttribute('aria-label', 'Close');
        close.textContent = '×';
        close.onclick = _closeDetail;
        head.appendChild(h);
        head.appendChild(close);
        const summary = document.createElement('div');
        summary.className = 'cluster-detail-summary cluster-badge--' + tier(c);
        summary.textContent = buildText(c);
        const explain = document.createElement('p');
        explain.className = 'cluster-detail-explain';
        explain.textContent = _explain(c);
        const breakdown = document.createElement('div');
        breakdown.className = 'cluster-detail-breakdown';
        const n = typeof c.insider_count === 'number' ? c.insider_count : 0;
        breakdown.appendChild(_row('Distinct insiders', String(n) + (typeof c.filing_row_count === 'number' ? ' (from ' + c.filing_row_count + ' filings)' : '')));
        breakdown.appendChild(_row('Company-baseline', typeof c.z_score === 'number' ? c.z_score.toFixed(1) + 'σ above 2-yr norm' : 'baseline too flat for a z'));
        breakdown.appendChild(_row('Sector-normalized', typeof c.sector_z_score === 'number'
            ? c.sector_z_score.toFixed(1) + 'σ (' + (c.sector_baseline_level || 'specific') + ')'
            : 'sector lens unavailable'));
        if (typeof c.percentile === 'number') {
            breakdown.appendChild(_row('Percentile', Math.round(c.percentile) + 'th vs 2-yr history'));
        }
        const txnsHead = document.createElement('div');
        txnsHead.className = 'cluster-detail-subhead';
        txnsHead.textContent = 'Source filings (SEC EDGAR Form 4)';
        const txns = document.createElement('div');
        txns.className = 'cluster-detail-txns';
        const footer = document.createElement('div');
        footer.className = 'cluster-detail-footer';
        footer.textContent = 'Our conviction read, computed from public SEC Form 4 filings. '
            + 'Informational only — not investment advice.';
        panel.appendChild(head);
        panel.appendChild(summary);
        panel.appendChild(explain);
        panel.appendChild(breakdown);
        panel.appendChild(txnsHead);
        panel.appendChild(txns);
        panel.appendChild(footer);
        ov.appendChild(panel);
        document.body.appendChild(ov);
        document.addEventListener('keydown', _onKey);
        _txnRows(panel, ticker);
    }
    // ── 5E.5 composed thesis card (the "screenshot moment") ─────────────────────
    // The OWNER-ratified "thesis card, not disjoint chips" surface. v1 is the
    // DEGRADED 2-signal card (counts + baseline state) — the track-record sentence
    // is 5C.5-gated and simply absent (no new logic; the card is the 2-signal
    // render by construction). PLAIN-FIRST per the 2026-06-02 panel: the headline
    // reuses the chip wording and the magnitude is glossed in plain English (no
    // Greek on the card); the precise σ is one [Verify] click away (5E.2).
    // Mounts as a STABLE sibling BEFORE #insider-activity — never inside it, which
    // renderInsiderActivity() wholly replaces via innerHTML (feedback_never_destroy_dom
    // sibling rule). createElement only.
    const CARD_ID = 'cluster-thesis-card';
    // plain gloss of the company-baseline magnitude — descriptive, no σ (§3.5/#16).
    function _glossBaseline(c) {
        const z = typeof c.z_score === 'number' ? c.z_score : null;
        if (z !== null) {
            if (z >= 3.0)
                return 'Unusually heavy versus its own 2-year history';
            if (z >= 2.5)
                return 'Heavier than usual versus its own 2-year history';
            return 'Above its typical 30-day pace';
        }
        const p = typeof c.percentile === 'number' ? c.percentile : null;
        if (p !== null && p >= 95)
            return 'Among the heaviest 30-day windows in its 2-year history';
        return 'Notable versus its recent history';
    }
    // ── 5E.6 share artifact (the screenshot, exported) ──────────────────────────
    // Renders the descriptive thesis as a 1200×630 (OG ratio) PNG with the
    // Oxford Ledge frame, an as-of timestamp watermark, and — per COUNSEL — the
    // audit-provenance disclaimer BAKED ONTO THE IMAGE (a shared PNG travels
    // without the page, so the disclaimer must ride with it). PLAIN-FIRST: the
    // image carries the same plain headline + gloss as the card; NO σ. Copies to
    // clipboard with a download fallback. Self-contained (own roundRect + export).
    function _ccRound(ctx, x, y, w, h, r) {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.arcTo(x + w, y, x + w, y + h, r);
        ctx.arcTo(x + w, y + h, x, y + h, r);
        ctx.arcTo(x, y + h, x, y, r);
        ctx.arcTo(x, y, x + w, y, r);
        ctx.closePath();
    }
    function _ccWrap(ctx, text, x, y, maxW, lh) {
        const words = text.split(' ');
        let line = '';
        let yy = y;
        for (let i = 0; i < words.length; i++) {
            const test = line ? line + ' ' + words[i] : words[i];
            if (ctx.measureText(test).width > maxW && line) {
                ctx.fillText(line, x, yy);
                line = words[i];
                yy += lh;
            }
            else {
                line = test;
            }
        }
        if (line) {
            ctx.fillText(line, x, yy);
            yy += lh;
        }
        return yy;
    }
    function _toast(msg, kind) {
        try {
            const st = window.showToast;
            if (typeof st === 'function')
                st(msg, kind);
        }
        catch (_e) { /* toast is best-effort */ }
    }
    function _shareClusterCard(ticker, c) {
        const t = (ticker || '').toUpperCase().trim();
        const W = 1200, H = 630;
        const canvas = document.createElement('canvas');
        canvas.width = W;
        canvas.height = H;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            _toast('Unable to render the share image.', 'error');
            return;
        }
        const BG = '#0d1117', CARD = '#131920', PRIMARY = '#e8edf2', SECONDARY = '#8fa3b8', MUTED = '#6b7280';
        const isHigh = tier(c) === 'high';
        const ACCENT = isHigh ? '#c9a84c' : '#3d7ab8';
        ctx.fillStyle = BG;
        ctx.fillRect(0, 0, W, H);
        ctx.fillStyle = ACCENT;
        ctx.fillRect(0, 0, W, 8);
        ctx.fillStyle = CARD;
        _ccRound(ctx, 40, 40, W - 80, H - 80, 16);
        ctx.fill();
        ctx.fillStyle = ACCENT;
        ctx.fillRect(40, 40, 6, H - 80);
        ctx.textBaseline = 'top';
        ctx.textAlign = 'left';
        ctx.font = '600 22px "Geist Mono", "SF Mono", Consolas, monospace';
        ctx.fillStyle = ACCENT;
        ctx.fillText('INSIDER CLUSTER', 80, 80);
        ctx.font = '600 88px "Instrument Serif", Georgia, serif';
        ctx.fillStyle = PRIMARY;
        ctx.fillText('$' + t, 80, 118);
        ctx.font = '600 44px -apple-system, "Segoe UI", Helvetica, Arial, sans-serif';
        ctx.fillStyle = PRIMARY;
        const afterHead = _ccWrap(ctx, buildText(c), 80, 248, W - 200, 54);
        ctx.font = '28px -apple-system, "Segoe UI", Helvetica, Arial, sans-serif';
        ctx.fillStyle = SECONDARY;
        const gloss = _glossBaseline(c)
            + (typeof c.sector_z_score === 'number' && c.sector_z_score < 0.5
                && typeof c.z_score === 'number' && c.z_score >= 2.5 ? ' · contra-sector' : '') + '.';
        _ccWrap(ctx, gloss, 80, Math.max(afterHead + 14, 360), W - 200, 38);
        // divider + baked disclaimer (COUNSEL: must be ON the image)
        ctx.strokeStyle = 'rgba(139,148,158,0.25)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(80, H - 150);
        ctx.lineTo(W - 80, H - 150);
        ctx.stroke();
        ctx.font = '20px -apple-system, "Segoe UI", Helvetica, Arial, sans-serif';
        ctx.fillStyle = MUTED;
        _ccWrap(ctx, 'Descriptive signal from public SEC Form 4 filings. Informational only — not investment advice.', 80, H - 132, W - 160, 26);
        let asOf = '';
        try {
            const we = c.window_end ? new Date(c.window_end) : new Date();
            if (!isNaN(we.getTime()))
                asOf = we.toISOString().slice(0, 10);
        }
        catch (_e) {
            asOf = '';
        }
        ctx.font = '18px -apple-system, "Segoe UI", Helvetica, Arial, sans-serif';
        ctx.fillStyle = SECONDARY;
        ctx.fillText(asOf ? 'As of ' + asOf : '', 80, H - 70);
        ctx.textAlign = 'right';
        ctx.font = 'italic 18px "Instrument Serif", Georgia, serif';
        ctx.fillStyle = 'rgba(201,168,76,0.55)';
        ctx.fillText('Deep Insights, Deep Conviction', W - 80, H - 90);
        ctx.font = '18px -apple-system, "Segoe UI", Helvetica, Arial, sans-serif';
        ctx.fillStyle = 'rgba(139,148,158,0.6)';
        ctx.fillText('oxfordledge.com', W - 80, H - 66);
        ctx.textAlign = 'left';
        canvas.toBlob(function (blob) {
            if (!blob) {
                _toast('Unable to generate the share image.', 'error');
                return;
            }
            const wc = window;
            if (navigator.clipboard && typeof wc.ClipboardItem !== 'undefined' && wc.ClipboardItem) {
                const Ctor = wc.ClipboardItem;
                navigator.clipboard.write([new Ctor({ 'image/png': blob })])
                    .then(function () { _toast('Cluster card copied to clipboard', 'success'); })
                    .catch(function () { _ccDownload(blob, t); });
            }
            else {
                _ccDownload(blob, t);
            }
        }, 'image/png');
    }
    function _ccDownload(blob, ticker) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = (ticker || 'cluster') + '-insider-cluster.png';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        _toast('Cluster card downloaded as PNG', 'success');
    }
    function renderThesisCard(ticker) {
        const t = (ticker || '').toUpperCase().trim();
        const stale = document.getElementById(CARD_ID);
        if (stale)
            stale.remove();
        if (!t)
            return;
        const anchor = document.getElementById('insider-activity');
        if (!anchor || !anchor.parentElement)
            return;
        function paint(c) {
            const old = document.getElementById(CARD_ID);
            if (old)
                old.remove();
            if (!c)
                return;
            const a = document.getElementById('insider-activity');
            if (!a || !a.parentElement)
                return;
            const card = document.createElement('div');
            card.id = CARD_ID;
            card.className = 'cluster-thesis cluster-thesis--' + tier(c);
            card.setAttribute('role', 'region');
            card.setAttribute('aria-label', 'Insider cluster thesis for ' + t);
            const eyebrow = document.createElement('div');
            eyebrow.className = 'cluster-thesis-eyebrow';
            eyebrow.textContent = 'Insider cluster';
            const headline = document.createElement('div');
            headline.className = 'cluster-thesis-headline';
            headline.textContent = buildText(c); // chip-parity wording
            const gloss = document.createElement('div');
            gloss.className = 'cluster-thesis-gloss';
            gloss.textContent = _glossBaseline(c)
                + (typeof c.sector_z_score === 'number' && c.sector_z_score < 0.5
                    && typeof c.z_score === 'number' && c.z_score >= 2.5
                    ? ' · contra-sector' : '')
                + '.';
            const actions = document.createElement('div');
            actions.className = 'cluster-thesis-actions';
            const verify = document.createElement('button');
            verify.type = 'button';
            verify.className = 'cluster-thesis-verify';
            verify.textContent = 'Verify';
            verify.setAttribute('aria-label', 'Verify this cluster — source Form 4 filings');
            verify.onclick = function () { openDetail(t, c); }; // 5E.2 receipt
            actions.appendChild(verify);
            const share = document.createElement('button'); // 5E.6 share artifact
            share.type = 'button';
            share.className = 'cluster-thesis-share';
            share.textContent = 'Share';
            share.setAttribute('aria-label', 'Share this cluster as an image');
            share.onclick = function () { _shareClusterCard(t, c); };
            actions.appendChild(share);
            const foot = document.createElement('div');
            foot.className = 'cluster-thesis-foot';
            foot.textContent = 'Our conviction read · public SEC Form 4 filings · informational only.';
            card.appendChild(eyebrow);
            card.appendChild(headline);
            card.appendChild(gloss);
            card.appendChild(actions);
            card.appendChild(foot);
            a.parentElement.insertBefore(card, a);
        }
        if (Object.prototype.hasOwnProperty.call(_cache, t)) {
            paint(_cache[t]);
            return;
        }
        if (typeof fetch === 'undefined')
            return;
        _clusterFetch(t)
            .then(function (data) {
            const list = (data && Array.isArray(data.clusters)) ? data.clusters : [];
            const top = list.length > 0 ? list[0] : null;
            _cache[t] = top;
            paint(top);
        })
            .catch(function () { });
    }
    function render(ticker) {
        const t = (ticker || '').toUpperCase().trim();
        if (!t) {
            _paint('', null);
            return;
        }
        if (Object.prototype.hasOwnProperty.call(_cache, t)) {
            _paint(t, _cache[t]);
            renderThesisCard(t);
            return;
        }
        if (typeof fetch === 'undefined')
            return;
        _clusterFetch(t)
            .then(function (data) {
            const list = (data && Array.isArray(data.clusters)) ? data.clusters : [];
            const top = list.length > 0 ? list[0] : null; // 5D returns newest-window-first
            _cache[t] = top;
            _paint(t, top);
            renderThesisCard(t); // 5E.5 — reuses the same cached cluster
        })
            .catch(function () { });
    }
    window.OLClusterBadge = {
        render: render,
        renderThesisCard: renderThesisCard,
        buildText: buildText,
        tier: tier,
    };
})();
//# sourceMappingURL=cluster-badge.js.map
;
// ═══ cluster-fire-banner.js ═══
;"use strict";
// ── cluster-fire-banner.ts ─────────────────────────────────────────────────
// SF-5 5E.4 — watchlist cluster-fire banner.
//
// Surfaces RECENT insider-cluster fires across the user's watchlist tickers as
// an ambient, dismissible strip above the watchlist table. Reads the FREE
// GET /api/insiders/clusters/recent?tickers=... endpoint.
//
// DESCRIPTIVE only (OWNER 2026-06-02 copy panel): plain-first copy, NO σ in the
// surfaced banner (the precise magnitude lives in the 5E.2 verify panel reached
// by clicking through to the ticker). Never a forecast — the §3.5 forbidden-
// language set is CI-gated by tests/test_sf5_informational_only_contract.py
// (the #16 gate also greps this file).
//
// Ambient > intrusive (feedback_zero_ux_friction): caps at 3 fires, hidden when
// none, and each fire is dismissible with a 7-day persisted dismissal so a
// fire the user has already seen doesn't re-nag on every watchlist visit.
//
// Build artifact: cluster-fire-banner.js is emitted by tools/build_bundle.py
// (this .ts is the source of truth). Wired into the core-utils chunk.
(function () {
    'use strict';
    const MOUNT_ID = 'cluster-fire-banner';
    const ANCHOR_ID = 'wl-table-wrap'; // banner is prepended above the table
    const DISMISS_KEY = 'ol_cluster_fire_dismissed';
    const DISMISS_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
    const MAX_ITEMS = 3;
    let _inflight = false;
    function _w() {
        return window;
    }
    // ── dismissal persistence (7-day TTL, self-pruning) ───────────────────────
    function _eventKey(c) {
        return [(c.ticker || '').toUpperCase(), c.direction || '', c.window_end || ''].join('|');
    }
    function _loadDismissed() {
        let raw = {};
        try {
            const w = _w();
            if (w.OLStorage && typeof w.OLStorage.get === 'function') {
                raw = w.OLStorage.get(DISMISS_KEY, {}) || {};
            }
            else {
                // eslint-disable-next-line ol/no-direct-localstorage -- load-order fallback only: cluster-fire-banner is in the core-utils chunk and can evaluate before OLStorage (storage.js) registers on window; the branch above prefers the wrapper when present. Best-effort dismissal persistence, failure is non-fatal.
                raw = JSON.parse(localStorage.getItem(DISMISS_KEY) || '{}');
            }
        }
        catch (_e) {
            raw = {};
        }
        // prune entries older than the TTL so the map can't grow unbounded
        const now = Date.now();
        const pruned = {};
        let changed = false;
        Object.keys(raw).forEach(function (k) {
            if (now - (raw[k] || 0) < DISMISS_TTL_MS)
                pruned[k] = raw[k];
            else
                changed = true;
        });
        if (changed)
            _saveDismissed(pruned);
        return pruned;
    }
    function _saveDismissed(map) {
        try {
            const w = _w();
            if (w.OLStorage && typeof w.OLStorage.set === 'function')
                w.OLStorage.set(DISMISS_KEY, map);
            // eslint-disable-next-line ol/no-direct-localstorage -- write-companion to _loadDismissed's load-order fallback (OLStorage may not be on window yet in core-utils); best-effort, non-fatal.
            else
                localStorage.setItem(DISMISS_KEY, JSON.stringify(map));
        }
        catch (_e) { /* storage unavailable — degrade to non-persistent */ }
    }
    function _dismiss(key) {
        const map = _loadDismissed();
        map[key] = Date.now();
        _saveDismissed(map);
        const el = document.getElementById(MOUNT_ID);
        if (!el)
            return;
        const item = el.querySelector('[data-cfb-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
        if (item && item.parentElement)
            item.parentElement.removeChild(item);
        // if that was the last fire, retire the whole strip
        if (!el.querySelector('.cfb-item'))
            el.remove();
    }
    // ── copy (plain-first; reuse the badge's exact wording when present) ──────
    function _itemText(c) {
        const w = _w();
        if (w.OLClusterBadge && typeof w.OLClusterBadge.buildText === 'function') {
            return w.OLClusterBadge.buildText(c);
        }
        // fallback (badge chunk not yet loaded) — same plain-first idiom, no σ
        const n = typeof c.insider_count === 'number' ? c.insider_count : 0;
        const sell = c.direction === 'sell';
        let s = (sell ? 'Insider selling' : 'Insider buying') + ' · ' + n
            + (sell ? ' sell' : ' insider') + (n === 1 ? '' : 's');
        const z = typeof c.z_score === 'number' ? c.z_score : null;
        const sz = typeof c.sector_z_score === 'number' ? c.sector_z_score : null;
        if (z !== null && z >= 2.5 && sz !== null && sz < 0.5)
            s += ' · contra-sector';
        return s;
    }
    function _tierClass(c) {
        const w = _w();
        if (w.OLClusterBadge && typeof w.OLClusterBadge.tier === 'function')
            return w.OLClusterBadge.tier(c);
        const n = typeof c.insider_count === 'number' ? c.insider_count : 0;
        return n >= 5 ? 'high' : n >= 4 ? 'medium' : 'low';
    }
    function _esc(s) {
        return s.replace(/[&<>"']/g, function (ch) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch] || ch;
        });
    }
    // ── render ────────────────────────────────────────────────────────────────
    function _watchlistTickers() {
        const wl = _w().wlData || [];
        const out = [];
        const seen = {};
        wl.forEach(function (e) {
            const t = (e && e.ticker ? String(e.ticker) : '').toUpperCase().trim();
            if (t && !seen[t]) {
                seen[t] = true;
                out.push(t);
            }
        });
        return out;
    }
    function _paint(items) {
        const old = document.getElementById(MOUNT_ID);
        if (old)
            old.remove();
        if (!items.length)
            return;
        const anchor = document.getElementById(ANCHOR_ID);
        if (!anchor || !anchor.parentElement)
            return;
        const box = document.createElement('div');
        box.id = MOUNT_ID;
        box.className = 'cfb-banner';
        box.setAttribute('role', 'region');
        box.setAttribute('aria-label', 'Recent insider-cluster activity on your watchlist');
        const head = document.createElement('div');
        head.className = 'cfb-head';
        head.textContent = items.length === 1
            ? 'Insider cluster on your watchlist'
            : items.length + ' insider clusters on your watchlist';
        box.appendChild(head);
        items.forEach(function (c) {
            const tk = (c.ticker || '').toUpperCase();
            const row = document.createElement('div');
            row.className = 'cfb-item cfb-item--' + _tierClass(c);
            row.setAttribute('data-cfb-key', _eventKey(c));
            // clickthrough opens the ticker (existing global delegated action) — the
            // hero then paints the 5E.2 verify-panel-bearing cluster badge.
            row.innerHTML =
                '<button type="button" class="cfb-go" data-action="switch-ticker" data-ticker="' + _esc(tk) + '"'
                    + ' aria-label="Open ' + _esc(tk) + ' — ' + _esc(_itemText(c)) + '">'
                    + '<span class="cfb-tkr">$' + _esc(tk) + '</span>'
                    + '<span class="cfb-txt">' + _esc(_itemText(c)) + '</span>'
                    + '</button>'
                    + '<button type="button" class="cfb-x" data-cfb-dismiss="' + _esc(_eventKey(c)) + '"'
                    + ' aria-label="Dismiss ' + _esc(tk) + ' cluster">×</button>';
            box.appendChild(row);
        });
        anchor.parentElement.insertBefore(box, anchor);
        // dismiss handler — delegated on the strip; switch-ticker bubbles to global
        box.addEventListener('click', function (ev) {
            const t = ev.target;
            const x = t && t.closest ? t.closest('[data-cfb-dismiss]') : null;
            if (x) {
                ev.preventDefault();
                ev.stopPropagation();
                const k = x.getAttribute('data-cfb-dismiss') || '';
                if (k)
                    _dismiss(k);
            }
        });
    }
    function check() {
        if (_inflight)
            return;
        const tickers = _watchlistTickers();
        if (!tickers.length) {
            const o = document.getElementById(MOUNT_ID);
            if (o)
                o.remove();
            return;
        }
        if (typeof isLive !== 'undefined' && !isLive)
            return;
        _inflight = true;
        const joined = tickers.slice(0, 50).join(',');
        // FE P1-2 (2026-07-11): prefer the typed + deduped OLApi wrapper (30s
        // TTL + in-flight share + 429 cooldown); timeout-bounded raw fallback
        // only for the cold-start chunk race (b74549eb). Was a raw fetch with
        // no dedup/timeout co-mounting with the cluster-badge insider fetches.
        const _ow = window;
        const _p = (_ow.OLApi && typeof _ow.OLApi.getInsiderClustersRecent === 'function')
            ? _ow.OLApi.getInsiderClustersRecent(joined).catch(function () { return null; })
            // raw-fetch fallback: cold-start fallback before the deferred api-client module registers OLApi (b74549eb); timeout-bounded, fails closed
            : fetch('/api/insiders/clusters/recent?tickers=' + encodeURIComponent(joined), { credentials: 'same-origin', signal: AbortSignal.timeout(15000) })
                .then(function (r) {
                return r.ok ? r.json() : null;
            })
                .catch(function () { return null; });
        _p
            .then(function (data) {
            const all = (data && Array.isArray(data.clusters)) ? data.clusters : [];
            const dismissed = _loadDismissed();
            const fresh = all.filter(function (c) { return !dismissed[_eventKey(c)]; });
            _paint(fresh.slice(0, MAX_ITEMS));
        })
            .catch(function () { })
            .finally(function () { _inflight = false; });
    }
    _w().OLClusterFireBanner = { check: check };
})();
//# sourceMappingURL=cluster-fire-banner.js.map
;
// ═══ provenance-registry.js ═══
;"use strict";
/**
 * Provenance source registry + ol-prov chip primitive — wave 0 (SPA half).
 * Plan: docs/plans/PROVENANCE_SYSTEM_DESIGN_CONTRACT.md (DEC-4
 * OWNER-ratified 2026-08-17).
 *
 * MIRROR, not source of truth: keys and labels must stay byte-identical
 * to PROVENANCE_SOURCES in services/provenance_registry.py — the parity
 * contract in tests/test_provenance_wave0_contract.py compares the two.
 *
 * DORMANT IN WAVE 0: no call sites until wave 1 converts the credit
 * family (.refi-provenance string blobs) onto this primitive. Zero
 * visual change is the wave-0 contract — do not call OLProv.render from
 * a renderer in this wave.
 *
 * The chip carries the B2 triad (period · as_of · source); period is
 * optional per render. `asOf` is the DATA's date, never Date.now() —
 * a renderer that cannot obtain a data date renders NO chip rather
 * than a wrong one (honest-absent over fabricated-present).
 *
 * B12 (OWNER-ratified 2026-08-25): vendor keys are per-provider AND
 * per-family, never a collapsed "market data" label; no key is minted
 * before its display-licensing position is read from the signed
 * agreement (absence from the registry is the enforcement, B9 shape).
 * Every entry declares family ('price' | 'reference'); the delay gate
 * derives from the ENTRY, not from PRICE_FAMILY_KEYS membership -- the
 * hand-list check FAILED OPEN. Python half is the SoT for the full rule.
 */
(function () {
    // Keys/labels mirrored from services/provenance_registry.py — B4
    // (ol-derived vs vendor-derived split) and B8 (no collapsed
    // "finnhub-fmp"; price keys are per-provider, minted only with a
    // verified delayClass) are enforced on the Python side and pinned by
    // the parity contract here.
    const SOURCES = {
        'sec-edgar': { label: 'SEC EDGAR', methodology: null, family: 'reference' },
        'bls-bea': { label: 'BLS / BEA', methodology: null, family: 'reference' },
        // Bank surface (DESIGN R1, 2026-09-04): FDIC BankFind call-report data.
        'fdic-bankfind': { label: 'FDIC BankFind', methodology: null, family: 'reference' },
        'sec-8k-kpi': { label: 'SEC filings', methodology: null, family: 'reference' },
        'fred': { label: 'FRED', methodology: null, family: 'reference' },
        'ol-derived': { label: 'Oxford Ledge analysis', methodology: null, family: 'reference' },
        'vendor-derived': { label: 'vendor-computed metric', methodology: null, family: 'reference' },
    };
    // B3 mirror: empty until a provider's delay class is verified against
    // its terms; a key listed here without delayClass renders NO chip.
    const PRICE_FAMILY_KEYS = [];
    const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    // Positional parse, never `new Date(iso)` — an ISO date through the
    // Date constructor shifts a day west of UTC, and a provenance chip
    // that is one day wrong is worse than none.
    // `forceYear` suppresses the current-year elision. Elision is fine for ONE
    // date — an unqualified "Aug 20" is unambiguously this year — and misleading
    // inside a RANGE. See the range branch in render().
    function fmtAsOf(iso, forceYear) {
        const parts = (iso || '').split('-');
        if (parts.length !== 3)
            return '';
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);
        if (!year || !month || !day || month > 12 || day > 31)
            return '';
        const label = MONTHS[month - 1] + ' ' + day;
        if (forceYear)
            return label + ', ' + year;
        return year === new Date().getFullYear() ? label : label + ', ' + year;
    }
    function esc(text) {
        return text.replace(/&/g, '&amp;').replace(/</g, '&lt;')
            .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function render(fields) {
        const entry = SOURCES[fields.source];
        const asofLabel = fmtAsOf(fields.asOf);
        if (!entry || !asofLabel)
            return '';
        // A missing / unparseable / non-later end degrades to the single-date
        // chip rather than being reinterpreted — the floor is always safe.
        let asofDisplay = asofLabel;
        const latestLabel = fields.asOfLatest ? fmtAsOf(fields.asOfLatest) : '';
        const hasRange = !!latestLabel && fields.asOfLatest > fields.asOf;
        // CROSS-YEAR RANGES CARRY BOTH YEARS (2026-08-21). Current-year elision is
        // correct for a single date and MISLEADING inside a range. Found by
        // rendering the live chip to a human — the check the ruling-B Pattern-K
        // artifact named as still outstanding: /?view=credit published
        // `Sep 30, 2025 – Aug 20` for {earliest 2025-09-30, latest 2026-08-20}. A
        // reader takes the explicit "2025", meets an unqualified "Aug 20", and
        // reads the span as ENDING BEFORE IT BEGAN — the chip understated its own
        // freshness by eleven months on a surface whose only job is stating a
        // date. Elision is kept for the same-year case, where both endpoints share
        // the one implied year and no such misreading is available.
        if (hasRange) {
            const sameYear = fields.asOf.slice(0, 4)
                === fields.asOfLatest.slice(0, 4);
            asofDisplay = sameYear
                ? asofLabel + ' – ' + latestLabel
                : fmtAsOf(fields.asOf, true) + ' – '
                    + fmtAsOf(fields.asOfLatest, true);
        }
        // B12 (2026-08-25): derive from the ENTRY's family -- the hand-list
        // membership check FAILED OPEN for a price key omitted from the list.
        const isPrice = entry.family === 'price';
        if (isPrice && !entry.delayClass)
            return '';
        let srcLabel = esc(entry.label);
        if (isPrice && entry.delayClass)
            srcLabel += ' · ' + esc(entry.delayClass);
        const srcHtml = fields.methodology
            ? '<a class="ol-prov-src" href="/methodology/' + esc(fields.methodology)
                + '">' + srcLabel + '</a>'
            : '<span class="ol-prov-src">' + srcLabel + '</span>';
        const periodHtml = fields.period
            ? '<span class="ol-prov-period">' + esc(fields.period) + '</span> · '
            : '';
        const latestAttr = hasRange
            ? ' data-as-of-latest="' + esc(fields.asOfLatest) + '"'
            : '';
        return '<span class="ol-prov" data-as-of="' + esc(fields.asOf) + '"' + latestAttr
            + ' data-source="' + esc(fields.source) + '">'
            + periodHtml
            // P0-2 (2026-08-25): separator as DOM text (see the Python twin).
            + '<span class="ol-prov-asof">' + esc(asofDisplay) + '</span> · '
            + srcHtml
            + '</span>';
    }
    window.OLProv = {
        render: render,
        sources: SOURCES,
    };
})();
//# sourceMappingURL=provenance-registry.js.map
;
// ═══ feature-of-the-day.js ═══
;"use strict";
/**
 * Feature of the Day — unlocks one premium feature daily for free users.
 * Human-only (NEVER for API/MCP/SDK consumers).
 * Creates daily engagement habit and shows users what they're missing.
 *
 * TS Migration Phase 2 PR 23 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is now the SOURCE OF TRUTH; the sibling feature-of-the-day.js
 * is the build artifact produced by `npx tsc -p tsconfig.build.json`
 * (gitignored).
 *
 * NOTE: 2026-05-05 CYCLE5 #49: the previously-inline onclick="tryFOTD"
 * + onclick="dismissFOTD" handlers were CSP-blocked. Converted to
 * data-fotd-action delegation; the tryFOTD/dismissFOTD functions
 * remain accessible at the bottom of the file but are now invoked
 * through a closure-scoped event listener.
 */
const FOTD_FEATURES = [
    { id: '13f', name: '13F Holdings', desc: 'Track institutional portfolio positions from 1,050+ fund managers (Intermediate)', view: '13f', day: 0 },
    { id: 'credit', name: 'Bond Research', desc: 'Analyze corporate bonds, yields, and credit risk', view: 'credit', day: 1 },
    { id: 'screener', name: 'Stock Screener', desc: 'Screen stocks by earnings yield and return on capital', view: 'screener', day: 2 },
    { id: 'bdc', name: 'Private Credit', desc: 'Explore BDC holdings and leveraged loan data', view: 'bdc', day: 3 },
    { id: 'analytics', name: 'Portfolio Analytics', desc: 'Sharpe ratio, drawdown, and correlation analysis', view: 'portfolio', day: 4 },
    { id: 'estimates', name: 'Analyst Estimates', desc: 'Consensus EPS and revenue forecasts', view: 'ticker', day: 5 },
    { id: 'dividends', name: 'Dividend Forecast', desc: 'Project your annual dividend income', view: 'calendar', day: 6 },
];
function getTodayFeature() {
    const dayOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0).getTime()) / 86400000);
    return FOTD_FEATURES[dayOfYear % FOTD_FEATURES.length];
}
/** Returns ms until midnight local time */
function _fotdMsUntilMidnight() {
    const now = new Date();
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    return midnight.getTime() - now.getTime();
}
/** Formats the expiry label.
 *
 * 2026-06-19 audit Phase-4 [P0]: this used to tick down a live countdown
 * ("Available for 1h 23m" → "Expiring momentarily") as midnight approached —
 * a fake-urgency timer BRAND.md §Voice non-negotiable #3 explicitly bans
 * ("no hype, no urgency ... same rule for limited-time copy, fake scarcity,
 * or countdown timers"). Replaced with a calm, constant informational label
 * — the daily-rotation mechanic is unchanged, just no urgency ticking. */
function _fotdExpiryLabel() {
    return 'Refreshes daily';
}
let _fotdTimerInterval = null;
let _fotdTimers = [];
/** Tick the countdown; when midnight passes, lock the feature */
function _fotdStartTimer() {
    if (_fotdTimerInterval)
        clearInterval(_fotdTimerInterval);
    _fotdTimerInterval = setInterval(function () {
        const ms = _fotdMsUntilMidnight();
        // Day rolled over — feature expired
        if (ms > 86300000) { // >23h58m means we crossed midnight
            if (_fotdTimerInterval)
                clearInterval(_fotdTimerInterval);
            _fotdTimerInterval = null;
            _fotdExpire();
            return;
        }
        const el = document.getElementById('fotd-expiry');
        if (el)
            el.textContent = _fotdExpiryLabel();
    }, 30000); // update every 30s
}
/** Gracefully transition FOTD banner to locked state */
function _fotdExpire() {
    const banner = document.getElementById('fotd-banner');
    if (!banner)
        return;
    banner.style.transition = 'opacity 0.6s ease';
    banner.style.opacity = '0.5';
    banner.innerHTML = '<div>'
        + '<div class="fotd-label">FEATURE OF THE DAY</div>'
        + '<div class="fotd-expired-desc">Today\'s free feature has ended. Check back tomorrow for a new unlock.</div>'
        + '</div>';
    // Remove after a few seconds
    _fotdTimers.push(setTimeout(function () {
        if (banner && banner.parentNode) {
            banner.style.transition = 'opacity 1s ease';
            banner.style.opacity = '0';
            _fotdTimers.push(setTimeout(function () { if (banner.parentNode)
                banner.parentNode.removeChild(banner); }, 1000));
        }
    }, 8000));
}
function renderFeatureOfTheDay() {
    // Only show for free-tier human users
    if (typeof _userTier !== 'undefined' && _userTier !== 'free')
        return;
    // Don't show FOTD on LIVE/macro views — it's not relevant to market overview
    if (typeof currentView !== 'undefined' && (currentView === 'news' || currentView === 'macro' || currentView === 'watchlist')) {
        // Also hide any existing banner that may have been created before view switch
        const _existingBanner = document.getElementById('fotd-banner');
        if (_existingBanner)
            _existingBanner.classList.add('hidden');
        return;
    }
    // Don't show FOTD until user has explored enough — at least 20 page views
    let _fotdPageViews = 0;
    try {
        const _fotdAct = OLStorage.get('ol_user_activity', {});
        _fotdPageViews = (_fotdAct.tickersViewed ? _fotdAct.tickersViewed.length : 0) + (_fotdAct.sessionsCount || 0) * 3;
    }
    catch (_e) { }
    if (_fotdPageViews < 20)
        return;
    const feature = getTodayFeature();
    let dismissed = null;
    try {
        dismissed = OLStorage.getString('fotd_dismissed_' + new Date().toDateString(), null);
    }
    catch (_e) { }
    if (dismissed)
        return;
    // Create banner
    let banner = document.getElementById('fotd-banner');
    if (!banner) {
        banner = document.createElement('div');
        banner.id = 'fotd-banner';
        banner.className = 'fotd-banner-wrap';
        const content = document.querySelector('#content-wrapper') || document.querySelector('main');
        if (content)
            content.insertBefore(banner, content.firstChild);
    }
    const expiryText = _fotdExpiryLabel();
    banner.innerHTML = '<div>'
        + '<div class="fotd-label">FEATURE OF THE DAY</div>'
        + '<div class="fotd-name">' + feature.name + '</div>'
        + '<div class="fotd-desc">' + feature.desc + '</div>'
        + '<div id="fotd-expiry" class="fotd-expiry">' + expiryText + '</div>'
        + '</div>'
        + '<div class="fotd-actions">'
        + '<button data-fotd-action="try" data-fotd-view="' + feature.view + '" class="fotd-btn-try">Try it</button>'
        + '<button data-fotd-action="dismiss" class="fotd-btn-dismiss">Dismiss</button>'
        + '</div>';
    banner.classList.remove('hidden');
    // Start countdown timer
    _fotdStartTimer();
}
function tryFOTD(view) {
    // Dismiss the banner, switch to the feature's view, and scroll to top
    const banner = document.getElementById('fotd-banner');
    if (banner)
        banner.classList.add('hidden');
    if (typeof setView === 'function') {
        setView(view);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (typeof trackAchievement === 'function')
        trackAchievement('fotd_tried');
}
function dismissFOTD() {
    try {
        OLStorage.setString('fotd_dismissed_' + new Date().toDateString(), '1');
    }
    catch (_e) { }
    const banner = document.getElementById('fotd-banner');
    if (banner)
        banner.classList.add('hidden');
}
// Check if today's feature should bypass the feature gate for this user
function isFOTDUnlocked(endpointPath) {
    if (typeof _userTier !== 'undefined' && _userTier !== 'free')
        return false; // paid users don't need FOTD
    const feature = getTodayFeature();
    // Map feature IDs to endpoint prefixes
    const endpointMap = {
        '13f': '/api/13f',
        'credit': '/api/credit',
        'screener': '/api/screener',
        'bdc': '/api/bdc',
        'analytics': '/api/portfolio-analytics',
        'estimates': '/api/analyst',
        'dividends': '/api/dividend-forecast',
    };
    const prefix = endpointMap[feature.id];
    return !!(prefix && endpointPath.startsWith(prefix));
}
// ── Cleanup: clear all timers ──
function cleanupFeatureOfTheDay() {
    _fotdTimers.forEach(clearTimeout);
    _fotdTimers = [];
    if (_fotdTimerInterval) {
        clearInterval(_fotdTimerInterval);
        _fotdTimerInterval = null;
    }
}
// Auto-show on page load (delayed)
if (typeof document !== 'undefined') {
    _fotdTimers.push(setTimeout(renderFeatureOfTheDay, 3000));
}
// Suppress "declared but never read" — public top-level surfaces.
void cleanupFeatureOfTheDay;
void tryFOTD;
void dismissFOTD;
void isFOTDUnlocked;
// CSP-clean delegation (CYCLE5 #49, 2026-05-05).
let _fotdDelegationInstalled = false;
function _fotdInstallDelegation() {
    if (_fotdDelegationInstalled)
        return;
    _fotdDelegationInstalled = true;
    document.addEventListener('click', function (ev) {
        const tgt = ev.target;
        if (!tgt || !tgt.closest)
            return;
        const el = tgt.closest('[data-fotd-action]');
        if (!el)
            return;
        const action = el.getAttribute('data-fotd-action');
        switch (action) {
            case 'try': {
                const v = el.getAttribute('data-fotd-view') || '';
                if (v)
                    tryFOTD(v);
                return;
            }
            case 'dismiss':
                dismissFOTD();
                return;
        }
    });
}
_fotdInstallDelegation();
//# sourceMappingURL=feature-of-the-day.js.map
;
// ═══ tab-reorder.js ═══
;"use strict";
/**
 * Tab Reorder — drag-to-reorder ticker tabs.
 * Uses HTML5 Drag and Drop API.
 *
 * TS Migration Phase 2 PR 21 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is now the SOURCE OF TRUTH; the sibling tab-reorder.js
 * is the build artifact produced by `npx tsc -p tsconfig.build.json`
 * (gitignored).
 *
 * Cross-chunk: tickers + renderTabs + showToast (declared in
 * globals.d.ts).
 */
window.initTabReorder = function () {
    let _draggedTab = null;
    function initTabReorder() {
        const tabsContainer = document.getElementById('ticker-tabs');
        if (!tabsContainer)
            return;
        // Attach drag handlers to all .ticker-btn children that don't have them yet
        function attachDragHandlers() {
            if (!tabsContainer)
                return;
            const tabs = tabsContainer.querySelectorAll('.ticker-btn');
            tabs.forEach(function (tab) {
                if (tab.getAttribute('draggable'))
                    return; // already set
                tab.setAttribute('draggable', 'true');
                tab.style.cursor = 'grab';
                tab.addEventListener('dragstart', function (e) {
                    _draggedTab = tab;
                    tab.style.opacity = '0.4';
                    if (e.dataTransfer) {
                        e.dataTransfer.effectAllowed = 'move';
                        e.dataTransfer.setData('text/plain', tab.getAttribute('data-ticker') || tab.textContent || '');
                    }
                });
                tab.addEventListener('dragend', function () {
                    tab.style.opacity = '1';
                    _draggedTab = null;
                    // Remove all drag-over indicators
                    if (!tabsContainer)
                        return;
                    tabsContainer.querySelectorAll('.ticker-btn').forEach(function (t) {
                        t.style.borderLeft = '';
                        t.style.borderRight = '';
                    });
                });
                tab.addEventListener('dragover', function (e) {
                    e.preventDefault();
                    if (e.dataTransfer)
                        e.dataTransfer.dropEffect = 'move';
                    // Show insertion indicator
                    const rect = tab.getBoundingClientRect();
                    const midX = rect.left + rect.width / 2;
                    if (e.clientX < midX) {
                        tab.style.borderLeft = '2px solid var(--accent-blue)';
                        tab.style.borderRight = '';
                    }
                    else {
                        tab.style.borderRight = '2px solid var(--accent-blue)';
                        tab.style.borderLeft = '';
                    }
                });
                tab.addEventListener('dragleave', function () {
                    tab.style.borderLeft = '';
                    tab.style.borderRight = '';
                });
                tab.addEventListener('drop', function (e) {
                    e.preventDefault();
                    tab.style.borderLeft = '';
                    tab.style.borderRight = '';
                    if (!_draggedTab || _draggedTab === tab || !tabsContainer)
                        return;
                    // Determine insertion position
                    const rect = tab.getBoundingClientRect();
                    const midX = rect.left + rect.width / 2;
                    if (e.clientX < midX) {
                        tabsContainer.insertBefore(_draggedTab, tab);
                    }
                    else {
                        tabsContainer.insertBefore(_draggedTab, tab.nextSibling);
                    }
                    // Save tab order to localStorage
                    const order = [];
                    tabsContainer.querySelectorAll('.ticker-btn').forEach(function (t) {
                        const ticker = t.getAttribute('data-ticker') || (t.textContent || '').trim().split(/\s/)[0];
                        if (ticker)
                            order.push(ticker);
                    });
                    try {
                        OLStorage.set('ol_tab_order', order);
                    }
                    catch (_e) { }
                    // Sync the global tickers array so renderTabs() preserves order
                    if (typeof tickers !== 'undefined' && order.length > 0) {
                        const currentSet = new Set(tickers);
                        const synced = [];
                        for (let k = 0; k < order.length; k++) {
                            if (currentSet.has(order[k])) {
                                synced.push(order[k]);
                                currentSet.delete(order[k]);
                            }
                        }
                        currentSet.forEach(function (t) { synced.push(t); });
                        if (synced.length === tickers.length) {
                            tickers.length = 0;
                            for (let m = 0; m < synced.length; m++)
                                tickers.push(synced[m]);
                        }
                    }
                    if (typeof showToast === 'function')
                        showToast('Tab order saved', 'info', 1500);
                });
            });
        }
        // Observe for new tabs being added
        const observer = new MutationObserver(attachDragHandlers);
        observer.observe(tabsContainer, { childList: true });
        // Attach handlers to any tabs already in the DOM
        attachDragHandlers();
    }
    /**
     * Restore saved tab order from localStorage.
     * Reorders the global `tickers` array to match the saved order,
     * appending any new tickers not present in the saved order.
     */
    function restoreTabOrder() {
        if (typeof tickers === 'undefined')
            return;
        let saved = null;
        try {
            saved = OLStorage.getString('ol_tab_order', null);
        }
        catch (_e) { }
        if (!saved)
            return;
        try {
            const order = JSON.parse(saved);
            if (!Array.isArray(order) || order.length === 0)
                return;
            const currentSet = new Set(tickers);
            // Build new order: saved tickers that still exist, then any new ones
            const restored = [];
            for (let i = 0; i < order.length; i++) {
                if (currentSet.has(order[i])) {
                    restored.push(order[i]);
                    currentSet.delete(order[i]);
                }
            }
            // Append tickers not in saved order (newly added since last save)
            currentSet.forEach(function (t) { restored.push(t); });
            // Only reorder if we matched at least some saved tickers
            if (restored.length === tickers.length) {
                tickers.length = 0;
                for (let j = 0; j < restored.length; j++) {
                    tickers.push(restored[j]);
                }
                if (typeof renderTabs === 'function')
                    renderTabs();
            }
        }
        catch (_e) {
            // Corrupted localStorage — ignore
        }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initTabReorder();
            restoreTabOrder();
        });
    }
    else {
        initTabReorder();
        restoreTabOrder();
    }
};
//# sourceMappingURL=tab-reorder.js.map
;
// ═══ pull-refresh.js ═══
;"use strict";
/**
 * pull-refresh.js — Pull-to-Refresh + Offline Detection.
 *
 * TS Migration Phase 2 PR 25 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is the SOURCE OF TRUTH; pull-refresh.js is the build
 * artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
 *
 * Touch gesture handler for mobile devices. Installs:
 *   - A pull-down gesture that calls `refreshCurrent()` (when defined)
 *     once a 40px threshold is crossed at scrollTop=0.
 *   - An offline banner toggled by the browser online/offline events.
 *
 * Activation gates:
 *   - Touch-only: bails on init if the device lacks ontouchstart.
 *   - View whitelist: only fires on the active SPA view-panel; the
 *     fallback returns true so the gesture stays available on any
 *     view that scrolls to top (the explicit news/portfolio/macro
 *     check is preserved as documentation of original intent).
 */
(function () {
    'use strict';
    function _initPullRefresh() {
        'use strict';
        const PULL_THRESHOLD = 40;
        const MAX_PULL = 100;
        let startY = 0;
        let currentY = 0;
        let pulling = false;
        let refreshing = false;
        let indicator = null;
        let offlineBanner = null;
        function createIndicator() {
            indicator = document.createElement('div');
            indicator.className = 'pull-indicator';
            indicator.setAttribute('aria-live', 'polite');
            indicator.innerHTML =
                '<span class="pull-spinner">&#8635;</span>' +
                    '<span class="pull-text pr-text">Pull to refresh</span>';
            document.body.appendChild(indicator);
        }
        function createOfflineBanner() {
            offlineBanner = document.createElement('div');
            offlineBanner.className = 'offline-banner';
            offlineBanner.setAttribute('role', 'status');
            offlineBanner.setAttribute('aria-live', 'polite');
            offlineBanner.textContent = 'Offline — showing cached data';
            document.body.appendChild(offlineBanner);
        }
        function isPullableView() {
            const active = document.querySelector('.view-panel[style*="display: block"], .view-panel.active');
            if (!active)
                return true;
            const id = active.id || '';
            return /news|portfolio|overview|macro/.test(id) || true;
        }
        function onTouchStart(e) {
            if (refreshing)
                return;
            if (window.scrollY !== 0)
                return;
            if (!isPullableView())
                return;
            startY = e.touches[0].clientY;
            pulling = false;
        }
        function onTouchMove(e) {
            if (refreshing)
                return;
            if (window.scrollY !== 0) {
                resetPull();
                return;
            }
            currentY = e.touches[0].clientY;
            const delta = currentY - startY;
            if (delta <= 0) {
                resetPull();
                return;
            }
            if (delta > 10) {
                e.preventDefault();
            }
            pulling = true;
            document.body.classList.add('pulling');
            const progress = Math.min(delta / MAX_PULL, 1);
            const translateY = Math.min(delta, MAX_PULL) * 0.5;
            if (!indicator)
                return;
            indicator.style.transform = 'translateY(' + (translateY - 50) + 'px)';
            indicator.style.opacity = String(Math.min(progress * 1.5, 1));
            const textEl = indicator.querySelector('.pull-text');
            const spinnerEl = indicator.querySelector('.pull-spinner');
            if (delta >= PULL_THRESHOLD) {
                if (textEl)
                    textEl.textContent = 'Release to refresh';
                indicator.classList.add('visible');
                if (spinnerEl)
                    spinnerEl.style.transform = 'rotate(' + (progress * 180) + 'deg)';
            }
            else {
                if (textEl)
                    textEl.textContent = 'Pull to refresh';
                indicator.classList.remove('visible');
                if (spinnerEl)
                    spinnerEl.style.transform = 'rotate(' + (progress * 180) + 'deg)';
            }
        }
        function onTouchEnd() {
            if (!pulling || refreshing)
                return;
            const delta = currentY - startY;
            if (delta >= PULL_THRESHOLD) {
                triggerRefresh();
            }
            else {
                resetPull();
            }
        }
        function triggerRefresh() {
            refreshing = true;
            if (!indicator)
                return;
            indicator.classList.add('visible', 'refreshing');
            indicator.style.transform = 'translateY(0)';
            indicator.style.opacity = '1';
            const textEl = indicator.querySelector('.pull-text');
            if (textEl)
                textEl.textContent = 'Refreshing…';
            const done = function () {
                setTimeout(function () {
                    resetPull();
                    refreshing = false;
                }, 400);
            };
            const w = window;
            if (typeof w.refreshCurrent === 'function') {
                const result = w.refreshCurrent();
                if (result && typeof result.then === 'function') {
                    result.then(done).catch(done);
                }
                else {
                    setTimeout(done, 1500);
                }
            }
            else {
                window.location.reload();
            }
        }
        function resetPull() {
            pulling = false;
            document.body.classList.remove('pulling');
            if (indicator) {
                indicator.classList.remove('visible', 'refreshing');
                indicator.style.transform = 'translateY(-100%)';
                indicator.style.opacity = '0';
                const textEl = indicator.querySelector('.pull-text');
                if (textEl)
                    textEl.textContent = 'Pull to refresh';
                const spinnerEl = indicator.querySelector('.pull-spinner');
                if (spinnerEl)
                    spinnerEl.style.transform = '';
            }
        }
        function updateOnlineStatus() {
            if (!offlineBanner)
                return;
            if (!navigator.onLine) {
                offlineBanner.classList.add('visible');
                document.body.classList.add('app-offline');
            }
            else {
                offlineBanner.classList.remove('visible');
                document.body.classList.remove('app-offline');
            }
        }
        function onBackOnline() {
            updateOnlineStatus();
            const w = window;
            if (typeof w.refreshCurrent === 'function') {
                setTimeout(function () {
                    if (typeof w.refreshCurrent === 'function')
                        w.refreshCurrent();
                }, 500);
            }
        }
        function onGoOffline() {
            updateOnlineStatus();
        }
        function init() {
            if (!('ontouchstart' in window))
                return;
            createIndicator();
            createOfflineBanner();
            document.addEventListener('touchstart', onTouchStart, { passive: true });
            document.addEventListener('touchmove', onTouchMove, { passive: false });
            document.addEventListener('touchend', onTouchEnd, { passive: true });
            window.addEventListener('online', onBackOnline);
            window.addEventListener('offline', onGoOffline);
            updateOnlineStatus();
        }
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        }
        else {
            init();
        }
    }
    if (typeof window !== 'undefined') {
        const w = window;
        w.initPullRefresh = _initPullRefresh;
    }
})();
//# sourceMappingURL=pull-refresh.js.map
;
// ═══ context-menu.js ═══
;"use strict";
/**
 * Context Menu — right-click on ticker symbols for quick actions.
 *
 * TS Migration Phase 2 PR 16 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is now the SOURCE OF TRUTH; the sibling context-menu.js
 * is the build artifact produced by `npx tsc -p tsconfig.build.json`
 * (gitignored).
 *
 * Cross-chunk dependencies (declared in globals.d.ts):
 *   - escHtml(s) for ticker-string sanitization
 *   - switchTicker(t) / addToWatchlist(t) / removeTicker(t)
 *     (all typeof-guarded — typeof check is the runtime gate even
 *     though the ambient type says always-function).
 */
window.initContextMenu = function () {
    let _menu = null;
    // 2026-06-19 audit Phase-1 [High]: set true when a touch long-press opens
    // the menu, so the ghost click that follows finger-lift doesn't immediately
    // re-close it via the click-outside listener below. Cleared by that click
    // (or by the next touchstart, bounding any staleness to one interaction).
    let _lpSuppressClick = false;
    function createMenu() {
        if (_menu)
            return _menu;
        _menu = document.createElement('div');
        _menu.id = 'ol-context-menu';
        _menu.className = 'csp-context-menu';
        document.body.appendChild(_menu);
        // Close on click outside
        document.addEventListener('click', function () {
            if (_lpSuppressClick) {
                _lpSuppressClick = false;
                return;
            } // swallow long-press ghost click
            if (_menu)
                _menu.classList.add('hidden');
        });
        document.addEventListener('contextmenu', function (e) {
            const target = e.target;
            if (!(target instanceof Element)) {
                if (_menu)
                    _menu.classList.add('hidden');
                return;
            }
            if (!target.closest('#ol-context-menu') && _menu) {
                _menu.classList.add('hidden');
            }
        });
        return _menu;
    }
    function showContextMenu(e, ticker) {
        e.preventDefault();
        const menu = createMenu();
        const safeTicker = typeof escHtml === 'function'
            ? escHtml(ticker)
            : ticker.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        menu.innerHTML = '<div class="ctx-menu-header">' + safeTicker + '</div>'
            + '<div class="ctx-item" data-action="ctx-view-ticker" data-ticker="' + safeTicker + '">View Ticker</div>'
            + '<div class="ctx-item" data-action="ctx-add-watchlist" data-ticker="' + safeTicker + '">Add to Watchlist</div>'
            + '<div class="ctx-item" data-action="ctx-remove-session" data-ticker="' + safeTicker + '">Remove from Session</div>'
            + '<div class="ctx-menu-sep"></div>'
            + '<div class="ctx-item" data-action="ctx-open-edgar" data-ticker="' + safeTicker + '">SEC EDGAR</div>'
            + '<div class="ctx-item" data-action="ctx-open-yahoo" data-ticker="' + safeTicker + '">Yahoo Finance</div>';
        // Click delegation for context menu items
        menu.addEventListener('click', function (ev) {
            const target = ev.target;
            if (!(target instanceof Element))
                return;
            const item = target.closest('[data-action]');
            if (!item)
                return;
            const t = item.dataset.ticker || '';
            switch (item.dataset.action) {
                case 'ctx-view-ticker':
                    if (typeof switchTicker === 'function')
                        switchTicker(t);
                    break;
                case 'ctx-add-watchlist':
                    if (typeof addToWatchlist === 'function')
                        addToWatchlist(t);
                    break;
                case 'ctx-remove-session':
                    if (typeof removeTicker === 'function')
                        removeTicker(t);
                    break;
                case 'ctx-open-edgar':
                    window.open('https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=' + encodeURIComponent(t) + '&type=&dateb=&owner=include&count=40', '_blank', 'noopener,noreferrer');
                    break;
                case 'ctx-open-yahoo':
                    window.open('https://finance.yahoo.com/quote/' + encodeURIComponent(t), '_blank', 'noopener,noreferrer');
                    break;
            }
            menu.classList.add('hidden');
        });
        // Position
        menu.style.left = Math.min(e.clientX, window.innerWidth - 180) + 'px';
        menu.style.top = Math.min(e.clientY, window.innerHeight - 200) + 'px';
        menu.classList.remove('hidden');
    }
    // 2026-04-05: CSS moved to static/css/dynamic-components.css
    // (strict CSP style-src blocks dynamic style injection).
    // Listen for right-clicks on ticker-related elements
    document.addEventListener('contextmenu', function (e) {
        const target = e.target;
        if (!(target instanceof Element))
            return;
        const tab = target.closest('.ticker-btn');
        if (tab) {
            const ticker = tab.getAttribute('data-ticker') || (tab.textContent || '').trim().split(/\s/)[0];
            if (ticker)
                showContextMenu(e, ticker.toUpperCase());
            return;
        }
        // Also on holding links in 13F
        const holdingLink = target.closest('.holding-link');
        if (holdingLink) {
            const text = (holdingLink.textContent || '').trim().split(' ')[0];
            if (text)
                showContextMenu(e, text.toUpperCase());
        }
    });
    // 2026-06-19 audit Phase-1 [High]: touch long-press fallback. The
    // `contextmenu` event never fires on touch devices, so the quick-actions
    // menu was invisible to every mobile/tablet user. A ~500ms press (with no
    // significant finger movement) on a ticker chip / 13F holding link opens the
    // SAME menu at the touch point. showContextMenu only reads clientX/clientY +
    // preventDefault, so a small coord shim stands in for the MouseEvent.
    const LP_DELAY = 500; // ms — long-press threshold
    const LP_MOVE_TOL = 10; // px — movement beyond this = scroll, not press
    let _lpTimer = null;
    let _lpX = 0, _lpY = 0, _lpTicker = '';
    function _lpClear() {
        if (_lpTimer) {
            clearTimeout(_lpTimer);
            _lpTimer = null;
        }
    }
    function _lpTickerFor(target) {
        if (!(target instanceof Element))
            return '';
        const tab = target.closest('.ticker-btn');
        if (tab) {
            const t = tab.getAttribute('data-ticker') || (tab.textContent || '').trim().split(/\s/)[0];
            return t ? t.toUpperCase() : '';
        }
        const hl = target.closest('.holding-link');
        if (hl) {
            const ht = (hl.textContent || '').trim().split(' ')[0];
            return ht ? ht.toUpperCase() : '';
        }
        return '';
    }
    document.addEventListener('touchstart', function (e) {
        _lpSuppressClick = false; // new interaction — clear any stale suppressor
        if (!e.touches || e.touches.length !== 1)
            return;
        const tk = _lpTickerFor(e.target);
        if (!tk)
            return;
        _lpTicker = tk;
        _lpX = e.touches[0].clientX;
        _lpY = e.touches[0].clientY;
        _lpClear();
        _lpTimer = setTimeout(function () {
            _lpTimer = null;
            _lpSuppressClick = true;
            showContextMenu({ clientX: _lpX, clientY: _lpY, preventDefault: function () { } }, _lpTicker);
        }, LP_DELAY);
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
        if (!_lpTimer || !e.touches || !e.touches.length)
            return;
        if (Math.abs(e.touches[0].clientX - _lpX) > LP_MOVE_TOL ||
            Math.abs(e.touches[0].clientY - _lpY) > LP_MOVE_TOL) {
            _lpClear(); // finger moved → treat as scroll, cancel the press
        }
    }, { passive: true });
    document.addEventListener('touchend', _lpClear, { passive: true });
    document.addEventListener('touchcancel', _lpClear, { passive: true });
};
//# sourceMappingURL=context-menu.js.map
;
// ═══ system-messages.js ═══
;"use strict";
/* system-messages.js — Priority queue for system-level banners.
 *
 * TS Migration Phase 2 PR 21 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is now the SOURCE OF TRUTH; the sibling system-messages.js
 * is the build artifact produced by `npx tsc -p tsconfig.build.json`
 * (gitignored).
 *
 * I-19: On mobile (max-width: 767px) only ONE message is visible at a time.
 * Priority order (highest first):
 *   provider-outage > stale > demo > morning-brief > quickstart > cta
 *
 * On desktop all messages render as normal — this module only suppresses
 * lower-priority messages on small screens.
 *
 * Usage: call SystemMessages.update() whenever you show/hide a message.
 * The module observes DOM mutations so external code rarely needs to call
 * it directly — it re-evaluates on any visibility change to the managed
 * message elements.
 *
 * Provider-outage API (S49 Upstream §7 P2):
 *   SystemMessages.showProviderOutage('voyage', 'AI context retrieval is
 *     temporarily degraded.');   // shows the banner
 *   SystemMessages.clearProviderOutage();                 // hides it
 * Use these when a circuit breaker trips or an upstream API returns
 * sustained errors. Message text should be human-readable ("AI search"
 * not "voyage_client embed_documents 503").
 */
const SystemMessages = (function () {
    'use strict';
    // Priority order — index 0 = highest priority.
    // `provider-outage-banner` sits above `stale-data-banner` because a
    // provider outage is a trust + availability concern; stale data is
    // a freshness concern. If both fire, outage takes the slot.
    const PRIORITY = [
        'provider-outage-banner',
        'stale-data-banner',
        'demo-banner',
        'morning-brief',
        'quickstart-bar',
        'buffett-cta',
    ];
    const _mql = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
    // The single MutationObserver, stored so update() can disconnect it around
    // its own writes (see the LOOP GUARD comment in update()).
    let _obs = null;
    function _isMobile() {
        return _mql ? _mql.matches : window.innerWidth <= 767;
    }
    // Returns the first element in PRIORITY that is currently "visible"
    // (i.e., does not have the 'd-none' class and is in the DOM).
    function _getActiveMessages() {
        const active = [];
        for (let i = 0; i < PRIORITY.length; i++) {
            const el = document.getElementById(PRIORITY[i]);
            if (el && !el.classList.contains('d-none')) {
                active.push({ id: PRIORITY[i], el: el, priority: i });
            }
        }
        return active;
    }
    // Re-attach the observer to every managed banner. Called after update()
    // finishes its own writes so the observer keeps reacting to EXTERNAL
    // visibility changes (other code toggling `d-none`) without seeing the
    // class writes update() itself just made.
    function _reobserve() {
        if (!_obs)
            return;
        for (let i = 0; i < PRIORITY.length; i++) {
            const el = document.getElementById(PRIORITY[i]);
            if (el)
                _obs.observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
        }
    }
    function update() {
        // LOOP GUARD (incident 2026-05-30): update() writes the `class` attribute
        // (sm-suppressed) on the very elements _observe() watches for `class`
        // mutations. Left connected, each write re-fires the observer -> update()
        // -> write -> ... an infinite microtask loop that pegs the main thread and
        // blocks bundle-app-init from ever booting (331,862 callback invocations
        // in 4s per CPU profile). Disconnect while we mutate, then re-attach; the
        // observer thus only ever fires for EXTERNAL visibility changes.
        if (_obs)
            _obs.disconnect();
        try {
            if (!_isMobile()) {
                // Desktop: remove any suppression, let all show
                for (let i = 0; i < PRIORITY.length; i++) {
                    const el = document.getElementById(PRIORITY[i]);
                    if (el)
                        el.classList.remove('sm-suppressed');
                }
                return;
            }
            const active = _getActiveMessages();
            if (active.length <= 1) {
                // Zero or one visible — remove any stale suppression marks and bail
                for (let j = 0; j < PRIORITY.length; j++) {
                    const elJ = document.getElementById(PRIORITY[j]);
                    if (elJ)
                        elJ.classList.remove('sm-suppressed');
                }
                return;
            }
            // More than one active on mobile — show only highest priority, suppress rest
            for (let k = 0; k < active.length; k++) {
                if (k === 0) {
                    active[k].el.classList.remove('sm-suppressed');
                }
                else {
                    active[k].el.classList.add('sm-suppressed');
                }
            }
        }
        finally {
            // While disconnected no records are queued; takeRecords() is
            // belt-and-suspenders before re-attaching for future EXTERNAL changes.
            if (_obs) {
                _obs.takeRecords();
                _reobserve();
            }
        }
    }
    // Observe visibility changes on all managed elements
    function _observe() {
        const targets = [];
        for (let i = 0; i < PRIORITY.length; i++) {
            const el = document.getElementById(PRIORITY[i]);
            if (el)
                targets.push(el);
        }
        if (!targets.length)
            return;
        if (typeof MutationObserver !== 'undefined') {
            _obs = new MutationObserver(function () { update(); });
            for (let j = 0; j < targets.length; j++) {
                _obs.observe(targets[j], { attributes: true, attributeFilter: ['class', 'style'] });
            }
        }
    }
    function init() {
        _observe();
        update();
        // Re-evaluate on viewport resize (mobile <-> desktop crossing)
        if (_mql) {
            const handler = function () { update(); };
            if (_mql.addEventListener)
                _mql.addEventListener('change', handler);
            else if (_mql.addListener)
                _mql.addListener(handler);
        }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    }
    else {
        init();
    }
    function showProviderOutage(provider, message) {
        const el = document.getElementById('provider-outage-banner');
        if (!el)
            return;
        const textEl = el.querySelector('.provider-outage-text');
        if (textEl) {
            textEl.textContent = message || ('A data provider is temporarily degraded. Some features may show stale results.');
        }
        el.setAttribute('data-provider', provider || 'unknown');
        el.classList.remove('d-none');
        update();
    }
    function clearProviderOutage() {
        const el = document.getElementById('provider-outage-banner');
        if (!el)
            return;
        el.classList.add('d-none');
        update();
    }
    return {
        update: update,
        showProviderOutage: showProviderOutage,
        clearProviderOutage: clearProviderOutage,
    };
})();
window.SystemMessages = SystemMessages;
// Suppress unused-binding flag — SystemMessages is the public surface.
void SystemMessages;
//# sourceMappingURL=system-messages.js.map
;
// ═══ loading-states.js ═══
;"use strict";
// ── loading-states.js ────────────────────────────────────────────────────
//
// TS Migration Phase 2 PR 36 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; loading-states.js is the build
// artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
//
// Skeleton loading screens + error recovery UI. IIFE-evaluated so the
// module-private state (active skeletons, pending retries, timer maps)
// stays scoped — only the public API is assigned to LoadingStates.
const LoadingStates = (function () {
    'use strict';
    const _active = new Map();
    const _pendingRetries = new Map();
    function _metricsHTML() {
        const pair = () => '<div class="ls-metric-pair">' +
            '<div class="ls-line ls-metric-label ls-line-h8"></div>' +
            '<div class="ls-line ls-metric-value ls-line-h14"></div>' +
            '</div>';
        return '<div class="ls-skeleton" data-ls-type="metrics">' +
            '<div class="ls-metrics-grid">' +
            pair() + pair() + pair() + pair() + pair() + pair() +
            '</div>' +
            '</div>';
    }
    function _chartHTML() {
        const yTicks = Array(5).fill('<div class="ls-tick"></div>').join('');
        const xTicks = Array(6).fill('<div class="ls-tick"></div>').join('');
        return '<div class="ls-skeleton" data-ls-type="chart">' +
            '<div class="ls-chart">' +
            '<div class="ls-chart-axis-y">' + yTicks + '</div>' +
            '<div class="ls-chart-axis-x">' + xTicks + '</div>' +
            '</div>' +
            '</div>';
    }
    function _newsHTML() {
        const widths = ['ls-line-full', 'ls-line-lg', 'ls-line-full', 'ls-line-lg', 'ls-line-md'];
        const items = widths.map(function (w) {
            return '<div class="ls-news-item">' +
                '<div class="ls-line ls-news-title ' + w + '"></div>' +
                '<div class="ls-line ls-news-meta"></div>' +
                '</div>';
        }).join('');
        return '<div class="ls-skeleton" data-ls-type="news">' + items + '</div>';
    }
    function _tableHTML() {
        const row = function (isHeader) {
            const cls = isHeader ? ' class="ls-header-dim"' : '';
            return '<div class="ls-table-row">' +
                '<div class="ls-table-cell"' + cls + '></div>' +
                '<div class="ls-table-cell"' + cls + '></div>' +
                '<div class="ls-table-cell"' + cls + '></div>' +
                '<div class="ls-table-cell"' + cls + '></div>' +
                '</div>';
        };
        return '<div class="ls-skeleton" data-ls-type="table">' +
            '<div class="ls-table">' +
            row(true) + row(false) + row(false) + row(false) + row(false) + row(false) +
            '</div>' +
            '</div>';
    }
    function _heroHTML() {
        return '<div class="ls-skeleton" data-ls-type="hero">' +
            '<div class="ls-hero">' +
            '<div class="ls-line ls-hero-name"></div>' +
            '<div class="ls-line ls-hero-price"></div>' +
            '<div class="ls-line ls-hero-change"></div>' +
            '</div>' +
            '</div>';
    }
    function _finTableHTML() {
        return '<div class="ls-skeleton" data-ls-type="fin-table">' +
            '<div class="panel-skel-fin-table">' +
            '<div class="skel-tr"><div class="skel-td" data-w="55"></div><div class="skel-td" data-w="18"></div><div class="skel-td" data-w="20"></div></div>' +
            '<div class="skel-tr"><div class="skel-td" data-w="42"></div><div class="skel-td" data-w="18"></div><div class="skel-td" data-w="20"></div></div>' +
            '<div class="skel-tr"><div class="skel-td" data-w="50"></div><div class="skel-td" data-w="18"></div><div class="skel-td" data-w="20"></div></div>' +
            '<div class="skel-tr"><div class="skel-td" data-w="20"></div><div class="skel-td" data-w="18"></div><div class="skel-td" data-w="20"></div></div>' +
            '<div class="skel-tr"><div class="skel-td" data-w="60"></div><div class="skel-td" data-w="18"></div><div class="skel-td" data-w="20"></div></div>' +
            '</div>' +
            '</div>';
    }
    function _newsListHTML() {
        const widths = [88, 74, 92, 66, 80];
        const items = widths.map(function (w) {
            return '<div class="skel-item">' +
                '<div class="skel-headline" data-w="' + w + '"></div>' +
                '<div class="skel-meta"></div>' +
                '</div>';
        }).join('');
        return '<div class="ls-skeleton" data-ls-type="news-list">' +
            '<div class="panel-skel-list">' + items + '</div>' +
            '</div>';
    }
    function _filingsListHTML() {
        const widths = [70, 56, 64, 50, 72];
        const items = widths.map(function (w) {
            return '<div class="skel-item">' +
                '<div class="skel-headline" data-w="' + w + '"></div>' +
                '<div class="skel-meta" data-w="30"></div>' +
                '</div>';
        }).join('');
        return '<div class="ls-skeleton" data-ls-type="filings-list">' +
            '<div class="panel-skel-list">' + items + '</div>' +
            '</div>';
    }
    function _earningsHTML() {
        let rows = '';
        for (let i = 0; i < 4; i++) {
            rows += '<div class="skel-tr">' +
                '<div class="skel-td" data-w="22"></div>' +
                '<div class="skel-td"></div>' +
                '<div class="skel-td"></div>' +
                '<div class="skel-td"></div>' +
                '</div>';
        }
        return '<div class="ls-skeleton" data-ls-type="earnings">' +
            '<div class="panel-skel-earnings">' + rows + '</div>' +
            '</div>';
    }
    function _debtHTML() {
        let rows = '';
        const years = ['2025', '2026', '2027', '2028+'];
        const widths = [55, 38, 72, 45];
        years.forEach(function (_yr, i) {
            rows += '<div class="skel-bar-row">' +
                '<div class="skel-year"></div>' +
                '<div class="skel-track" data-w="' + widths[i] + '"></div>' +
                '<div class="skel-amt"></div>' +
                '</div>';
        });
        return '<div class="ls-skeleton" data-ls-type="debt">' +
            '<div class="panel-skel-debt">' + rows + '</div>' +
            '</div>';
    }
    function _insiderHTML() {
        let rows = '';
        for (let i = 0; i < 4; i++) {
            rows += '<div class="skel-tr">' +
                '<div class="skel-td-sm"></div>' +
                '<div class="skel-td"></div>' +
                '<div class="skel-td-sm"></div>' +
                '<div class="skel-td-sm"></div>' +
                '<div class="skel-td-sm"></div>' +
                '</div>';
        }
        return '<div class="ls-skeleton" data-ls-type="insider">' +
            '<div class="panel-skel-insider">' + rows + '</div>' +
            '</div>';
    }
    const _generators = {
        metrics: _metricsHTML,
        chart: _chartHTML,
        news: _newsHTML,
        table: _tableHTML,
        hero: _heroHTML,
        'fin-table': _finTableHTML,
        'news-list': _newsListHTML,
        'filings': _filingsListHTML,
        'earnings': _earningsHTML,
        'debt': _debtHTML,
        'insider': _insiderHTML,
    };
    const _timeouts = new Map();
    const _stillLoadingTimers = new Map();
    const DEFAULT_SKELETON_TIMEOUT = 20000;
    const STILL_LOADING_THRESHOLD = 8000;
    const _TIMEOUT_PRESETS = {
        fast: 8000,
        medium: 12000,
        slow: 20000,
    };
    function _resolveTimeout(rawTimeout) {
        if (typeof rawTimeout === 'number' && rawTimeout > 0)
            return rawTimeout;
        if (typeof rawTimeout === 'string' && _TIMEOUT_PRESETS[rawTimeout]) {
            return _TIMEOUT_PRESETS[rawTimeout];
        }
        return DEFAULT_SKELETON_TIMEOUT;
    }
    function showSkeleton(containerId, type, opts) {
        const el = document.getElementById(containerId);
        if (!el)
            return;
        if (_active.has(containerId))
            return;
        const gen = _generators[type];
        if (!gen) {
            const w = window;
            /* @__PURE__ */ _olDebugWarn('[LoadingStates] Unknown skeleton type:', type);
            return;
        }
        _active.set(containerId, {
            type: type,
            hadContent: el.innerHTML.trim().length > 0,
        });
        if (!el.getAttribute('aria-live')) {
            el.setAttribute('aria-live', 'polite');
            el.setAttribute('aria-busy', 'true');
        }
        else {
            el.setAttribute('aria-busy', 'true');
        }
        const srAnnounce = '<span class="sr-only ls-sr-announce">Loading data…</span>';
        el.insertAdjacentHTML('afterbegin', srAnnounce + gen());
        el.querySelectorAll('[data-w]').forEach(function (n) {
            const html = n;
            html.style.width = (html.dataset.w || '') + '%';
        });
        if (_stillLoadingTimers.has(containerId)) {
            const existing = _stillLoadingTimers.get(containerId);
            if (existing)
                clearTimeout(existing);
        }
        _stillLoadingTimers.set(containerId, setTimeout(function () {
            _stillLoadingTimers.delete(containerId);
            if (!_active.has(containerId))
                return;
            const skel = el.querySelector('.ls-skeleton');
            if (skel && !skel.querySelector('.ls-still-loading')) {
                const notice = document.createElement('div');
                notice.className = 'ls-still-loading';
                // S11 (first-time-user audit, 2026-09-25): "SEC/EDGAR" is jargon to
                // a newcomer; say where the data comes from in plain words.
                notice.textContent = 'Still loading… this data comes straight from SEC filings and can take a moment.';
                skel.appendChild(notice);
            }
        }, STILL_LOADING_THRESHOLD));
        const timeoutMs = _resolveTimeout(opts && opts.timeout);
        if (_timeouts.has(containerId)) {
            const existing = _timeouts.get(containerId);
            if (existing)
                clearTimeout(existing);
        }
        _timeouts.set(containerId, setTimeout(function () {
            _timeouts.delete(containerId);
            if (_stillLoadingTimers.has(containerId)) {
                const t = _stillLoadingTimers.get(containerId);
                if (t)
                    clearTimeout(t);
                _stillLoadingTimers.delete(containerId);
            }
            if (!_active.has(containerId))
                return;
            // FE review 2026-07-19 P1: a caller that repainted via innerHTML
            // deleted the skeleton NODE but left this _active entry stale — the
            // timeout then stamped a false "taking longer than usual" banner
            // under already-rendered content (live on the legacy watchlist).
            // No skeleton in the container = content painted = nothing timed out.
            const elNow = document.getElementById(containerId);
            if (!elNow || !elNow.querySelector('.ls-skeleton')) {
                _active.delete(containerId);
                if (elNow)
                    elNow.setAttribute('aria-busy', 'false');
                return;
            }
            hideSkeleton(containerId);
            const retryFn = (opts && typeof opts.retryFn === 'function') ? opts.retryFn : null;
            // Board#7: the 'timeout' code routes through OLErrorCopy (which owns the
            // copy); this literal is only the no-registry fallback — keep it aligned
            // with the registry's own-the-failure timeout body, never blame-the-wifi.
            showError(containerId, 'This is taking longer than usual on our end. Try again in a moment.', retryFn, 'timeout');
        }, timeoutMs));
    }
    function hideSkeleton(containerId) {
        const el = document.getElementById(containerId);
        if (!el)
            return;
        if (_timeouts.has(containerId)) {
            const existing = _timeouts.get(containerId);
            if (existing)
                clearTimeout(existing);
            _timeouts.delete(containerId);
        }
        if (_stillLoadingTimers.has(containerId)) {
            const existing = _stillLoadingTimers.get(containerId);
            if (existing)
                clearTimeout(existing);
            _stillLoadingTimers.delete(containerId);
        }
        const skel = el.querySelector('.ls-skeleton');
        if (!skel) {
            _active.delete(containerId);
            el.setAttribute('aria-busy', 'false');
            return;
        }
        // Known race (benign, FE review 2026-07-19 P2): _active is deleted only
        // after the 200ms fade below, so an immediate re-showSkeleton within
        // that window no-ops via its _active.has() guard (brief missing
        // skeleton, content follows normally). Accepted - do not "fix" by
        // deleting _active here without also cancelling the fade timer.
        const srEl = el.querySelector('.ls-sr-announce');
        if (srEl && srEl.parentNode)
            srEl.parentNode.removeChild(srEl);
        skel.classList.add('ls-fade-out');
        setTimeout(function () {
            if (skel.parentNode) {
                skel.parentNode.removeChild(skel);
            }
            _active.delete(containerId);
            el.setAttribute('aria-busy', 'false');
        }, 200);
    }
    function showError(containerId, message, retryFn, code, ctx) {
        const el = document.getElementById(containerId);
        if (!el)
            return;
        let _title = null;
        let _body = message || 'Unable to load data';
        let _ctaLabel = null;
        let _ctaAction = null;
        let _severity = 'warning';
        const w = window;
        if (code != null && typeof window !== 'undefined' && w.OLErrorCopy) {
            // F1 audit (PR1, 2026-05-06): forward ctx so the 402/tier_gated
            // body can be rewritten with the required tier label + price.
            // Backend tier_gate_exception_handler emits ctx.requiredTier
            // already; callers just need to parse the JSON envelope and pass
            // it through.
            const _copy = w.OLErrorCopy.lookup(code, (ctx || undefined));
            _title = _copy.title || null;
            _body = _copy.body || _body;
            _ctaLabel = _copy.ctaLabel || null;
            _ctaAction = _copy.ctaAction || null;
            _severity = _copy.severity || 'warning';
        }
        // CLS #119: capture the skeleton's rendered height BEFORE removing it, so the
        // error banner can reserve the same footprint. Without this, swapping a tall
        // skeleton for this short banner collapses the panel then re-expands it,
        // shifting the page (prod RUM 2026-07: `/` CLS 0.276, #ticker-view>
        // .load-error--warning after a failed default-ticker fetch). offsetHeight is
        // 0 when there is no skeleton — the CSS `#ticker-view .load-error` min-height
        // floor then covers that case.
        const skel = el.querySelector('.ls-skeleton');
        let _reservedH = 0;
        if (skel) {
            _reservedH = skel.offsetHeight || 0;
            if (skel.parentNode)
                skel.parentNode.removeChild(skel);
        }
        _active.delete(containerId);
        const oldErr = el.querySelector('.load-error');
        if (oldErr && oldErr.parentNode)
            oldErr.parentNode.removeChild(oldErr);
        const errorDiv = document.createElement('div');
        errorDiv.className = 'load-error load-error--' + _severity;
        if (_reservedH > 0)
            errorDiv.style.minHeight = _reservedH + 'px';
        errorDiv.setAttribute('data-ls-error', '1');
        const iconEl = document.createElement('div');
        iconEl.className = 'load-error-icon';
        iconEl.textContent = '⚠';
        errorDiv.appendChild(iconEl);
        if (_title) {
            const titleEl = document.createElement('div');
            titleEl.className = 'load-error-title';
            titleEl.textContent = _title;
            errorDiv.appendChild(titleEl);
        }
        const msgEl = document.createElement('div');
        msgEl.className = 'load-error-msg';
        msgEl.textContent = _body;
        errorDiv.appendChild(msgEl);
        if (_ctaLabel && _ctaAction) {
            const ctaBtn = document.createElement('button');
            ctaBtn.className = 'load-error-cta';
            ctaBtn.textContent = _ctaLabel;
            ctaBtn.setAttribute('data-action', _ctaAction);
            errorDiv.appendChild(ctaBtn);
        }
        if (typeof retryFn === 'function') {
            const btn = document.createElement('button');
            btn.className = 'load-error-retry';
            btn.textContent = 'Retry';
            btn.addEventListener('click', function () {
                if (errorDiv.parentNode)
                    errorDiv.parentNode.removeChild(errorDiv);
                retryFn();
            });
            errorDiv.appendChild(btn);
        }
        if (!_title && !_ctaLabel) {
            const hintEl = document.createElement('div');
            hintEl.className = 'load-error-hint';
            // Board#7: own the failure — provider/EDGAR slowness is our commonest
            // failure mode, not the user's wifi. No lead-with-blame.
            hintEl.textContent = 'Try again in a moment';
            errorDiv.appendChild(hintEl);
        }
        el.appendChild(errorDiv);
    }
    function clearError(containerId) {
        const el = document.getElementById(containerId);
        if (!el)
            return;
        const err = el.querySelector('.load-error');
        if (err && err.parentNode)
            err.parentNode.removeChild(err);
    }
    async function withLoading(containerId, skeletonType, fetchFn, opts) {
        opts = opts || {};
        const errorMsg = opts.errorMsg || 'Unable to load data';
        const errorCode = opts.errorCode || null;
        const retryDelay = opts.retryDelay || 3000;
        if (_pendingRetries.has(containerId)) {
            const existing = _pendingRetries.get(containerId);
            if (existing)
                clearTimeout(existing);
            _pendingRetries.delete(containerId);
        }
        showSkeleton(containerId, skeletonType);
        clearError(containerId);
        try {
            await fetchFn();
            hideSkeleton(containerId);
        }
        catch (firstErr) {
            const w = window;
            /* @__PURE__ */ _olDebugWarn('[LoadingStates] First attempt failed for', containerId, firstErr);
            await new Promise(function (resolve) {
                const timer = setTimeout(resolve, retryDelay);
                _pendingRetries.set(containerId, timer);
            });
            _pendingRetries.delete(containerId);
            try {
                await fetchFn();
                hideSkeleton(containerId);
            }
            catch (secondErr) {
                /* @__PURE__ */ _olDebugWarn('[LoadingStates] Retry failed for', containerId, secondErr);
                hideSkeleton(containerId);
                showError(containerId, errorMsg, function () {
                    void withLoading(containerId, skeletonType, fetchFn, opts);
                }, errorCode);
            }
        }
    }
    function isLoading(containerId) {
        return _active.has(containerId);
    }
    function showAllPanelSkeletons() {
        const panels = [
            ['fin-table-wrap', 'fin-table'],
            ['news-list', 'news-list'],
            ['filings-list', 'filings'],
            ['earnings-info', 'earnings'],
            ['earnings-history', 'earnings'],
            ['insider-activity', 'insider'],
        ];
        panels.forEach(function (p) { showSkeleton(p[0], p[1]); });
    }
    function hideAllPanelSkeletons() {
        const ids = [
            'fin-table-wrap', 'news-list', 'filings-list',
            'earnings-info', 'earnings-history', 'insider-activity',
        ];
        ids.forEach(function (id) { hideSkeleton(id); });
    }
    return {
        showSkeleton: showSkeleton,
        hideSkeleton: hideSkeleton,
        showError: showError,
        clearError: clearError,
        withLoading: withLoading,
        isLoading: isLoading,
        showAllPanelSkeletons: showAllPanelSkeletons,
        hideAllPanelSkeletons: hideAllPanelSkeletons,
        TIMEOUT_PRESETS: _TIMEOUT_PRESETS,
        _resolveTimeout: _resolveTimeout,
    };
})();
void LoadingStates;
//# sourceMappingURL=loading-states.js.map
;
// ═══ data-cache.js ═══
;"use strict";
/**
 * DataCache — Stale-while-revalidate client-side data caching layer
 *
 * TS Migration Phase 2 PR 24 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is now the SOURCE OF TRUTH; the sibling data-cache.js
 * is the build artifact produced by `npx tsc -p tsconfig.build.json`
 * (gitignored).
 *
 * Returns last-known data instantly from localStorage for returning users,
 * then silently refreshes from the API. Skeleton screens only appear for
 * first-time visitors with no cache.
 */
// Wrapped in outer IIFE so the local const doesn't collide with the
// ambient `declare var DataCache` in globals.d.ts. Window assignment
// at the bottom is the canonical cross-chunk export.
(function () {
    const DataCacheImpl = (function () {
        const STORAGE_PREFIX = 'ol_cache_';
        const DEFAULT_TTL = 300000; // 5 minutes — data older than this is "stale"
        const STALE_TTL = 86400000; // 24 hours — stale data older than this is evicted
        const api = {
            /**
             * Store data with current timestamp.
             * Auto-evicts oldest 25% of entries if localStorage is full.
             */
            set: function (key, data) {
                const payload = { data: data, timestamp: Date.now() };
                if (!OLStorage.set(STORAGE_PREFIX + key, payload)) {
                    // Quota exceeded — evict oldest entries and retry once.
                    api._evictOldest();
                    OLStorage.set(STORAGE_PREFIX + key, payload);
                }
            },
            /**
             * Get cached data.
             * Returns { data, age_ms, stale, timestamp } or null if miss/expired.
             */
            get: function (key) {
                try {
                    const raw = OLStorage.getString(STORAGE_PREFIX + key, null);
                    if (!raw)
                        return null;
                    const entry = JSON.parse(raw);
                    if (!entry || typeof entry.timestamp !== 'number') {
                        OLStorage.remove(STORAGE_PREFIX + key);
                        return null;
                    }
                    const age = Date.now() - entry.timestamp;
                    if (age > STALE_TTL) {
                        OLStorage.remove(STORAGE_PREFIX + key);
                        return null; // Too old, treat as miss
                    }
                    return {
                        data: entry.data,
                        age_ms: age,
                        stale: age > DEFAULT_TTL,
                        timestamp: entry.timestamp,
                    };
                }
                catch (_e) {
                    return null;
                }
            },
            /**
             * Fetch with stale-while-revalidate pattern.
             */
            fetchWithCache: function (url, cacheKey, onData, onError) {
                const cached = api.get(cacheKey);
                // Step 1: Return cached data immediately (< 50ms for returning users)
                if (cached) {
                    onData(cached.data, true); // true = from cache
                }
                // Step 2: Fetch fresh data in background
                fetch(url, { signal: AbortSignal.timeout(15000) })
                    .then(function (resp) {
                    if (!resp.ok) {
                        throw new Error('HTTP ' + resp.status);
                    }
                    return resp.json();
                })
                    .then(function (fresh) {
                    api.set(cacheKey, fresh);
                    // Only re-render if data actually changed (avoid jank)
                    if (!cached || JSON.stringify(fresh) !== JSON.stringify(cached.data)) {
                        onData(fresh, false); // false = fresh data
                    }
                })
                    .catch(function (err) {
                    // If we had cached data, user already sees it — just log
                    if (cached) {
                        /* @__PURE__ */ _olDebug('[DataCache] Using stale data for', cacheKey, '(fetch failed)');
                    }
                    else if (onError) {
                        onError(err);
                    }
                });
            },
            /**
             * Cache key generators for common data types.
             */
            keys: {
                ticker: function (t) { return 'ticker_' + t; },
                portfolio: function () { return 'portfolio'; },
                marketIndicators: function () { return 'market_indicators'; },
                news: function () { return 'news_headlines'; },
                watchlist: function () { return 'watchlist'; },
            },
            /**
             * Human-readable staleness label for a cache key.
             */
            getStalenessLabel: function (key) {
                const cached = api.get(key);
                if (!cached)
                    return null;
                const mins = Math.floor(cached.age_ms / 60000);
                if (mins < 1)
                    return 'Just now';
                if (mins < 60)
                    return mins + 'm ago';
                const hrs = Math.floor(mins / 60);
                return hrs + 'h ago';
            },
            /**
             * Evict oldest 25% of cache entries when localStorage is full.
             */
            _evictOldest: function () {
                const entries = OLStorage.keys(STORAGE_PREFIX).map(function (k) {
                    const v = OLStorage.get(k, null);
                    return { key: k, timestamp: (v && v.timestamp) || 0 };
                });
                // Sort oldest first, remove bottom 25%
                entries.sort(function (a, b) { return a.timestamp - b.timestamp; });
                const toRemove = Math.max(1, Math.floor(entries.length / 4));
                for (let j = 0; j < toRemove; j++) {
                    OLStorage.remove(entries[j].key);
                }
            },
            /**
             * Clear all DataCache entries from localStorage.
             */
            clear: function () {
                return OLStorage.clearPrefix(STORAGE_PREFIX);
            },
            /**
             * Diagnostic stats for debugging.
             */
            stats: function () {
                let count = 0, totalSize = 0, oldest = Infinity, newest = 0;
                OLStorage.keys(STORAGE_PREFIX).forEach(function (k) {
                    count++;
                    const val = OLStorage.getString(k, null);
                    if (val) {
                        totalSize += val.length;
                        try {
                            const ts = JSON.parse(val).timestamp;
                            if (ts < oldest)
                                oldest = ts;
                            if (ts > newest)
                                newest = ts;
                        }
                        catch (_e) { }
                    }
                });
                return {
                    entries: count,
                    sizeKB: Math.round(totalSize / 1024),
                    oldestAge: count ? Math.round((Date.now() - oldest) / 60000) + 'm' : null,
                    newestAge: count ? Math.round((Date.now() - newest) / 60000) + 'm' : null,
                };
            },
        };
        return api;
    })();
    window.DataCache = DataCacheImpl;
})();
//# sourceMappingURL=data-cache.js.map
;
// ═══ funnel-analytics.js ═══
;"use strict";
/**
 * FunnelAnalytics — First-time user funnel tracking.
 *
 * TS Migration Phase 2 PR 26 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is the SOURCE OF TRUTH; funnel-analytics.js is the build
 * artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
 *
 * Tracks where first-time users drop off through a 10-stage funnel:
 *   page_load → welcome_seen → level_selected → preset_selected →
 *   dashboard_loaded → first_ticker_viewed → second_view_used →
 *   feature_used → return_visit → power_user
 *
 * All data stored in localStorage. Server beacons via
 * navigator.sendBeacon are fire-and-forget.
 */
// Wrapped in outer IIFE so the local const doesn't collide with the
// ambient `declare var FunnelAnalytics` in globals.d.ts. Window
// assignment at the bottom is the canonical cross-chunk export.
(function () {
    // Wave-4 QA (2026-07-17): `var`, not `const` — this module ships in the
    // EAGER core-utils bundle AND is re-injected standalone by app-init's +5s
    // analytics loader; a top-level `const` makes the second evaluation a
    // page-level SyntaxError (the AdaptiveUI OXFORD-LEDGE-BROWSER-11 class).
    var FunnelAnalyticsImpl = (function () {
        const STORAGE_KEY = 'ol_funnel';
        const STAGES = [
            'page_load',
            'welcome_seen',
            'level_selected',
            'preset_selected',
            'dashboard_loaded',
            'first_ticker_viewed',
            'second_view_used',
            'feature_used',
            'return_visit',
            'power_user',
        ];
        let _data = null;
        const api = {
            init: function () {
                _data = (function () {
                    try {
                        return OLStorage.get(STORAGE_KEY, null);
                    }
                    catch (_e) {
                        return null;
                    }
                })() || {
                    firstVisit: new Date().toISOString(),
                    stages: {},
                    sessions: [],
                    currentSession: null,
                    viewSequence: [],
                    tickersViewed: [],
                    featuresUsed: [],
                    dropOffView: null,
                    totalSessions: 0,
                    lastActive: null,
                    idlePeriods: [],
                };
                this._startSession();
                this._trackStage('page_load');
                this._setupIdleDetection();
                this._save();
            },
            _trackStage: function (stage) {
                if (!_data)
                    return;
                if (!_data.stages[stage]) {
                    _data.stages[stage] = {
                        timestamp: new Date().toISOString(),
                        sessionNumber: _data.totalSessions,
                        timeFromFirstVisit: Date.now() - new Date(_data.firstVisit).getTime(),
                    };
                    this._save();
                    this._beacon('funnel_stage', { stage: stage });
                }
            },
            trackView: function (viewName) {
                try {
                    if (!_data)
                        return;
                    _data.viewSequence.push({
                        view: viewName,
                        timestamp: Date.now(),
                        session: _data.totalSessions,
                    });
                    _data.dropOffView = viewName;
                    _data.lastActive = Date.now();
                    if (_data.viewSequence.length === 1)
                        this._trackStage('first_ticker_viewed');
                    if (_data.viewSequence.length >= 2) {
                        const views = new Set(_data.viewSequence.map(function (v) { return v.view; }));
                        if (views.size >= 2)
                            this._trackStage('second_view_used');
                    }
                    this._save();
                }
                catch (e) {
                    /* @__PURE__ */ _olDebugWarn('[FunnelAnalytics] trackView failed:', e);
                }
            },
            trackTicker: function (ticker) {
                try {
                    if (!_data)
                        return;
                    if (_data.tickersViewed.indexOf(ticker) < 0) {
                        _data.tickersViewed.push(ticker);
                    }
                    if (_data.totalSessions >= 5 && _data.tickersViewed.length >= 10) {
                        this._trackStage('power_user');
                    }
                    this._save();
                }
                catch (e) {
                    /* @__PURE__ */ _olDebugWarn('[FunnelAnalytics] trackTicker failed:', e);
                }
            },
            trackFeature: function (feature) {
                try {
                    if (!_data)
                        return;
                    if (_data.featuresUsed.indexOf(feature) < 0) {
                        _data.featuresUsed.push(feature);
                        this._trackStage('feature_used');
                        this._beacon('feature_used', { feature: feature });
                    }
                    this._save();
                }
                catch (e) {
                    /* @__PURE__ */ _olDebugWarn('[FunnelAnalytics] trackFeature failed:', e);
                }
            },
            trackWelcomeStage: function (stage) {
                try {
                    this._trackStage(stage);
                }
                catch (e) {
                    /* @__PURE__ */ _olDebugWarn('[FunnelAnalytics] trackWelcomeStage failed:', e);
                }
            },
            _startSession: function () {
                if (!_data)
                    return;
                _data.totalSessions++;
                const now = Date.now();
                if (_data.lastActive) {
                    const gap = now - _data.lastActive;
                    const gapHours = gap / 3600000;
                    if (gapHours > 1) {
                        _data.idlePeriods.push({
                            from: new Date(_data.lastActive).toISOString(),
                            to: new Date(now).toISOString(),
                            durationHours: Math.round(gapHours * 10) / 10,
                        });
                    }
                }
                if (_data.totalSessions > 1) {
                    const firstDay = new Date(_data.firstVisit).toDateString();
                    const today = new Date().toDateString();
                    if (firstDay !== today) {
                        this._trackStage('return_visit');
                    }
                }
                _data.currentSession = {
                    start: now,
                    viewsUsed: [],
                    tickersViewed: 0,
                };
                _data.lastActive = now;
            },
            _setupIdleDetection: function () {
                const self = this;
                let idleTimeout = null;
                const IDLE_THRESHOLD = 300000;
                function resetIdle() {
                    if (!_data)
                        return;
                    _data.lastActive = Date.now();
                    if (idleTimeout)
                        clearTimeout(idleTimeout);
                    idleTimeout = setTimeout(function () {
                        if (!_data)
                            return;
                        self._beacon('user_idle', {
                            lastView: _data.dropOffView,
                            sessionDuration: Date.now() - (_data.currentSession ? _data.currentSession.start : Date.now()),
                            viewCount: _data.viewSequence.length,
                        });
                    }, IDLE_THRESHOLD);
                }
                ['mousemove', 'keydown', 'scroll', 'touchstart'].forEach(function (evt) {
                    document.addEventListener(evt, resetIdle, { passive: true });
                });
                window.addEventListener('beforeunload', function () {
                    self._endSession();
                });
            },
            _endSession: function () {
                if (!_data)
                    return;
                if (_data.currentSession) {
                    _data.currentSession.end = Date.now();
                    _data.currentSession.duration = _data.currentSession.end - _data.currentSession.start;
                    _data.sessions.push(_data.currentSession);
                    if (_data.sessions.length > 50)
                        _data.sessions = _data.sessions.slice(-50);
                }
                this._save();
            },
            _beacon: function (event, data) {
                try {
                    if (!_data)
                        return;
                    // #110: `sessionId` added. Without it the server's INSERT violates
                    // analytics_events.session_id NOT NULL, so every one of the 10 stages
                    // was discarded. `funnel` names the series; the handler prefixes it.
                    navigator.sendBeacon('/api/analytics/funnel', JSON.stringify({
                        event: event,
                        data: data,
                        funnel: 'onboarding',
                        sessionId: window._olSessionId || String(_data.totalSessions || 0),
                        sessionNumber: _data.totalSessions,
                        timestamp: new Date().toISOString(),
                    }));
                }
                catch (_e) { /* beacon not supported */ }
            },
            _save: function () {
                try {
                    OLStorage.set(STORAGE_KEY, _data);
                }
                catch (_e) { /* storage full */ }
            },
            getReport: function () {
                if (!_data)
                    return null;
                const stageCount = Object.keys(_data.stages).length;
                let farthestStage = STAGES[0];
                for (let i = STAGES.length - 1; i >= 0; i--) {
                    if (_data.stages[STAGES[i]]) {
                        farthestStage = STAGES[i];
                        break;
                    }
                }
                return {
                    firstVisit: _data.firstVisit,
                    totalSessions: _data.totalSessions,
                    stagesReached: stageCount + '/' + STAGES.length,
                    farthestStage: farthestStage,
                    uniqueViewsUsed: new Set(_data.viewSequence.map(function (v) { return v.view; })).size,
                    tickersViewed: _data.tickersViewed.length,
                    featuresUsed: _data.featuresUsed,
                    dropOffView: _data.dropOffView,
                    avgSessionMinutes: _data.sessions.length > 0
                        ? Math.round(_data.sessions.reduce(function (s, x) {
                            return s + (x.duration || 0);
                        }, 0) / _data.sessions.length / 60000)
                        : 0,
                    idlePeriods: _data.idlePeriods.length,
                    stages: _data.stages,
                };
            },
            reset: function () {
                try {
                    OLStorage.remove(STORAGE_KEY);
                }
                catch (_e) { }
                _data = null;
            },
        };
        return api;
    })();
    if (typeof window !== 'undefined') {
        window.FunnelAnalytics = FunnelAnalyticsImpl;
    }
    // Auto-init (wrapped — analytics must never block page initialization)
    document.addEventListener('DOMContentLoaded', function () {
        try {
            FunnelAnalyticsImpl.init();
        }
        catch (e) {
            /* @__PURE__ */ _olDebugWarn('[FunnelAnalytics] init failed:', e);
        }
    });
})();
//# sourceMappingURL=funnel-analytics.js.map
;
// ═══ share-links.js ═══
;"use strict";
// ── share-links.js ───────────────────────────────────────────────────────
//
// TS Migration Phase 2 PR 35 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; share-links.js is the build
// artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
//
// Deep-link generation, share modal, annotation sharing. Encodes view
// state into base64-shareable URLs and surfaces a brand-consistent
// share modal with email / X / LinkedIn / clipboard targets.
const ShareLinks = {
    // D23 (2026-09-25): this palette carried 16 keys and exactly ONE was read
    // (`s.textPrimary`, the QR-code cell fill). The other 15 were dead and
    // several were off-brand on their face (a green-dim, an Inter/IBM Plex
    // font stack, a 6px radius that is off the sanctioned set) -- a stale
    // parallel palette waiting for a future reader to trust it. Only the
    // live key remains; the QR is drawn into an SVG string, so a CSS var()
    // cannot be used here and the literal is the dark-theme --text-primary.
    _s: {
        textPrimary: '#e8edf2',
    },
    _escHandler: null,
    generateLink: function () {
        const w = window;
        const state = {
            t: (typeof w.activeTicker !== 'undefined' ? w.activeTicker : '') || '',
            v: (typeof w.currentView !== 'undefined' ? w.currentView : 'ticker') || 'ticker',
            p: (typeof w.tickerChartPeriod !== 'undefined' ? w.tickerChartPeriod : '1y') || '1y',
            m: '',
        };
        const params = new URLSearchParams();
        for (const k in state) {
            if (Object.prototype.hasOwnProperty.call(state, k) && state[k]) {
                params.set(k, state[k]);
            }
        }
        return window.location.origin + '/?s=' + btoa(params.toString());
    },
    parseLink: function () {
        const url = new URL(window.location.href);
        const encoded = url.searchParams.get('s');
        if (!encoded)
            return null;
        try {
            const decoded = atob(encoded);
            const params = new URLSearchParams(decoded);
            return {
                ticker: params.get('t'),
                view: params.get('v'),
                period: params.get('p'),
                mode: params.get('m'),
            };
        }
        catch (_e) {
            return null;
        }
    },
    applySharedState: function () {
        const state = this.parseLink();
        if (!state)
            return false;
        const w = window;
        if (state.ticker && typeof w.switchTicker === 'function') {
            w.switchTicker(state.ticker);
        }
        if (state.view && typeof w.setView === 'function') {
            w.setView(state.view);
        }
        const annotation = this.parseAnnotation();
        if (annotation) {
            this._showAnnotationBanner(annotation);
        }
        return true;
    },
    generateShortCode: function () {
        const link = this.generateLink();
        let hash = 0;
        for (let i = 0; i < link.length; i++) {
            hash = ((hash << 5) - hash) + link.charCodeAt(i);
            hash |= 0;
        }
        return Math.abs(hash).toString(36).substring(0, 6).toUpperCase();
    },
    generateQR: function (url) {
        const s = this._s;
        const size = 160;
        const cells = 8;
        const cellSize = size / cells;
        let rects = '';
        let hash = 0;
        for (let i = 0; i < url.length; i++) {
            hash = ((hash << 5) - hash) + url.charCodeAt(i);
            hash |= 0;
        }
        let seed = Math.abs(hash);
        const positions = [
            [0, 0], [1, 0], [2, 0], [0, 1], [2, 1], [0, 2], [1, 2], [2, 2],
            [5, 0], [6, 0], [7, 0], [5, 1], [7, 1], [5, 2], [6, 2], [7, 2],
            [0, 5], [1, 5], [2, 5], [0, 6], [2, 6], [0, 7], [1, 7], [2, 7],
        ];
        for (let p = 0; p < positions.length; p++) {
            rects += '<rect x="' + (positions[p][0] * cellSize) + '" y="' +
                (positions[p][1] * cellSize) + '" width="' + cellSize +
                '" height="' + cellSize + '" fill="' + s.textPrimary + '"/>';
        }
        for (let row = 0; row < cells; row++) {
            for (let col = 0; col < cells; col++) {
                if ((row < 3 && col < 3) || (row < 3 && col > 4) || (row > 4 && col < 3))
                    continue;
                seed = (seed * 1103515245 + 12345) & 0x7fffffff;
                if (seed % 3 === 0) {
                    rects += '<rect x="' + (col * cellSize) + '" y="' + (row * cellSize) +
                        '" width="' + cellSize + '" height="' + cellSize +
                        '" fill="' + s.textPrimary + '" opacity="0.8"/>';
                }
            }
        }
        return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + size + ' ' +
            size + '" width="' + size + '" height="' + size +
            '" class="sl-qr-svg">' +
            '<rect width="' + size + '" height="' + size + '" fill="#fff"/>' +
            rects + '</svg>';
    },
    generateAnnotatedLink: function (annotation) {
        const link = this.generateLink();
        if (annotation) {
            return link + '#note=' + encodeURIComponent(annotation);
        }
        return link;
    },
    parseAnnotation: function () {
        const hash = window.location.hash;
        if (hash && hash.indexOf('note=') !== -1) {
            try {
                return decodeURIComponent(hash.split('note=')[1]);
            }
            catch (_e) {
                return null;
            }
        }
        return null;
    },
    _showAnnotationBanner: function (text) {
        const banner = document.createElement('div');
        banner.id = 'share-annotation-banner';
        banner.className = 'share-annotation-banner';
        const label = document.createElement('span');
        label.className = 'share-annotation-label';
        label.textContent = 'Shared Note';
        const msg = document.createElement('span');
        msg.className = 'share-annotation-msg';
        msg.textContent = text;
        const close = document.createElement('button');
        close.className = 'share-annotation-close';
        close.innerHTML = '&#x2715;';
        close.onclick = function () { banner.remove(); };
        banner.appendChild(label);
        banner.appendChild(msg);
        banner.appendChild(close);
        document.body.appendChild(banner);
        setTimeout(function () {
            if (banner.parentNode)
                banner.remove();
        }, 15000);
    },
    showShareModal: function () {
        const existing = document.getElementById('share-modal-overlay');
        if (existing)
            existing.remove();
        const link = this.generateLink();
        const shortCode = this.generateShortCode();
        const w = window;
        const ticker = (typeof w.activeTicker !== 'undefined' ? w.activeTicker : '') || '';
        const view = (typeof w.currentView !== 'undefined' ? w.currentView : '') || '';
        const self = this;
        const overlay = document.createElement('div');
        overlay.id = 'share-modal-overlay';
        overlay.className = 'share-modal-overlay';
        const modal = document.createElement('div');
        modal.id = 'share-modal-box';
        modal.className = 'share-modal-box';
        const title = document.createElement('div');
        title.className = 'share-modal-title';
        title.textContent = 'Share this view';
        const subtitle = document.createElement('div');
        subtitle.className = 'share-modal-subtitle';
        subtitle.textContent = (ticker ? ticker + ' — ' : '') + (view || 'dashboard');
        const linkSection = this._buildSection('Direct Link');
        const linkRow = document.createElement('div');
        linkRow.className = 'share-modal-row';
        const linkInput = document.createElement('input');
        linkInput.type = 'text';
        linkInput.readOnly = true;
        linkInput.value = link;
        linkInput.className = 'share-link-input share-modal-input';
        linkInput.addEventListener('focus', function () {
            this.classList.add('share-modal-input--focus');
            this.select();
        });
        linkInput.addEventListener('blur', function () { this.classList.remove('share-modal-input--focus'); });
        const copyBtn = document.createElement('button');
        copyBtn.textContent = 'Copy';
        copyBtn.className = 'share-btn';
        copyBtn.onclick = function () { self.copyLink(); };
        linkRow.appendChild(linkInput);
        linkRow.appendChild(copyBtn);
        linkSection.appendChild(linkRow);
        const annoSection = this._buildSection('Add a Note (optional)');
        const annoRow = document.createElement('div');
        annoRow.className = 'share-modal-row';
        const annoInput = document.createElement('input');
        annoInput.type = 'text';
        annoInput.id = 'share-annotation-input';
        annoInput.placeholder = 'e.g. "Check out this earnings trend"';
        annoInput.maxLength = 280;
        annoInput.className = 'share-modal-input share-modal-input--anno';
        annoInput.addEventListener('focus', function () { this.classList.add('share-modal-input--focus'); });
        annoInput.addEventListener('blur', function () { this.classList.remove('share-modal-input--focus'); });
        annoInput.addEventListener('input', function () {
            const note = this.value.trim();
            linkInput.value = note ? self.generateAnnotatedLink(note) : self.generateLink();
        });
        annoRow.appendChild(annoInput);
        annoSection.appendChild(annoRow);
        const codeSection = this._buildSection('Share Code');
        const codeDisplay = document.createElement('div');
        codeDisplay.className = 'share-code-display';
        codeDisplay.textContent = shortCode;
        const codeHint = document.createElement('div');
        codeHint.className = 'share-code-hint';
        codeHint.textContent = 'Enter at oxfordledge.com/?c=CODE';
        codeSection.appendChild(codeDisplay);
        codeSection.appendChild(codeHint);
        const shareSection = this._buildSection('Share via');
        const btnRow = document.createElement('div');
        btnRow.className = 'share-platform-row';
        const platforms = [
            { key: 'email', label: 'Email', icon: '✉' },
            { key: 'twitter', label: 'X / Twitter', icon: '𝓍' },
            { key: 'linkedin', label: 'LinkedIn', icon: 'in' },
            { key: 'clipboard', label: 'Copy link', icon: '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>' },
        ];
        for (let i = 0; i < platforms.length; i++) {
            (function (p) {
                const btn = document.createElement('button');
                btn.className = 'share-platform-btn';
                btn.innerHTML = '<div class="share-platform-icon">' + p.icon + '</div>' + p.label;
                btn.onclick = function () { self.shareVia(p.key); };
                btnRow.appendChild(btn);
            })(platforms[i]);
        }
        shareSection.appendChild(btnRow);
        const closeBtn = document.createElement('button');
        closeBtn.className = 'share-modal-close';
        closeBtn.innerHTML = '&#x2715;';
        closeBtn.onclick = function () { self.closeShareModal(); };
        modal.appendChild(closeBtn);
        modal.appendChild(title);
        modal.appendChild(subtitle);
        modal.appendChild(linkSection);
        modal.appendChild(annoSection);
        modal.appendChild(codeSection);
        modal.appendChild(shareSection);
        overlay.appendChild(modal);
        overlay.onclick = function (e) {
            if (e.target === overlay)
                self.closeShareModal();
        };
        document.body.appendChild(overlay);
        this._escHandler = function (e) {
            if (e.key === 'Escape')
                self.closeShareModal();
        };
        document.addEventListener('keydown', this._escHandler);
        setTimeout(function () { linkInput.focus(); }, 100);
    },
    closeShareModal: function () {
        const overlay = document.getElementById('share-modal-overlay');
        if (overlay)
            overlay.remove();
        if (this._escHandler) {
            document.removeEventListener('keydown', this._escHandler);
            this._escHandler = null;
        }
    },
    shareVia: function (platform) {
        const annoInput = document.getElementById('share-annotation-input');
        const annotation = annoInput ? annoInput.value.trim() : '';
        const link = annotation ? this.generateAnnotatedLink(annotation) : this.generateLink();
        const w = window;
        const ticker = (typeof w.activeTicker !== 'undefined' ? w.activeTicker : '') || 'this';
        const text = 'Check out ' + ticker + ' on Oxford Ledge';
        switch (platform) {
            case 'email':
                window.open('mailto:?subject=' + encodeURIComponent(text) +
                    '&body=' + encodeURIComponent(text + '\n\n' + link +
                    (annotation ? '\n\nNote: ' + annotation : '')));
                break;
            case 'twitter':
                window.open('https://x.com/intent/post?text=' +
                    encodeURIComponent(text + (annotation ? ' — "' + annotation + '"' : '')) +
                    '&url=' + encodeURIComponent(link), '_blank', 'noopener,noreferrer');
                break;
            case 'linkedin':
                window.open('https://www.linkedin.com/sharing/share-offsite/?url=' +
                    encodeURIComponent(link), '_blank', 'noopener,noreferrer');
                break;
            case 'clipboard':
                this._copyToClipboard(link + (annotation ? '\n\nNote: ' + annotation : ''));
                break;
        }
    },
    copyLink: function () {
        const input = document.querySelector('.share-link-input');
        if (input) {
            this._copyToClipboard(input.value);
            const w = window;
            if (typeof trackUniqueAchievement === 'function')
                trackUniqueAchievement('shares_total', (typeof w.activeTicker !== 'undefined' ? w.activeTicker : '') + '_copylink');
        }
    },
    _copyToClipboard: function (text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(function () {
                if (typeof showToast === 'function')
                    showToast('Link copied!', 'success', 2000);
            }).catch(function () {
                ShareLinks._fallbackCopy(text);
            });
        }
        else {
            this._fallbackCopy(text);
        }
    },
    _fallbackCopy: function (text) {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.className = 'sr-offscreen';
        document.body.appendChild(ta);
        ta.select();
        try {
            document.execCommand('copy');
            if (typeof showToast === 'function')
                showToast('Link copied!', 'success', 2000);
        }
        catch (_e) {
            if (typeof showToast === 'function')
                showToast('Unable to copy to clipboard. Please select and copy manually.', 'error', 3000);
        }
        document.body.removeChild(ta);
    },
    _buildSection: function (labelText) {
        const section = document.createElement('div');
        section.className = 'share-modal-section';
        const label = document.createElement('div');
        label.className = 'share-modal-section-label';
        label.textContent = labelText;
        section.appendChild(label);
        return section;
    },
};
document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        ShareLinks.applySharedState();
    }, 1000);
});
void ShareLinks;
//# sourceMappingURL=share-links.js.map
;
// ═══ aria-labels.js ═══
;"use strict";
/* ═══════════════════════════════════════════════════════════════
   aria-labels.js — ARIA label injection for metric abbreviations
   Oxford Ledge · extracted from dashboard.html inline <script>
   ═══════════════════════════════════════════════════════════════
   TS Migration Phase 2 PR 15 (2026-05-04): renamed .js → .ts.
   Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.

   This file is now the SOURCE OF TRUTH; the sibling aria-labels.js
   is the build artifact produced by `npx tsc -p tsconfig.build.json`
   (gitignored). Self-contained: no cross-chunk surface.

   CSP note (2026-04-04): this file was previously an inline <script>
   block at dashboard.html:2096. The CSP `script-src` directive is
   set to `'self' <CDN allowlist>` with NO `'unsafe-inline'`, which
   silently blocked the inline script in the browser. This extraction
   restores the ARIA label functionality that had been broken for
   an unknown period. See docs/CISO_AUDIT_POST_PHASE3.md and the
   security hotfix commit for context.
*/
(function () {
    const ariaMap = {
        'P/E': 'Price to Earnings ratio',
        'P/E (x)': 'Price to Earnings ratio',
        'P/E (TTM)': 'Price to Earnings ratio, trailing twelve months',
        'P/E (Fwd)': 'Forward Price to Earnings ratio',
        'EV/EBITDA': 'Enterprise Value to Earnings Before Interest Taxes Depreciation and Amortization',
        'P/B': 'Price to Book ratio',
        'P/S': 'Price to Sales ratio',
        'ROE': 'Return on Equity',
        'ROIC': 'Return on Invested Capital',
        'D/E': 'Debt to Equity ratio',
        'FCF': 'Free Cash Flow',
        'EPS': 'Earnings Per Share',
        'YTD': 'Year to Date',
        'Mkt Cap': 'Market Capitalization',
        'Wt %': 'Portfolio Weight percentage',
        'Ret %': 'Return percentage',
        'Vol': 'Trading Volume',
    };
    function addAriaLabels() {
        document.querySelectorAll('th').forEach(function (th) {
            const txt = (th.textContent || '').trim();
            if (ariaMap[txt] && !th.getAttribute('aria-label')) {
                th.setAttribute('aria-label', ariaMap[txt]);
            }
        });
    }
    // Debounce (#31 / CHAOS P3-1, 2026-05-30): a full-document
    // querySelectorAll('th') scan on EVERY body mutation is brutal on
    // WS-tick-heavy views (ticker / portfolio fire hundreds of mutations/sec).
    // Coalesce to one scan per 150ms idle — mirrors responsive-tables.ts:133.
    let _ariaTimer = null;
    const obs = new MutationObserver(function () {
        if (_ariaTimer)
            return;
        _ariaTimer = setTimeout(function () {
            _ariaTimer = null;
            addAriaLabels();
        }, 150);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', addAriaLabels);
})();
//# sourceMappingURL=aria-labels.js.map
;
// ═══ age-gate.js ═══
;"use strict";
// §AGE-GATE  COPPA/GDPR first-visit age disclosure banner (COUNSEL-C5)
// ═══════════════════════════════════════════════════════════════════════
//
// TS Migration Phase 2 PR 16 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is now the SOURCE OF TRUTH; the sibling age-gate.js
// is the build artifact produced by `./node_modules/.bin/tsc -p tsconfig.build.json`.
//
// QA-02 (anonymous browser audit 2026-09-28, P0 COPPA): the "Under 13" button
// used to answer with the 13-17 parental-consent copy and a "Sign up with
// parental consent" link that opened the register modal -- a child who said
// they were under 13 was pointed at sign-up. The three answers are now
// separate branches:
//   - Got it     -> 'true'; the bar goes.
//   - 13 to 17   -> the parental-consent copy + the sign-up link (the server
//                   takes a teen sign-up with a parent's email, see below).
//   - Under 13   -> a plain statement that Oxford Ledge is for people 13 and
//                   older. NO link, NO button, no path to the register modal.
//                   The answer is stored ('under_13') so a reload shows the
//                   same statement instead of offering the choice again (the
//                   FTC neutral-age-screen guidance: a child must not be able
//                   to go back and pick a different age).
// What the server enforces (services/auth.py create_user +
// services/age_gate.py): a date of birth is required at sign-up; under 13 is
// refused; 13-17 must give a parent's email, and AI and paid plans stay off
// until the parent confirms by email. Nothing is enforced for an anonymous
// reader -- this bar is a notice, not a lock.
// Pinned by tests/test_age_gate_under13_contract.py (executes the emit).
(function _ageGateBanner() {
    let stored = null;
    try {
        stored = OLStorage.getString('ol_age_verified', null);
    }
    catch (_e) {
        return;
    }
    // 'under_13' is the one stored answer that keeps the bar up.
    if (stored && stored !== 'under_13')
        return;
    function show() {
        const bar = document.createElement('div');
        bar.id = 'ol-age-gate';
        bar.setAttribute('role', 'dialog');
        bar.setAttribute('aria-label', 'Age notice');
        bar.className = 'csp-consent-bar';
        // QA-06: the old first line said "We ask for your date of birth" on a bar
        // that asks for nothing. The rule leads (the one line a phone shows); the
        // voice line and the data-handling reassurance ride in a detail span that
        // collapses on mobile. Wording of the reassurance matches the privacy
        // policy verbatim ("never sold", account deletion).
        const msg = document.createElement('span');
        msg.className = 'csp-consent-msg';
        const rule = document.createElement('span');
        rule.textContent = 'You must be 13 or older to use Oxford Ledge.';
        msg.appendChild(rule);
        const detail = document.createElement('span');
        detail.className = 'csp-consent-detail';
        detail.textContent = ' Oxford Ledge is a place to learn how markets and companies work. Your data is encrypted in transit, never sold, and you can delete your account anytime.';
        msg.appendChild(detail);
        bar.appendChild(msg);
        // The value "Got it" stores. The 13-17 branch switches it to
        // 'minor_pending' so Settings reads a teen as a minor without consent,
        // never as a verified adult.
        let continueValue = 'true';
        const btnContinue = document.createElement('button');
        btnContinue.textContent = 'Got it';
        btnContinue.className = 'csp-consent-btn-primary';
        btnContinue.onclick = function () {
            try {
                OLStorage.setString('ol_age_verified', continueValue);
            }
            catch (_e) { }
            bar.remove();
            document.body.classList.remove('ol-age-gate-active');
            // LCP fix (2026-06-23): theme-init.js stamped html.ol-cc-hide pre-paint to
            // keep the (now default-visible) cookie banner suppressed while this gate
            // owned the bottom bar. Clear it so the cookie notice surfaces post-gate.
            document.documentElement.classList.remove('ol-cc-hide');
        };
        bar.appendChild(btnContinue);
        // Both minor-answer buttons exist before either handler can run.
        const btnTeen = document.createElement('button');
        const btnMinor = document.createElement('button');
        btnTeen.textContent = '13 to 17';
        btnTeen.className = 'csp-consent-btn-minor';
        btnTeen.onclick = function () {
            continueValue = 'minor_pending';
            // S5 (2026-09-25): same voice as the first sentence above. Since the
            // OWNER ruling of 2026-10-03 the server emails the parent at sign-up
            // (services/parental_consent.py); Settings "Request consent" re-sends.
            msg.textContent = 'If you are 13 to 17, you can sign up with a parent’s or guardian’s consent: we email them a link when you sign up. Until they confirm, AI features and paid plans stay off. ';
            const link = document.createElement('a');
            link.textContent = 'Sign up with parental consent';
            link.href = '#';
            link.className = 'csp-consent-link';
            link.onclick = function (e) {
                e.preventDefault();
                try {
                    OLStorage.setString('ol_age_verified', 'minor_pending');
                }
                catch (_e2) { }
                bar.remove();
                document.body.classList.remove('ol-age-gate-active');
                document.documentElement.classList.remove('ol-cc-hide');
                // auth-handlers.ts authOpenModal is the opener. This called
                // window.showAuthModal, which nothing defines, and fell back to adding
                // .active to #auth-modal, which is not how the modal opens -- so the
                // link closed the bar and opened nothing (found 2026-10-03).
                const w = window;
                if (typeof w.authOpenModal === 'function') {
                    w.authOpenModal('register');
                }
                else {
                    window.location.href = '/?signup=1';
                }
            };
            msg.appendChild(link);
            btnTeen.classList.add('hidden');
            btnMinor.classList.add('hidden');
        };
        bar.appendChild(btnTeen);
        btnMinor.textContent = 'Under 13';
        btnMinor.className = 'csp-consent-btn-minor';
        // QA-02: a statement, nothing to click. The bar stays (no dismiss path).
        function showUnder13() {
            msg.textContent = 'Oxford Ledge is for people 13 and older.';
            btnContinue.classList.add('hidden');
            btnTeen.classList.add('hidden');
            btnMinor.classList.add('hidden');
        }
        btnMinor.onclick = function () {
            try {
                OLStorage.setString('ol_age_verified', 'under_13');
            }
            catch (_e) { }
            // OWNER 2026-10-03: from this click on, this browser sees no sign-up
            // affordance and sends no analytics (OL-UNDER13-GUARD, theme-init.ts).
            const w = window;
            if (typeof w.olInstallUnder13Guard === 'function')
                w.olInstallUnder13Guard();
            showUnder13();
        };
        bar.appendChild(btnMinor);
        if (stored === 'under_13')
            showUnder13();
        document.body.appendChild(bar);
        // Suppress the cookie-consent banner while this legal age-gate is up so the
        // two bottom-fixed consent bars don't collide (#1, 2026-06-02 audit). The
        // class is removed on either dismiss path (Got it / parental-consent link).
        document.body.classList.add('ol-age-gate-active');
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', show);
    }
    else {
        show();
    }
})();
//# sourceMappingURL=age-gate.js.map
;
// ═══ tooltip-tour.js ═══
;"use strict";
// §TOUR ════════════════════════════════════════════════════════════════════════
//
// TS Migration Phase 2 PR 25 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; tooltip-tour.js is the build
// artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
//
// First-time onboarding tooltip tour (P1.3) + the SSE stream loop
// for server-pushed headlines / indicators / ticker updates.
// Top-level functions become bundle-IIFE-scope bindings consumed by
// app.js (skipTour / nextTourStep / replayTour / _connectSSE).
function _hydrateTTStyles(rootEl) {
    if (!rootEl || typeof rootEl.querySelectorAll !== 'function')
        return;
    rootEl.querySelectorAll('[data-fg],[data-bg]').forEach(function (n) {
        const html = n;
        const ds = html.dataset;
        if (ds.fg)
            html.style.color = ds.fg;
        if (ds.bg)
            html.style.backgroundColor = ds.bg;
    });
}
// ── FIRST-TIME TOOLTIP TOUR (P1.3) ──
const TOUR_STEPS = [
    { target: '#ticker-input', text: 'Look up any company by name or ticker symbol', position: 'bottom' },
    { target: '#view-news-btn', text: 'See what\u2019s happening in the markets right now', position: 'bottom' },
    { target: '#view-ticker-btn', text: 'Dive into a company\u2019s financials, price history, and key metrics', position: 'bottom' },
    // SF-23 vestige removed 2026-05-17: tour step targeting the deleted #more-dropdown-btn anchor.
    { target: '#cmd-trigger', text: 'Quick search — look up any company, term, or feature', position: 'bottom' },
];
let _tourStep = 0;
// S6 (first-time-user audit, 2026-09-25): `startTour()` was deleted. Its only
// call site was the commented-out `setTimeout(startTour, 2000)` in
// app-renderers.ts ("Old tour disabled — walkthrough.js handles onboarding");
// no test, template or module named it. The live first-time walkthrough is
// the `walkthrough` chunk that app-init.ts auto-fires for beginners at the
// ticker view, so wiring this tour to it would have started two tours. The
// step machinery below stays because app-renderers.ts still binds
// `skip-tour` / `next-tour-step` to skipTour / nextTourStep (see that file's
// delegate-action map) and replayTour is the remaining entry point.
function _showTourStep() {
    // Remove any existing tour tooltip
    const old = document.getElementById('tour-tooltip');
    if (old)
        old.remove();
    if (_tourStep >= TOUR_STEPS.length) {
        OLStorage.setString('tourCompleted', '1');
        _showNextActionToast();
        return;
    }
    const step = TOUR_STEPS[_tourStep];
    const target = document.querySelector(step.target);
    if (!target) {
        // Retry once after a short delay (lazy-loaded elements may not exist yet)
        if (!step._retried) {
            step._retried = true;
            setTimeout(_showTourStep, 500);
            return;
        }
        // Still missing — skip this step
        _tourStep++;
        _showTourStep();
        return;
    }
    const rect = target.getBoundingClientRect();
    const tooltip = document.createElement('div');
    tooltip.id = 'tour-tooltip';
    tooltip.innerHTML = '<div class="tour-text">' + escHtml(step.text) + '</div>'
        + '<div class="tour-footer">'
        + '<span class="tour-counter">' + (_tourStep + 1) + ' of ' + TOUR_STEPS.length + '</span>'
        + '<div class="tour-btn-group">'
        + '<button data-action="skip-tour" class="tour-skip-btn">Skip</button>'
        + '<button data-action="next-tour-step" class="tour-next-btn">' + (_tourStep < TOUR_STEPS.length - 1 ? 'Next' : 'Done') + '</button>'
        + '</div></div>';
    tooltip.className = 'csp-tooltip-fixed';
    // Position below the target
    let top = rect.bottom + 8;
    const left = Math.max(8, Math.min(rect.left, window.innerWidth - 300));
    if (top + 120 > window.innerHeight) {
        top = rect.top - 120;
    } // flip above if near bottom
    tooltip.style.top = top + 'px';
    tooltip.style.left = left + 'px';
    document.body.appendChild(tooltip);
    // Highlight target
    target.style.outline = '2px solid var(--accent-blue)';
    target.style.outlineOffset = '2px';
    target.dataset.tourHighlight = '1';
}
function nextTourStep() {
    // Remove highlight from current target
    const step = TOUR_STEPS[_tourStep];
    if (step) {
        const target = document.querySelector(step.target);
        if (target && target.dataset.tourHighlight) {
            target.style.outline = '';
            target.style.outlineOffset = '';
            delete target.dataset.tourHighlight;
        }
    }
    _tourStep++;
    _showTourStep();
}
function skipTour() {
    // Clean up all highlights
    TOUR_STEPS.forEach(function (s) {
        const t = document.querySelector(s.target);
        if (t) {
            t.style.outline = '';
            t.style.outlineOffset = '';
        }
    });
    const old = document.getElementById('tour-tooltip');
    if (old)
        old.remove();
    OLStorage.setString('tourCompleted', '1');
    _showNextActionToast();
}
// T3 (UX walkthrough quorum 2026-05-12): after the tour ends or is
// skipped, surface a non-blocking "what should I do next" toast.
// Closes Sarah's #1 confusion from the walkthrough ("tour ends and
// I'm staring at a blank dashboard"). Two suggested actions: jump
// to AAPL (familiar starter ticker) or browse trending headlines.
// Dismissible; one-shot per browser per origin.
function _showNextActionToast() {
    try {
        if (OLStorage.getString('ol_tour_next_action_seen', null) === '1')
            return;
    }
    catch (e) { /* noop */ }
    // Defer slightly so the highlight cleanup paints first.
    setTimeout(function () {
        const old = document.getElementById('tour-next-action-toast');
        if (old)
            old.remove();
        const toast = document.createElement('div');
        toast.id = 'tour-next-action-toast';
        toast.className = 'tour-next-action-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        // Build via DOM construction (not innerHTML) — keeps the
        // pattern-ratchet count flat. All text is static + literal so
        // there is no XSS risk either way, but the ratchet treats every
        // innerHTML assignment as guilty-until-proven-innocent.
        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'tour-toast-close';
        closeBtn.dataset.action = 'tour-toast-close';
        closeBtn.setAttribute('aria-label', 'Dismiss');
        closeBtn.textContent = '×';
        toast.appendChild(closeBtn);
        const eyebrow = document.createElement('div');
        eyebrow.className = 'tour-toast-eyebrow';
        eyebrow.textContent = 'YOU’RE ALL SET';
        toast.appendChild(eyebrow);
        const title = document.createElement('div');
        title.className = 'tour-toast-title';
        title.textContent = 'Where to start?';
        toast.appendChild(title);
        const body = document.createElement('div');
        body.className = 'tour-toast-body';
        body.textContent = 'Try a familiar name, or scan what’s moving in markets.';
        toast.appendChild(body);
        const actions = document.createElement('div');
        actions.className = 'tour-toast-actions';
        const goAapl = document.createElement('a');
        goAapl.className = 'tour-toast-cta tour-toast-cta--primary';
        goAapl.href = '/stock/AAPL/';
        goAapl.dataset.action = 'tour-toast-go-aapl';
        goAapl.textContent = 'Look up AAPL →';
        actions.appendChild(goAapl);
        const goNews = document.createElement('a');
        goNews.className = 'tour-toast-cta tour-toast-cta--secondary';
        goNews.href = '/?view=news';
        goNews.dataset.action = 'tour-toast-go-news';
        goNews.textContent = 'Browse trending →';
        actions.appendChild(goNews);
        toast.appendChild(actions);
        document.body.appendChild(toast);
        // One-shot — mark seen so it doesn't re-fire on later sessions.
        try {
            OLStorage.setString('ol_tour_next_action_seen', '1');
        }
        catch (e) { /* noop */ }
        // Telemetry — fire-and-forget.
        try {
            if (typeof window._track === 'function') {
                window._track('tour_next_action_shown', {});
            }
        }
        catch (e) { /* noop */ }
        // Auto-dismiss after 14s if the user doesn't engage.
        setTimeout(function () {
            const t = document.getElementById('tour-next-action-toast');
            if (t && !t.dataset.engaged)
                t.remove();
        }, 14000);
    }, 320);
}
// Event-delegated close + telemetry handlers. Registered on the
// document so the toast can be CSP-safe (no inline onclick).
if (typeof document !== 'undefined') {
    document.addEventListener('click', function (ev) {
        const target = ev.target;
        if (!target)
            return;
        const action = target.closest('[data-action]')?.dataset.action;
        if (!action)
            return;
        if (action === 'tour-toast-close') {
            const t = document.getElementById('tour-next-action-toast');
            if (t) {
                t.dataset.engaged = '1';
                t.remove();
            }
            try {
                if (typeof window._track === 'function') {
                    window._track('tour_next_action_dismissed', {});
                }
            }
            catch (e) { /* noop */ }
        }
        else if (action === 'tour-toast-go-aapl' || action === 'tour-toast-go-news') {
            const t = document.getElementById('tour-next-action-toast');
            if (t)
                t.dataset.engaged = '1';
            try {
                if (typeof window._track === 'function') {
                    window._track('tour_next_action_clicked', { action: action });
                }
            }
            catch (e) { /* noop */ }
        }
    });
}
function replayTour() {
    OLStorage.remove('tourCompleted');
    TOUR_STEPS.forEach(function (s) { delete s._retried; });
    _tourStep = 0;
    _showTourStep();
}
// S27: SSE stream for server-pushed data (replaces polling)
//
// WP-G (2026-09-26 external review, P1-1): the backoff counter used to be reset
// synchronously right after `new EventSource`, BEFORE the stream opened, so every
// onerror recomputed the FIRST delay: always 5s, the 120s cap never reached, no
// jitter (every tab of a restarted server reconnected in lockstep). The reset now
// lives in onopen, the delay carries +/-30% jitter under a hard 120s cap, and the
// loop stops after _SSE_MAX_RECONNECT_ATTEMPTS (shape copied from ws-client.ts).
// A tab hidden for 60s closes its stream (/api/stream holds a server session and
// counts toward the anonymous per-minute budget); visibilitychange and a bfcache
// pageshow reopen it -- before this, pagehide closed it and nothing reopened it.
let _sseStream = null;
let _sseReconnectAttempts = 0;
let _sseReconnectTimer = null;
let _sseHiddenTimer = null;
let _sseWanted = false; // true once the app asked for the stream; resume only reopens a wanted one
const _SSE_BASE_DELAY_MS = 5000;
const _SSE_MAX_DELAY_MS = 120000;
const _SSE_MAX_RECONNECT_ATTEMPTS = 20;
const _SSE_HIDDEN_CLOSE_MS = 60000;
function _sseReconnectDelay(attempt) {
    const base = Math.min(_SSE_BASE_DELAY_MS * Math.pow(1.5, attempt - 1), _SSE_MAX_DELAY_MS);
    return Math.min(Math.round(base * (0.7 + Math.random() * 0.6)), _SSE_MAX_DELAY_MS);
}
function _sseClose() {
    try {
        if (_sseStream)
            _sseStream.close();
    }
    catch (_e) { }
    _sseStream = null;
    if (_sseReconnectTimer) {
        clearTimeout(_sseReconnectTimer);
        _sseReconnectTimer = null;
    }
}
// Reopen after a hidden-tab close, a bfcache restore or a spent retry budget: a
// returning reader gets a fresh attempt cycle. A no-op while a stream or a pending
// reconnect exists, and before the app ever asked for the stream.
function _sseResume() {
    if (!_sseWanted || _sseStream || _sseReconnectTimer)
        return;
    if (typeof document !== 'undefined' && document.hidden)
        return;
    _sseReconnectAttempts = 0;
    _connectSSE();
}
// P1-15 (WP-G 2026-09-26): an SSE `headlines` push used to rewrite
// #market-headlines.innerHTML unconditionally -- destroying the news view's
// IntersectionObserver sentinel, any Prior/Search results the reader was looking
// at, and the client filters (CLAUDE.md "DOM rebuilds"). headlinesCache is always
// updated by the handler; the COLUMN is repainted only when the news view is
// current and the reader is on the Live list, and then through renderNewsView()
// (which keeps its sentinel + filters) when the news chunk is loaded. The inline
// renderer below is the no-chunk fallback only.
//
// CHAOS 2026-09-26 (docs/board/audit/2026-09-26_CHAOS_wave3_sse_news.md): that
// renderNewsView() is a FULL repaint -- it innerHTMLs the wire back to its first
// 20 rows (dropping every lazily appended page), rebuilds the Company & Industry
// column, the filter chips and the indicator rail. Run under a reader, it yanks a
// scrolled list back to its top, drops keyboard focus to <body> and repaints
// behind an open preview. So the push repaints only while the reader is AT REST
// (_sseNewsReaderBusy false); otherwise it re-arms and retries every 30s until
// they are. headlinesCache is fresh either way, so the next repaint (or the
// reader's own filter click) shows the new rows.
const _SSE_REPAINT_RETRY_MS = 30000;
function _sseNewsReaderBusy() {
    if (typeof document === 'undefined')
        return false;
    if (document.hidden)
        return true;
    if (typeof document.querySelector === 'function' && document.querySelector('.news-preview-overlay'))
        return true;
    const view = document.getElementById('news-view');
    const ae = document.activeElement;
    if (view && ae && ae !== document.body && typeof view.contains === 'function' && view.contains(ae))
        return true;
    const ids = ['market-headlines', 'portfolio-news'];
    for (let i = 0; i < ids.length; i++) {
        const el = document.getElementById(ids[i]);
        if (!el)
            continue;
        // Scrolled INTO the list: its top edge is above the viewport (document scroll) ...
        if (typeof el.getBoundingClientRect === 'function' && el.getBoundingClientRect().top < 0)
            return true;
        // ... or the list / its panel scrolls on its own (the stacked mobile layout).
        for (let n = el; n && n !== view && n !== document.body; n = n.parentElement) {
            if ((n.scrollTop || 0) > 0)
                return true;
        }
    }
    return false;
}
function _sseRepaintHeadlines() {
    if (typeof currentView === 'undefined' || currentView !== 'news')
        return;
    if (typeof _headlinesMode !== 'undefined' && _headlinesMode !== 'live')
        return;
    if (_sseNewsReaderBusy()) {
        const dw = window;
        if (dw._sseHeadlineDebounce)
            clearTimeout(dw._sseHeadlineDebounce);
        dw._sseHeadlineDebounce = setTimeout(_sseRepaintHeadlines, _SSE_REPAINT_RETRY_MS);
        return;
    }
    if (typeof renderNewsView === 'function') {
        try {
            void Promise.resolve(renderNewsView()).catch(function () { });
        }
        catch (_e) { }
        return;
    }
    const el = document.getElementById('market-headlines');
    if (el && Array.isArray(headlinesCache) && headlinesCache.length > 0) {
        // The SSE payload is the raw feed roster, videogame desks included (a PC Gamer
        // "seamstress sim" review led this column live on 2026-09-26). Apply the news
        // view's own source exclusion when it is loaded.
        const _ex = window.NEWS_EXCLUDED_SOURCES;
        el.innerHTML = headlinesCache.filter(function (n) {
            return !(_ex && _ex.has(String(n.source || '')));
        }).slice(0, 40).map(function (n) {
            const src = escHtml(n.source || '');
            // timeAgo() CAPS relative time at 7 days and returns null beyond
            // that (its documented "caller falls back to an absolute date"
            // contract). The prior code concatenated that null straight into
            // innerHTML, so every 7d+ article rendered the literal text "null"
            // as its timestamp (OWNER 2026-07-19). Fall back to a calendar
            // date (year-qualified when it isn't the current year, so an
            // 18-month-old wire item can't masquerade as recent).
            let ago = typeof timeAgo === 'function' ? timeAgo(n.date) : null;
            if (!ago && n.date) {
                const _d = new Date(String(n.date).replace(' ', 'T'));
                if (!isNaN(_d.getTime())) {
                    const _sameYear = _d.getFullYear() === new Date().getFullYear();
                    ago = escHtml(_d.toLocaleDateString(undefined, _sameYear
                        ? { month: 'short', day: 'numeric' }
                        : { month: 'short', day: 'numeric', year: 'numeric' }));
                }
            }
            if (!ago)
                ago = '';
            return '<div class="tt-headline-row">' +
                '<div class="tt-headline-body">' +
                '<a href="' + escHtml(safeHttpUrl(n.url)) + '" target="_blank" rel="noopener" class="tt-headline-link">' +
                escHtml(n.headline || '') + '</a>' +
                '<div class="tt-headline-meta">' +
                (src ? '<span class="tt-source-badge">' + src + '</span>' : '') +
                '</div></div>' +
                '<span class="tt-headline-age">' + ago + '</span>' +
                '</div>';
        }).join('');
    }
}
function _connectSSE() {
    _sseWanted = true;
    // #73: a pending reconnect timer may have scheduled this call. Clear it first
    // so a timer-fired reconnect AND a separate _connectSSE() can't both pass the
    // `if (_sseStream) return` guard (which only catches an ALREADY-open stream)
    // and open two concurrent EventSources to /api/stream.
    if (_sseReconnectTimer) {
        clearTimeout(_sseReconnectTimer);
        _sseReconnectTimer = null;
    }
    if (_sseStream)
        return;
    if (typeof EventSource === 'undefined') {
        console.warn('[SSE] EventSource not supported in this browser');
        return;
    }
    try {
        _sseStream = new EventSource('/api/stream');
        _sseStream.onopen = function () {
            _sseReconnectAttempts = 0; // reset backoff only once the stream is actually open
            /* @__PURE__ */ _olDebug('[SSE] Connected to /api/stream');
        };
        _sseStream.addEventListener('headlines', function (e) {
            try {
                const data = JSON.parse(e.data);
                headlinesCache = data;
                // Debounce headline rendering to avoid rapid-fire DOM thrashing
                const dw = window;
                if (dw._sseHeadlineDebounce)
                    clearTimeout(dw._sseHeadlineDebounce);
                dw._sseHeadlineDebounce = setTimeout(_sseRepaintHeadlines, 5000); // 5s debounce on headline rendering
            }
            catch (err) {
                console.warn('[SSE] headlines parse error:', err);
            }
        });
        _sseStream.addEventListener('indicators', function (e) {
            try {
                const data = JSON.parse(e.data);
                indicatorsCache = data;
                if (typeof renderMarketPulse === 'function')
                    renderMarketPulse();
                // Debounce LIVE view re-render (same as WS market-pulse — prevents briefing flicker)
                if (currentView === 'macro') {
                    const dw = window;
                    if (dw._macroPulseDebounce)
                        clearTimeout(dw._macroPulseDebounce);
                    dw._macroPulseDebounce = setTimeout(function () {
                        if (typeof renderMacroView === 'function') {
                            try {
                                renderMacroView();
                            }
                            catch (_e) { }
                        }
                        else if (typeof _inlineRenderMacro === 'function') {
                            try {
                                _inlineRenderMacro();
                            }
                            catch (_e) { }
                        }
                    }, 30000);
                }
            }
            catch (err) {
                console.warn('[SSE] indicators parse error:', err);
            }
        });
        _sseStream.addEventListener('ticker', function (e) {
            try {
                const data = JSON.parse(e.data);
                const ticker = data.ticker;
                if (ticker && data.data) {
                    // Merge SSE data into existing cache — don't overwrite enriched fields
                    const existing = (dataCache[ticker] || {});
                    const incoming = data.data;
                    // Preserve local-DB-enriched financials/metrics if SSE sends nulls
                    const exFin = existing.financials;
                    const inFin = incoming.financials;
                    if (exFin && inFin) {
                        for (const fk in exFin) {
                            if (exFin[fk] != null && (inFin[fk] == null || inFin[fk] === 0)) {
                                inFin[fk] = exFin[fk];
                            }
                        }
                    }
                    const exMet = existing.metrics;
                    const inMet = incoming.metrics;
                    if (exMet && inMet) {
                        for (const mk in exMet) {
                            if (exMet[mk] != null && inMet[mk] == null) {
                                inMet[mk] = exMet[mk];
                            }
                        }
                    }
                    dataCache[ticker] = incoming;
                    _evictDataCache();
                    // SSE ticker updates only refresh cache — do NOT call the FULL render
                    // functions. renderData/renderPortfolio/renderWatchlist all trigger
                    // API fetches that cause request storms (240+ on ticker, 90+ on
                    // watchlist, 166+ on news). Full render only on user navigation.
                    // NARROW EXCEPTION (2026-09-01): a phase-2 envelope for the ticker
                    // the user is LOOKING AT re-renders only the phase-2 panels via
                    // updatePhase2Panels — audited fetch-free end to end (incl. its
                    // renderComboChart/renderEarningsHistory/renderInstitutionalHolders
                    // callees: zero fetch/OLApi/TierGate calls), so the storm rule
                    // above is not violated. Without this, the enriched payload sat in
                    // dataCache UNRENDERED and the Y/Y column stayed blank for the
                    // page-life on staged loads (OWNER report, measured live). Hidden
                    // tabs skip it — the countdown's visible-return refresh covers them.
                    if (data.phase === 2 && !document.hidden
                        && typeof activeTicker !== 'undefined' && activeTicker === ticker
                        && typeof updatePhase2Panels === 'function') {
                        try {
                            updatePhase2Panels(dataCache[ticker]);
                        }
                        catch (_e) { /* narrow update must never break the stream */ }
                    }
                }
            }
            catch (err) {
                console.warn('[SSE] ticker parse error:', err);
            }
        });
        _sseStream.onerror = function () {
            // Close stale EventSource and schedule manual reconnect with exponential backoff
            try {
                if (_sseStream)
                    _sseStream.close();
            }
            catch (_e) { }
            _sseStream = null;
            _sseReconnectAttempts = (_sseReconnectAttempts || 0) + 1;
            if (_sseReconnectAttempts > _SSE_MAX_RECONNECT_ATTEMPTS) {
                /* @__PURE__ */ _olDebug('[SSE] Max reconnect attempts reached; the stream reopens when the tab is next shown');
                return;
            }
            const delay = _sseReconnectDelay(_sseReconnectAttempts);
            /* @__PURE__ */ _olDebug('[SSE] Connection error, reconnecting in ' + Math.round(delay / 1000) + 's (attempt ' + _sseReconnectAttempts + '/' + _SSE_MAX_RECONNECT_ATTEMPTS + ')');
            _sseReconnectTimer = setTimeout(_connectSSE, delay);
        };
    }
    catch (e) {
        console.warn('[SSE] Failed to connect:', e);
        _sseStream = null;
    }
}
// #73: explicit teardown on page hide / unload. The browser tears an
// EventSource down on a full unload, but bfcache restore and SPA soft-nav can
// leave a stale stream (plus a pending reconnect timer) holding a server
// connection. Closing it deterministically here keeps a single live stream per
// session instead of accumulating one per (re)navigation. WP-G: a bfcache
// restore (pageshow.persisted) now reopens it, and a tab hidden for 60s closes
// it until the reader comes back.
if (typeof window !== 'undefined') {
    window.addEventListener('pagehide', function () {
        _sseClose();
    });
    window.addEventListener('pageshow', function (e) {
        if (e && e.persisted)
            _sseResume();
    });
}
if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
            if (_sseHiddenTimer)
                clearTimeout(_sseHiddenTimer);
            _sseHiddenTimer = setTimeout(function () {
                _sseHiddenTimer = null;
                if (document.hidden)
                    _sseClose();
            }, _SSE_HIDDEN_CLOSE_MS);
        }
        else {
            if (_sseHiddenTimer) {
                clearTimeout(_sseHiddenTimer);
                _sseHiddenTimer = null;
            }
            _sseResume();
        }
    });
}
// init() bootstrap moved to app.js (S37) — must be in app chunk for production
// §FEATURES — extracted to static/js/features-extra.js
//# sourceMappingURL=tooltip-tour.js.map
;
// ═══ cat-mascot.js ═══
;"use strict";
/**
 * Oxford Ledge Cat Mascot — State Machine & Discovery System.
 *
 * TS Migration Phase 2 PR 27 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is the SOURCE OF TRUTH; cat-mascot.js is the build
 * artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
 *
 * A subtle, delightful cat companion that lives in the logo area.
 * Hidden until discovered. Respects reduced motion & presentation mode.
 */
(function () {
    'use strict';
    const STATES = {
        idle: { weight: 35, dur: [4000, 8000] },
        saunter: { weight: 20, dur: [3000, 4000] },
        lounge: { weight: 15, dur: [5000, 8000] },
        sleep: { weight: 10, dur: [6000, 10000] },
        stretch: { weight: 10, dur: [2000, 3000] },
        explore: { weight: 7, dur: [3000, 5000] },
        jump: { weight: 3, dur: [1000, 2000] },
    };
    const TOTAL_WEIGHT = Object.keys(STATES).reduce(function (s, k) {
        return s + STATES[k].weight;
    }, 0);
    const FRAME_INTERVAL = 1000 / 15;
    const DISCOVERY_SESSIONS = 5;
    const TOOLTIP_SESSIONS = 15;
    const LS_DISCOVERED = 'ol_cat_discovered';
    const LS_ENABLED = 'ol_cat_enabled';
    const LS_SESSIONS = 'ol_session_count';
    const LS_PRESENTATION = 'ol_presentation_mode';
    const LS_TOOLTIP_SHOWN = 'ol_cat_tooltip_shown';
    // ── State ──
    let container = null;
    let catEl = null;
    let wordmark = null;
    let currentState = 'idle';
    let stateTimer = null;
    let revealed = false;
    const reducedMotion = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || false;
    let marketReactedThisSession = false;
    let willChangeTimer = null;
    let lastFrameTime = 0;
    let _catTimers = [];
    function _catSetTimeout(fn, ms) {
        const id = setTimeout(fn, ms);
        _catTimers.push(id);
        return id;
    }
    function rand(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    function ls(key, val) {
        try {
            if (val === undefined)
                return OLStorage.getString(key, null);
            OLStorage.setString(key, val);
            return undefined;
        }
        catch (_e) {
            return null;
        }
    }
    function pickState() {
        let r = Math.random() * TOTAL_WEIGHT;
        const keys = Object.keys(STATES);
        for (let i = 0; i < keys.length; i++) {
            r -= STATES[keys[i]].weight;
            if (r <= 0)
                return keys[i];
        }
        return 'idle';
    }
    function stateDuration(state) {
        const d = STATES[state].dur;
        return rand(d[0], d[1]);
    }
    function scheduleIdle(fn) {
        const w = window;
        if (w.requestIdleCallback) {
            w.requestIdleCallback(function () { fn(); });
        }
        else {
            setTimeout(fn, 0);
        }
    }
    function setWillChange(on) {
        if (!container)
            return;
        if (on) {
            container.style.willChange = 'transform';
            if (willChangeTimer)
                clearTimeout(willChangeTimer);
            willChangeTimer = _catSetTimeout(function () {
                if (container)
                    container.style.willChange = 'auto';
            }, 2000);
        }
        else {
            container.style.willChange = 'auto';
            if (willChangeTimer)
                clearTimeout(willChangeTimer);
        }
    }
    function applyState(state) {
        if (!container)
            return;
        const all = Object.keys(STATES);
        for (let i = 0; i < all.length; i++) {
            container.classList.remove('ol-cat-' + all[i]);
        }
        container.classList.add('ol-cat-' + state);
        setWillChange(true);
        currentState = state;
        void currentState;
    }
    function tick() {
        if (!revealed || ls(LS_PRESENTATION) === 'true')
            return;
        if (ls(LS_ENABLED) === 'false')
            return;
        const now = performance.now();
        if (now - lastFrameTime < FRAME_INTERVAL) {
            requestAnimationFrame(tick);
            return;
        }
        lastFrameTime = now;
        const next = pickState();
        applyState(next);
        const dur = stateDuration(next);
        if (stateTimer)
            clearTimeout(stateTimer);
        stateTimer = _catSetTimeout(function () {
            scheduleIdle(tick);
        }, dur);
    }
    function startMachine() {
        applyState('idle');
        stateTimer = _catSetTimeout(function () {
            scheduleIdle(tick);
        }, stateDuration('idle'));
    }
    function runReveal(callback) {
        if (!container)
            return;
        container.style.opacity = '1';
        container.style.pointerEvents = 'auto';
        if (reducedMotion) {
            container.classList.add('ol-cat-idle');
            revealed = true;
            ls(LS_DISCOVERED, 'true');
            if (callback)
                callback();
            return;
        }
        container.classList.add('ol-cat-reveal-1');
        _catSetTimeout(function () {
            if (!container)
                return;
            container.classList.remove('ol-cat-reveal-1');
            container.classList.add('ol-cat-reveal-2');
            _catSetTimeout(function () {
                if (!container)
                    return;
                container.classList.add('ol-cat-reveal-3');
                _catSetTimeout(function () {
                    if (!container)
                        return;
                    container.classList.remove('ol-cat-reveal-2', 'ol-cat-reveal-3');
                    container.classList.add('ol-cat-reveal-4');
                    _catSetTimeout(function () {
                        if (!container)
                            return;
                        container.classList.remove('ol-cat-reveal-4');
                        container.classList.add('ol-cat-idle');
                        revealed = true;
                        ls(LS_DISCOVERED, 'true');
                        if (callback)
                            callback();
                    }, 300);
                }, 300);
            }, 300);
        }, 200);
    }
    function showDiscoveryCue() {
        if (!container || revealed)
            return;
        container.style.opacity = '1';
        container.classList.add('ol-cat-cue');
        _catSetTimeout(function () {
            if (!revealed && container) {
                container.classList.remove('ol-cat-cue');
                container.style.opacity = '0';
            }
        }, 2000);
    }
    function showTooltip() {
        if (!wordmark || ls(LS_TOOLTIP_SHOWN) === 'true')
            return;
        const tip = document.createElement('div');
        tip.className = 'ol-cat-tooltip';
        tip.textContent = 'Click the logo';
        tip.setAttribute('role', 'tooltip');
        wordmark.style.position = 'relative';
        wordmark.appendChild(tip);
        ls(LS_TOOLTIP_SHOWN, 'true');
        _catSetTimeout(function () {
            if (tip.parentNode)
                tip.parentNode.removeChild(tip);
        }, 4000);
    }
    function onLogoClick() {
        if (ls(LS_PRESENTATION) === 'true')
            return;
        if (ls(LS_ENABLED) === 'false')
            return;
        if (!revealed) {
            runReveal(function () {
                startMachine();
            });
            return;
        }
        if (stateTimer)
            clearTimeout(stateTimer);
        applyState('idle');
        if (container) {
            container.classList.add('ol-cat-alert');
            _catSetTimeout(function () {
                if (container)
                    container.classList.remove('ol-cat-alert');
                tick();
            }, 3000);
        }
    }
    function onMarketEvent(detail) {
        if (!revealed || marketReactedThisSession)
            return;
        if (ls(LS_ENABLED) === 'false' || ls(LS_PRESENTATION) === 'true')
            return;
        const type = detail && detail.type;
        if (type === 'rally' && container) {
            marketReactedThisSession = true;
            container.classList.add('ol-cat-rally');
            _catSetTimeout(function () {
                if (container)
                    container.classList.remove('ol-cat-rally');
            }, 3000);
        }
        else if (type === 'milestone') {
            marketReactedThisSession = true;
            if (stateTimer)
                clearTimeout(stateTimer);
            applyState('stretch');
            stateTimer = _catSetTimeout(function () { scheduleIdle(tick); }, 2500);
        }
    }
    function togglePresentation() {
        const current = ls(LS_PRESENTATION) === 'true';
        ls(LS_PRESENTATION, current ? 'false' : 'true');
        if (!current && container) {
            container.style.opacity = '0';
            if (stateTimer)
                clearTimeout(stateTimer);
        }
        else if (revealed && container) {
            container.style.opacity = '1';
            tick();
        }
    }
    function onKeyDown(e) {
        if (e.ctrlKey && e.shiftKey && e.key === 'P') {
            e.preventDefault();
            togglePresentation();
        }
    }
    function injectStyles() {
        // Styles live in static/css/dynamic-components.css per S-CSP migration.
    }
    function buildContainer() {
        wordmark = document.querySelector('.ol-wordmark');
        if (!wordmark)
            return false;
        wordmark.style.position = 'relative';
        container = document.createElement('div');
        container.id = 'ol-cat-container';
        container.setAttribute('aria-hidden', 'true');
        wordmark.appendChild(container);
        const xhr = new XMLHttpRequest();
        xhr.open('GET', '/static/img/cat-logo.svg', true);
        xhr.onload = function () {
            if (xhr.status === 200 && container) {
                container.innerHTML = xhr.responseText;
                catEl = container.querySelector('svg');
                void catEl;
            }
            else if (container) {
                container.classList.add('hidden');
            }
        };
        xhr.onerror = function () {
            if (container)
                container.classList.add('hidden');
        };
        xhr.send();
        return true;
    }
    function handleDiscovery() {
        if (ls(LS_DISCOVERED) === 'true') {
            if (ls(LS_ENABLED) === 'false')
                return;
            if (ls(LS_PRESENTATION) === 'true')
                return;
            revealed = true;
            if (container) {
                container.style.opacity = '1';
                if (reducedMotion) {
                    container.classList.add('ol-cat-idle');
                }
                else {
                    startMachine();
                }
            }
            return;
        }
        const count = parseInt(ls(LS_SESSIONS) || '0', 10) + 1;
        ls(LS_SESSIONS, String(count));
        if (count >= DISCOVERY_SESSIONS) {
            _catSetTimeout(function () { showDiscoveryCue(); }, 3000);
        }
        if (count >= TOOLTIP_SESSIONS && ls(LS_TOOLTIP_SHOWN) !== 'true') {
            _catSetTimeout(function () { showTooltip(); }, 5000);
        }
    }
    function listenMarket() {
        window.addEventListener('ol-market-event', function (e) {
            const ce = e;
            onMarketEvent(ce.detail);
        });
    }
    function trackDiscovery() {
        const count = parseInt(ls(LS_SESSIONS) || '0', 10);
        try {
            const w = window;
            if (typeof trackUniqueAchievement === 'function') {
                trackUniqueAchievement('cat_discovered', String(count));
            }
            if (w.olAnalytics && typeof w.olAnalytics.track === 'function') {
                w.olAnalytics.track('cat_discovered', { session_number: count });
            }
        }
        catch (_e) { /* analytics failure is non-blocking */ }
    }
    function init() {
        if (window.location.search.indexOf('mode=presentation') !== -1) {
            ls(LS_PRESENTATION, 'true');
        }
        injectStyles();
        if (!buildContainer())
            return;
        if (wordmark) {
            wordmark.addEventListener('click', function () {
                onLogoClick();
                if (!ls(LS_DISCOVERED + '_tracked')) {
                    trackDiscovery();
                    ls(LS_DISCOVERED + '_tracked', 'true');
                }
            });
        }
        document.addEventListener('keydown', onKeyDown);
        listenMarket();
        _catSetTimeout(handleDiscovery, 500);
    }
    window.cleanupCatMascot = function () {
        if (stateTimer)
            clearTimeout(stateTimer);
        stateTimer = null;
        if (willChangeTimer)
            clearTimeout(willChangeTimer);
        willChangeTimer = null;
        _catTimers.forEach(function (t) { clearTimeout(t); });
        _catTimers = [];
        revealed = false;
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    }
    else {
        init();
    }
})();
//# sourceMappingURL=cat-mascot.js.map
;
// ═══ creator-mode.js ═══
;"use strict";
/* creator-mode.js — Publish watchlists as shared research pages.
 *
 * TS Migration Phase 2 PR 23 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is now the SOURCE OF TRUTH; the sibling creator-mode.js
 * is the build artifact produced by `npx tsc -p tsconfig.build.json`
 * (gitignored).
 *
 * Adds a "Publish Watchlist" button to the watchlist toolbar.
 * On click: generates a public URL /research/{username}/{watchlist-slug}.
 * The published page shows tickers, conviction levels, theses, last updated.
 * Anyone with the link can view (no auth required).
 * Publisher can unpublish anytime.
 */
(function () {
    'use strict';
    // ── State ──────────────────────────────────────────────────────────────────
    let _publishedSlug = null; // null = not published
    // ── Helpers ────────────────────────────────────────────────────────────────
    function _getUsername() {
        // Try to get display name from auth state
        if (typeof currentUser !== 'undefined' && currentUser && currentUser.displayName) {
            return currentUser.displayName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'user';
        }
        if (typeof currentUser !== 'undefined' && currentUser && currentUser.email) {
            return currentUser.email.split('@')[0].toLowerCase().replace(/[^a-z0-9]+/g, '-');
        }
        return 'user';
    }
    void _getUsername;
    function _getWatchlistSlug() {
        // Use the active watchlist name or default
        const title = document.querySelector('.wl-title-inline');
        const name = (title && title.textContent) ? title.textContent.trim() : 'Watchlist';
        return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'watchlist';
    }
    function _readCsrfHeader() {
        const headers = { 'Content-Type': 'application/json' };
        const csrf = document.querySelector('meta[name="csrf-token"]');
        if (csrf)
            headers['X-CSRF-Token'] = csrf.content;
        // Read CSRF from cookie if meta tag not present.
        // HMAC-first (2026-07-29): validate_csrf path (b) requires
        // HMAC(OL_CSRF_SECRET, ol_session) for a session-bearing request and,
        // since SEC-2 (2026-06-14), rejects a mismatch outright with no
        // fallthrough. /api/research/publish + /unpublish are authed, so the
        // legacy-first read 403'd every publish. `ol_csrf` is retained last as
        // the anonymous path-(a) fallback. Pinned by
        // tests/test_client_csrf_hmac_first_contract.py.
        if (!csrf) {
            try {
                const hmacTok = document.cookie.match(/(?:^|;\s*)ol_csrf_hmac=([^;]+)/);
                const anonTok = document.cookie.match(/(?:^|;\s*)ol_csrf=([^;]+)/);
                const tok = (hmacTok && hmacTok[1]) || (anonTok && anonTok[1]) || '';
                if (tok)
                    headers['X-CSRF-Token'] = decodeURIComponent(tok);
            }
            catch (_e) { /* document.cookie unavailable */ }
        }
        return headers;
    }
    // ── Publish / Unpublish API calls ──────────────────────────────────────────
    async function publishWatchlist() {
        const slug = _getWatchlistSlug();
        try {
            const headers = _readCsrfHeader();
            const resp = await fetch('/api/research/publish', {
                method: 'POST',
                headers: headers,
                credentials: 'same-origin',
                body: JSON.stringify({ slug: slug }),
                signal: AbortSignal.timeout(30000),
            });
            const data = await resp.json();
            if (data.status === 'ok' && data.url) {
                _publishedSlug = slug;
                _updatePublishButton();
                _showPublishSuccess(data.url);
            }
            else {
                console.error('[publish watchlist]', data && data.error);
                if (typeof showToast === 'function')
                    showToast('We couldn\'t publish your watchlist. Please try again in a moment.', '', 4000);
            }
        }
        catch (e) {
            console.error('[publish watchlist]', e);
            if (typeof showToast === 'function')
                showToast('We couldn\'t publish your watchlist. Check your connection and try again.', '', 4000);
        }
    }
    async function unpublishWatchlist() {
        try {
            const headers = _readCsrfHeader();
            const resp = await fetch('/api/research/unpublish', {
                method: 'POST',
                headers: headers,
                credentials: 'same-origin',
                signal: AbortSignal.timeout(30000),
            });
            const data = await resp.json();
            if (data.status === 'ok') {
                _publishedSlug = null;
                _updatePublishButton();
                if (typeof showToast === 'function')
                    showToast('Watchlist unpublished.', '', 3000);
            }
        }
        catch (e) {
            console.error('[unpublish watchlist]', e);
            if (typeof showToast === 'function')
                showToast('We couldn\'t unpublish your watchlist. Please try again in a moment.', '', 4000);
        }
    }
    async function checkPublishStatus() {
        try {
            const resp = await fetch('/api/research/status', { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
            const data = await resp.json();
            if (data.published) {
                _publishedSlug = data.slug || 'watchlist';
            }
            else {
                _publishedSlug = null;
            }
            _updatePublishButton();
        }
        catch (_e) {
            // Silently fail — publish status is not critical
        }
    }
    // ── UI ─────────────────────────────────────────────────────────────────────
    function _updatePublishButton() {
        const btn = document.getElementById('wl-publish-btn');
        if (!btn)
            return;
        if (_publishedSlug) {
            btn.textContent = 'Unpublish';
            btn.title = 'Remove public research page';
            btn.classList.add('wl-published');
        }
        else {
            btn.textContent = 'Publish';
            btn.title = 'Publish watchlist as a public research page';
            btn.classList.remove('wl-published');
        }
    }
    function _showPublishSuccess(url) {
        const fullUrl = window.location.origin + url;
        if (typeof showToast === 'function') {
            showToast('Watchlist published! <a href="' + url + '" target="_blank" class="cr-publish-link">' + fullUrl + '</a>', '', 8000, { html: true });
        }
        // Also copy to clipboard
        if (navigator.clipboard) {
            navigator.clipboard.writeText(fullUrl).catch(function () { });
        }
    }
    function _onPublishClick() {
        if (_publishedSlug) {
            unpublishWatchlist();
        }
        else {
            publishWatchlist();
        }
    }
    // ── Inject button into watchlist toolbar ────────────────────────────────────
    function injectPublishButton() {
        const toolbar = document.querySelector('#watchlist-view .wl-toolbar');
        if (!toolbar || document.getElementById('wl-publish-btn'))
            return;
        const btn = document.createElement('button');
        btn.id = 'wl-publish-btn';
        btn.className = 'sb-help-btn fs-11 ml-8';
        btn.textContent = 'Publish';
        btn.title = 'Publish watchlist as a public research page';
        btn.style.cursor = 'pointer';
        btn.addEventListener('click', _onPublishClick);
        // Insert after the CSV button
        const csvBtn = document.getElementById('wl-csv-btn');
        if (csvBtn && csvBtn.nextSibling) {
            toolbar.insertBefore(btn, csvBtn.nextSibling);
        }
        else {
            toolbar.appendChild(btn);
        }
    }
    // ── Init ───────────────────────────────────────────────────────────────────
    function init() {
        injectPublishButton();
        // Check publish status on load (after auth resolves)
        setTimeout(checkPublishStatus, 2000);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    }
    else {
        init();
    }
})();
//# sourceMappingURL=creator-mode.js.map
;
// ═══ product/chrome/dark-topbar.js ═══
;"use strict";
/**
 * static/js/product/chrome/dark-topbar.ts — dark-surface variant of the
 * product topbar.
 *
 * Plan: docs/plans/SF-HANDOFF-REDESIGN.md PR2 Phase 1-A.
 * Handoff spec: handoff-product/IMPLEMENTATION.md §"Phase 1 — Shared
 * primitives" + handoff-product/01-recommendations.md §"Consistent
 * surface chrome".
 *
 * Sits at the top of every product surface (Achievements, 13F,
 * Watchlist, Portfolio, News, Markets, Earnings). Same structural
 * shape as the legacy #topbar (mark + wordmark · nav · right-side
 * util cluster) but tuned for the dark product surface palette
 * (--dark-bg background, --dark-border hairline, --off-white text).
 *
 * Composition (left → right):
 *   ┌──────────────────────────────────────────────────────────────┐
 *   │  ◆ OXFORD LEDGE    Markets · News · Portfolio · Watchlist · │
 *   │                    Learn                        [right slot] │
 *   └──────────────────────────────────────────────────────────────┘
 *
 * The right slot is consumer-controlled (auth pill, ⌘K, etc.). The
 * topbar does NOT wire any click handlers — the data-action attributes
 * dispatch through the existing global click delegation in app-init.js.
 * This keeps it CSP-strict (no inline `onclick=`) and lets the Phase 2
 * surface code hook into the same action plumbing as the legacy chrome.
 *
 * Exposed as `window.OLProduct.chrome.createDarkTopbar`.
 */
(function () {
    'use strict';
    const DEFAULT_NAV = [
        { label: 'Markets', view: 'macro' },
        { label: 'News', view: 'news' },
        { label: 'Portfolio', view: 'portfolio' },
        { label: 'Watchlist', view: 'watchlist' },
        { label: 'Learn', view: 'learn' },
    ];
    function _mark() {
        // Hairline gold lozenge — matches existing brand v3 Ledge mark
        // intent (no SVG asset dependency; CSS-only diamond).
        const m = document.createElement('span');
        m.className = 'ol-dark-topbar__mark';
        m.setAttribute('aria-hidden', 'true');
        return m;
    }
    function _navButton(item) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = ['ol-dark-topbar__nav-btn', item.active ? 'is-active' : '']
            .filter(Boolean).join(' ');
        btn.textContent = item.label;
        // CSP-strict: no inline handler. Use data-action so the global
        // click delegator in app-init.js picks it up.
        // N21 (mobile/tablet audit 2026-09-25): the delegator's map key is
        // 'set-view' (app-renderers.ts `_delegatedActions['set-view']`,
        // reading data-view); 'setView' was never a key, so every nav button
        // this primitive built was a dead tap. Nothing mounts createDarkTopbar
        // today, which is how the wrong string survived since PR2 Phase 1-A.
        // Contract: tests/test_mobile_audit_n21_dark_topbar_action_contract.py.
        btn.setAttribute('data-action', item.action ?? 'set-view');
        btn.setAttribute('data-view', item.view);
        if (item.active)
            btn.setAttribute('aria-current', 'page');
        return btn;
    }
    function createDarkTopbar(props) {
        const p = props || {};
        const root = document.createElement('header');
        root.className = ['ol-dark-topbar', p.className ?? ''].filter(Boolean).join(' ');
        root.setAttribute('role', 'banner');
        if (p.id)
            root.id = p.id;
        // Brand cluster: mark + wordmark
        const brand = document.createElement('div');
        brand.className = 'ol-dark-topbar__brand';
        brand.appendChild(_mark());
        const wordmark = document.createElement('span');
        wordmark.className = 'ol-dark-topbar__wordmark';
        wordmark.textContent = p.wordmark ?? 'OXFORD LEDGE';
        brand.appendChild(wordmark);
        root.appendChild(brand);
        // Nav cluster
        const nav = document.createElement('nav');
        nav.className = 'ol-dark-topbar__nav';
        nav.setAttribute('aria-label', 'Primary');
        const items = (p.nav && p.nav.length > 0) ? p.nav : DEFAULT_NAV;
        items.forEach(function (item) { nav.appendChild(_navButton(item)); });
        root.appendChild(nav);
        // Right slot (auth pill, command palette button, etc.)
        const right = document.createElement('div');
        right.className = 'ol-dark-topbar__right';
        if (p.rightSlot && p.rightSlot.nodeType === 1) {
            right.appendChild(p.rightSlot);
        }
        root.appendChild(right);
        return root;
    }
    const r = (typeof window !== 'undefined' ? window : globalThis);
    r.OLProduct = r.OLProduct || {};
    r.OLProduct.chrome = r.OLProduct.chrome || {};
    r.OLProduct.chrome.createDarkTopbar = createDarkTopbar;
})();
//# sourceMappingURL=dark-topbar.js.map
;
// ═══ product/chrome/ticker-strip.js ═══
;"use strict";
/**
 * static/js/product/chrome/ticker-strip.ts — SPY · VIXY · gold etc.
 * ticker tape under the dark topbar.
 *
 * Plan: docs/plans/SF-HANDOFF-REDESIGN.md PR2 Phase 1-A.
 * Handoff spec: handoff-product/IMPLEMENTATION.md §"Phase 1 — Shared
 * primitives" + handoff-product/01-recommendations.md §"After-hours /
 * pre-market badge" (mentions the "SPY 744 +0.73% · VIXY 27.09 +1.21%
 * · After Hours" pattern at the top of most pages).
 *
 * The factory returns a DOM-only strip with placeholder values. Each
 * tile carries a data-symbol attribute so a downstream wirer (Phase 2)
 * can fetch from /api/quote?symbol=… or the existing market_data
 * helpers and update the .value / .change spans in place — no
 * innerHTML rebuild (per CLAUDE.md §"DOM rebuilds").
 *
 * Phase-1 scope: pure DOM-factory. No fetch, no polling. Phase 2
 * wires the live updates from existing market data endpoints.
 *
 * Exposed as `window.OLProduct.chrome.createTickerStrip`.
 */
(function () {
    'use strict';
    const DEFAULT_TICKERS = [
        { symbol: 'SPY', label: 'S&P 500' },
        // #81: VIXY is the VIX-futures ETF — never label it as the index
        // itself (its price is not the VIX level; the tile shows the symbol).
        { symbol: 'VIXY', label: 'VIX futures ETF' },
        { symbol: 'GLD', label: 'Gold' },
        { symbol: 'TLT', label: '20Y Treasury' },
        { symbol: 'DXY', label: 'Dollar Index' },
    ];
    function _tile(entry) {
        const tile = document.createElement('div');
        tile.className = 'ol-ticker-strip__tile';
        tile.setAttribute('data-symbol', entry.symbol);
        const sym = document.createElement('span');
        sym.className = 'ol-ticker-strip__symbol';
        sym.textContent = entry.symbol;
        tile.appendChild(sym);
        const value = document.createElement('span');
        value.className = 'ol-ticker-strip__value';
        // "—" placeholder until Phase 2 wires fetch; CLAUDE.md note
        // about empty cells applies to data tables, not chrome tape.
        value.textContent = entry.value ?? '—';
        tile.appendChild(value);
        const change = document.createElement('span');
        const dir = entry.direction ?? 'flat';
        change.className = ['ol-ticker-strip__change', 'ol-ticker-strip__change--' + dir]
            .join(' ');
        change.textContent = entry.change ?? '';
        tile.appendChild(change);
        return tile;
    }
    function _session(props) {
        const badge = document.createElement('span');
        const tone = props.tone ?? 'closed';
        badge.className = ['ol-ticker-strip__session', 'ol-ticker-strip__session--' + tone]
            .join(' ');
        badge.textContent = props.text;
        return badge;
    }
    function createTickerStrip(props) {
        const p = props || {};
        const root = document.createElement('div');
        root.className = ['ol-ticker-strip', p.className ?? ''].filter(Boolean).join(' ');
        root.setAttribute('role', 'region');
        root.setAttribute('aria-label', 'Market ticker');
        if (p.id)
            root.id = p.id;
        const track = document.createElement('div');
        track.className = 'ol-ticker-strip__track';
        const tickers = (p.tickers && p.tickers.length > 0) ? p.tickers : DEFAULT_TICKERS;
        tickers.forEach(function (t) { track.appendChild(_tile(t)); });
        if (p.session) {
            track.appendChild(_session(p.session));
        }
        root.appendChild(track);
        return root;
    }
    const r = (typeof window !== 'undefined' ? window : globalThis);
    r.OLProduct = r.OLProduct || {};
    r.OLProduct.chrome = r.OLProduct.chrome || {};
    r.OLProduct.chrome.createTickerStrip = createTickerStrip;
})();
//# sourceMappingURL=ticker-strip.js.map
;
// ═══ product/chrome/live-data-strip.js ═══
;"use strict";
/**
 * static/js/product/chrome/live-data-strip.ts — yellow-amber
 * dismissible warning strip.
 *
 * Plan: docs/plans/SF-HANDOFF-REDESIGN.md PR2 Phase 1-A.
 * Handoff spec: handoff-product/IMPLEMENTATION.md §"Phase 1 — Shared
 * primitives" + handoff-product/01-recommendations.md §"Live data
 * temporarily limited strip" — "Dismissible (already is — good); Less
 * aggressive in color (the dark amber is fine); Linkable to a 'What
 * does this mean?' tooltip."
 *
 * Renders as a single horizontal row:
 *   ┌──────────────────────────────────────────────────────────┐
 *   │  ⚠  MARKETS CLOSED · Data may be delayed.   What is this? ✕ │
 *   └──────────────────────────────────────────────────────────┘
 *
 * Dismiss state is persisted in localStorage under
 *   ol.product.live-data-strip.dismissed.<id>
 * so a refresh of the same product surface does not re-show it. A new
 * day (different stripId) re-shows by design — the warning is
 * time-bounded and the new stripId opts the user back in.
 *
 * Phase-1 scope: dismiss-only behavior. The "What is this?" link is
 * a real <a> element with a configurable href; the page owns the
 * tooltip / modal target.
 *
 * CSP-strict: no inline handlers. Dismiss button carries
 * data-action="ol-live-strip-dismiss" so the global click delegator
 * can route it, AND the factory also wires a defensive `click`
 * listener so the strip works on smoke pages that do not load
 * app-init's delegator (e.g. an isolated test harness).
 *
 * Exposed as `window.OLProduct.chrome.createLiveDataStrip`.
 */
(function () {
    'use strict';
    const STORAGE_PREFIX = 'ol.product.live-data-strip.dismissed.';
    function _safeLocalStorageGet(key) {
        try {
            const w = (typeof window !== 'undefined' ? window : globalThis);
            const ls = w && w.localStorage;
            return ls ? ls.getItem(key) : null;
        }
        catch (_e) {
            return null;
        }
    }
    function _safeLocalStorageSet(key, value) {
        try {
            const w = (typeof window !== 'undefined' ? window : globalThis);
            const ls = w && w.localStorage;
            if (ls)
                ls.setItem(key, value);
        }
        catch (_e) { /* quota / privacy mode — ignore */ }
    }
    function createLiveDataStrip(props) {
        const p = props || {};
        const storageKey = STORAGE_PREFIX + (p.stripId || 'default');
        const tone = p.tone ?? 'amber';
        const root = document.createElement('div');
        root.className = [
            'ol-live-data-strip',
            'ol-live-data-strip--' + tone,
            p.className ?? '',
        ].filter(Boolean).join(' ');
        root.setAttribute('role', 'status');
        root.setAttribute('aria-live', 'polite');
        if (p.id)
            root.id = p.id;
        // If previously dismissed for this stripId, render but hidden.
        // We still emit the element so consumers can re-show it via
        // a `data-action` flow without re-creating it.
        if (_safeLocalStorageGet(storageKey) === '1') {
            root.classList.add('is-dismissed');
            root.setAttribute('hidden', '');
        }
        // Icon (CSS-decorative; aria-hidden)
        const icon = document.createElement('span');
        icon.className = 'ol-live-data-strip__icon';
        icon.setAttribute('aria-hidden', 'true');
        root.appendChild(icon);
        // Body: kicker + message
        const body = document.createElement('span');
        body.className = 'ol-live-data-strip__body';
        if (p.kicker) {
            const kicker = document.createElement('span');
            kicker.className = 'ol-live-data-strip__kicker';
            kicker.textContent = p.kicker;
            body.appendChild(kicker);
        }
        const msg = document.createElement('span');
        msg.className = 'ol-live-data-strip__message';
        msg.textContent = p.message;
        body.appendChild(msg);
        root.appendChild(body);
        // Learn-more link (optional)
        if (p.learnMoreHref) {
            const link = document.createElement('a');
            link.className = 'ol-live-data-strip__learn-more';
            link.href = p.learnMoreHref;
            link.textContent = p.learnMoreLabel ?? 'What is this?';
            root.appendChild(link);
        }
        // Dismiss control (default on)
        if (p.dismissible !== false) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'ol-live-data-strip__dismiss';
            btn.setAttribute('aria-label', 'Dismiss');
            btn.setAttribute('data-action', 'ol-live-strip-dismiss');
            btn.setAttribute('data-strip-id', p.stripId || 'default');
            btn.textContent = '×'; // ×
            // Defensive direct handler so smoke pages without the
            // global delegator still dismiss correctly.
            btn.addEventListener('click', function (_e) {
                root.classList.add('is-dismissed');
                root.setAttribute('hidden', '');
                _safeLocalStorageSet(storageKey, '1');
            });
            root.appendChild(btn);
        }
        return root;
    }
    const r = (typeof window !== 'undefined' ? window : globalThis);
    r.OLProduct = r.OLProduct || {};
    r.OLProduct.chrome = r.OLProduct.chrome || {};
    r.OLProduct.chrome.createLiveDataStrip = createLiveDataStrip;
})();
//# sourceMappingURL=live-data-strip.js.map
;
// ═══ product/chrome/panel-header.js ═══
;"use strict";
/**
 * static/js/product/chrome/panel-header.ts — standard product
 * page header: KICKER · h1 · lede · right-slot.
 *
 * Plan: docs/plans/SF-HANDOFF-REDESIGN.md PR2 Phase 1-A.
 * Handoff spec: handoff-product/IMPLEMENTATION.md §"Phase 1 — Shared
 * primitives" + handoff-product/01-recommendations.md §"Consistent
 * surface chrome" (item 4: "PanelHeader (kicker + h1 + lede +
 * right-slot)") + per-surface refs across surfaces/*.md.
 *
 * Replaces ad-hoc page headers across the 7 product surfaces with
 * one shared composition:
 *
 *   ┌──────────────────────────────────────────────────────────────┐
 *   │  ACHIEVEMENTS                       [tab nav · 1Y · etc.]    │  (kicker, mono)
 *   │  Marks of the careful reader.                                 │  (h1, serif)
 *   │  Thirty-eight honors await — each conferred by                │
 *   │  the act of doing the work.                                   │  (lede, italic serif)
 *   └──────────────────────────────────────────────────────────────┘
 *   (2026-05-28 audience-framing sweep: example h1 updated from
 *   "Marks of the practitioner" to current canonical per DESIGN F-01.)
 *
 * Responsive: the inner grid (kicker+h1+lede vs. right-slot) reflows
 * from 2-column at ≥720px to stacked at <720px via a viewport
 * `@media (max-width: 720px)` in chrome.css. (This was originally a
 * `@container` query, but it self-referenced the container element and
 * never fired — see the chrome.css comment; all 7 uses are full-width
 * heroes so a viewport media query is equivalent and actually works.)
 *
 * The factory composes the Phase 1 LEARN primitives when they're
 * present on window.OLLearn (createSectionLabel for the kicker)
 * and falls back to a styled span otherwise.
 *
 * Exposed as `window.OLProduct.chrome.createPanelHeader`.
 */
(function () {
    'use strict';
    function _fallbackKicker(text) {
        const el = document.createElement('span');
        el.className = 'ol-section-label';
        el.textContent = text;
        return el;
    }
    function _fallbackLede(text) {
        const el = document.createElement('p');
        el.className = 'ol-editorial-note';
        el.textContent = text;
        return el;
    }
    function createPanelHeader(props) {
        const p = props || {};
        const w = (typeof window !== 'undefined' ? window : globalThis);
        const P = (w.OLLearn && w.OLLearn.primitives) || {};
        const root = document.createElement('header');
        root.className = ['ol-panel-header', p.className ?? ''].filter(Boolean).join(' ');
        root.setAttribute('role', 'banner');
        if (p.id)
            root.id = p.id;
        // Left column: kicker + title + lede
        const left = document.createElement('div');
        left.className = 'ol-panel-header__left';
        if (p.kicker) {
            const kicker = P.createSectionLabel
                ? P.createSectionLabel({ text: p.kicker, color: 'gold-deep' })
                : _fallbackKicker(p.kicker);
            kicker.classList.add('ol-panel-header__kicker');
            left.appendChild(kicker);
        }
        const level = p.headingLevel === 2 ? 'h2'
            : p.headingLevel === 3 ? 'h3'
                : 'h1';
        const title = document.createElement(level);
        title.className = 'ol-panel-header__title';
        title.textContent = p.title;
        left.appendChild(title);
        if (p.lede) {
            const lede = P.createEditorialNote
                ? P.createEditorialNote({ text: p.lede, color: 'muted-cream' })
                : _fallbackLede(p.lede);
            lede.classList.add('ol-panel-header__lede');
            left.appendChild(lede);
        }
        root.appendChild(left);
        // Right column: caller-controlled slot (tabs, search, period
        // selector, "Add cost basis →" form, etc.)
        const right = document.createElement('div');
        right.className = 'ol-panel-header__right';
        if (p.rightSlot && p.rightSlot.nodeType === 1) {
            right.appendChild(p.rightSlot);
        }
        root.appendChild(right);
        return root;
    }
    const r = (typeof window !== 'undefined' ? window : globalThis);
    r.OLProduct = r.OLProduct || {};
    r.OLProduct.chrome = r.OLProduct.chrome || {};
    r.OLProduct.chrome.createPanelHeader = createPanelHeader;
})();
//# sourceMappingURL=panel-header.js.map
;
// ═══ product/chrome/bottom-tab.js ═══
;"use strict";
/**
 * static/js/product/chrome/bottom-tab.ts — mobile bottom tab bar (NF-1
 * Phase 1, SHIP-5).
 *
 * Plan: DESIGN audit `docs/board/audit/2026-05-28_DESIGN_handoff_vs_prod_crispness_audit.md`
 * §F-09 / NF-1 + ratified ship list item SHIP-5.
 * Handoff spec: `handoff-learn/04-responsive.md:183-198` §"Bottom tab bar"
 * + `handoff-product/02-responsive.md:62-65`.
 *
 * Phase-1 + Phase-2 (2a + 2b) scope (this file): shell + 4 tabs + active
 * state + GPU-accelerated tab-switch transition + active-weight-shift
 * (CSS lives in static/css/bottom-tab.css; this file owns the tab array).
 *   • Tabs: Learn / Markets / News / Portfolio (Phase 2 sub-slice 2b
 *     promoted News from Phase-2 deferred → shipped. Order per scoping
 *     doc §3 Q2 recommendation Option B: LEARN-first register with News
 *     inserted between Markets and Portfolio.)
 *   • Mounted via `mountBottomTab()` from app-init.ts on DOMContentLoaded.
 *   • Hidden on viewports ≥ 768px (719→767 on 2026-06-11: the original
 *     720 handoff left the 720-767px band with NO primary nav — the
 *     topstrip nav hides ≤767px — and mobile.css already styles the
 *     band as phone; one breakpoint story now: ≤767 = phone chrome).
 *   • Active state via wrapping `window.setView` (same idempotent pattern
 *     as `mobile-helpers.ts:240-271` to coexist with the legacy
 *     `_syncMobileBottomNav` while this lives alongside the old chrome).
 *   • Tap targets ≥ 48px tall (Apple HIG 44px + a tick for fat-finger
 *     comfort; exceeds the MOBILE_OPS 32px minimum).
 *
 * Phase-2 sub-slices SHIPPED in this batch (per
 * docs/board/audit/2026-05-28_DESIGN_ship5_phase2_scoping.md):
 *   • 2a Animations — CSS-only transition on color/font-weight/opacity
 *     (compositor-friendly; never width/top/left); prefers-reduced-motion
 *     respected. (See static/css/bottom-tab.css §"Animations".)
 *   • 2b News tab — added between Markets and Portfolio (Q2 Option B).
 *
 * Phase-2 sub-slices NOT in this batch (deferred to follow-ons):
 *   • 2c Swipe gestures (medium; sequencing q resolved Q3 = edge-swipe)
 *   • 2d Sticky-Resume CTA (medium; backend wire via pg_get_learn_progress)
 *   • 2e Search-as-sheet (large; new chrome surface)
 *   • 2f Garamond polish — GATED on VOICE-clearance (Q6 in scoping doc
 *     §3 unresolved as of 2026-05-28; will ship as a follow-on PR once
 *     VOICE blesses serif at 13-14px label size, or pivots to a
 *     weight-only / tracking polish per scoping §6 fallback)
 *   • 2g Legacy `#mobile-bottom-nav` retire (small; 7d soak per Q7 Option B)
 *
 * NOT in any Phase 2 slice (deferred to Phase 3+):
 *   • Haptics
 *   • Badge counts (e.g., "3" on Markets for unread)
 *   • iOS-Safari landscape bottom-toolbar collision mitigation
 *   • Hover states on touch devices
 *
 * Per FOUNDATIONAL `feedback_module_top_level_window_global_race`: this
 * file reads `window.currentView` and `window.setView`. Both are
 * declared in `app-init.ts` (line 1614 + §VIEWS section) which loads
 * BEFORE this script in the bundle (JS_MODULES order in
 * tools/build_bundle.py). A defensive shim handles the case where this
 * file is loaded standalone (without the bundle) — never silent-catch.
 *
 * Per FOUNDATIONAL `feedback_never_destroy_dom`: mount appends to
 * `document.body` (idempotent — checks for existing element first); we
 * never innerHTML-replace a parent.
 *
 * Per FOUNDATIONAL `feedback_zero_ux_friction`: the bar is hidden on
 * desktop via a `display:none`-outside-≤767px rule in
 * `static/css/bottom-tab.css`. No JS-toggled visibility.
 *
 * Exposed as `window.OLProduct.chrome.mountBottomTab` (matches the
 * sibling chrome modules: `createDarkTopbar`, `createTickerStrip`,
 * `createPanelHeader`, `createLiveDataStrip`).
 * The `mount` prefix (vs. `create`) signals this is a side-effecting
 * mounter, not a pure factory — callers don't manage the lifecycle.
 */
(function () {
    'use strict';
    // ── Phase-2 canonical tabs (post 2b News addition) ────────────────
    // Audience-framing FOUNDATIONAL (`memory/audience_framing.md`):
    // labels speak to "lifelong students and investors". No "Desk",
    // "Terminal", "Trade", "Position", "Book" — those are
    // practitioner-register.
    //
    // Order per scoping doc §3 Q2 = Option B (LEARN-first register
    // preserved from Phase 1, with News inserted between Markets and
    // Portfolio). The view-id 'news' matches the existing in-app
    // panel router (?view=news) — no new route needed.
    const DEFAULT_TABS = [
        // EXT-AUDIT 1.2 (#47, 2026-07-05): cold mobile boot resolves to
        // view='ticker' (app-init), but no tab covered it — first paint had
        // NO active tab and, once the user tapped anything, no bottom-tab
        // path BACK to the landing surface. The ticker view stays a tab.
        //
        // N12 (mobile/tablet audit 2026-09-25): the bar read Ticker / Learn /
        // Markets / News / Portfolio while the topstrip primary reads Markets /
        // News / Portfolio / Watchlist / Learn and the sidecar says "Stock
        // lookup" -- three names for the same surfaces. "Ticker" is jargon to a
        // first-time user; the tab is now "Stocks" (it IS the ticker view, the
        // view-id is unchanged) and the order is Markets / Stocks / Learn /
        // News / Portfolio so the first three are what a novice needs. The
        // topstrip generator's labels are untouched (chrome-convergence pins).
        // SWIPE_TABS in swipe-gestures.ts mirrors this order (contract-pinned).
        { label: 'Markets', view: 'macro' }, // 'macro' is the existing view-id for markets
        { label: 'Stocks', view: 'ticker' }, // the ticker view; "Stocks" is the novice word
        { label: 'Learn', view: 'learn' },
        { label: 'News', view: 'news' }, // 2b — added 2026-05-28 per scoping §2b
        { label: 'Portfolio', view: 'portfolio' },
    ];
    const ROOT_ID = 'ol-bottom-tab'; // distinct from legacy '#mobile-bottom-nav'
    const ACTIVE_CLASS = 'ol-bottom-tab__tab--active';
    // ── Defensive getters per feedback_module_top_level_window_global_race ──
    // `currentView` is a top-level `var` in app-init.ts; reading it from
    // here is safe ONLY when this script loads AFTER app-init.ts (which
    // is the bundled-order invariant). Standalone loads (e.g. tests, a
    // future strict ES-module migration) won't have it — return null
    // and let the caller fall back to a no-op active state.
    function _currentView() {
        try {
            const g = (typeof window !== 'undefined' ? window : globalThis);
            const cv = g['currentView'];
            return typeof cv === 'string' ? cv : null;
        }
        catch (_e) {
            return null;
        }
    }
    function _setView(view) {
        const g = (typeof window !== 'undefined' ? window : globalThis);
        const fn = g['setView'];
        if (typeof fn === 'function') {
            try {
                fn(view);
            }
            catch (e) {
                // Never silent-catch per FOUNDATIONAL — log so Sentry's
                // browser SDK + LoggingIntegration can pick it up.
                // eslint-disable-next-line no-console
                console.error('[ol-bottom-tab] setView threw:', e);
            }
        }
        else {
            // Standalone load (no app-init): fall back to a hash so the
            // tap is still meaningful. Hash-router pickup is handled
            // elsewhere (existing `?view=` panel router).
            try {
                // EXT-AUDIT 1.2b (#47): the old '#view=' hash write was a FALSE
                // fallback — nothing reads the fragment (the router reads
                // location.search). Real navigation instead: the server's SPA
                // routes accept ?view=, so a failed/slow app-init bundle still
                // gets the user where they tapped (full reload, but WORKING).
                window.location.search = '?view=' + encodeURIComponent(view);
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error('[ol-bottom-tab] hash-fallback threw:', e);
            }
        }
    }
    function _buildTab(item, isActive) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = ['ol-bottom-tab__tab', isActive ? ACTIVE_CLASS : '']
            .filter(Boolean).join(' ');
        btn.setAttribute('data-view', item.view);
        // Native a11y semantics — the bar is a <nav> (role="navigation");
        // each item is a plain button. aria-current="page" marks the active
        // destination, mirroring the convention dark-topbar.ts uses for its
        // nav. (Was role="tablist"/tab — wrong: these navigate views, they
        // are not tabs controlling tabpanels. See the root build below.)
        if (isActive)
            btn.setAttribute('aria-current', 'page');
        const label = document.createElement('span');
        label.className = 'ol-bottom-tab__label';
        label.textContent = item.label;
        btn.appendChild(label);
        // Click handler: route via setView. Inline handler (NOT delegated
        // via data-action) because this chrome may mount before the global
        // delegator finishes binding — direct handler is the safer path
        // for a Phase-1 ship.
        btn.addEventListener('click', function () {
            // N6 (mobile/tablet audit 2026-09-25): re-tapping the ACTIVE tab
            // used to call setView unconditionally, which re-rendered the view
            // and (before the router's own guard) pushed a duplicate history
            // entry per tap -- Back then had to be pressed once per tap. A
            // same-view tap now scrolls to the top and leaves history and the
            // render alone. Contract: tests/test_mobile_audit_n12_bottom_tab_runtime_contract.py.
            if (_currentView() === item.view) {
                try {
                    if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
                        const _rm = typeof window.matchMedia === 'function'
                            && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                        window.scrollTo({ top: 0, behavior: _rm ? 'auto' : 'smooth' });
                    }
                }
                catch (_e) { /* scroll-to-top is a courtesy, never a failure */ }
                return;
            }
            _setView(item.view);
        });
        return btn;
    }
    function _syncActive(root, view) {
        if (!view)
            return;
        const tabs = root.querySelectorAll('.ol-bottom-tab__tab');
        for (let i = 0; i < tabs.length; i++) {
            const t = tabs[i];
            const tv = t.getAttribute('data-view');
            const on = tv === view;
            t.classList.toggle(ACTIVE_CLASS, on);
            if (on) {
                t.setAttribute('aria-current', 'page');
            }
            else {
                t.removeAttribute('aria-current');
            }
        }
    }
    function mountBottomTab(opts) {
        const o = opts || {};
        const parent = o.parent || document.body;
        if (!parent)
            return null;
        // Idempotent — never remount per feedback_never_destroy_dom.
        const existing = document.getElementById(ROOT_ID);
        if (existing)
            return existing;
        const tabs = (o.tabs && o.tabs.length > 0) ? o.tabs : DEFAULT_TABS;
        const root = document.createElement('nav');
        root.id = ROOT_ID;
        root.className = 'ol-bottom-tab';
        // a11y (2026-06-01 browser-pass): the native <nav> already exposes
        // role="navigation". A `role="tablist"` here REQUIRED role="tab"
        // children (these are nav buttons, not tabs — no tabpanels, no roving
        // tabindex), so Lighthouse flagged "missing required children". A
        // bottom navigation bar is semantically navigation, and the active
        // item is marked with aria-current="page" below — the correct
        // pattern. Dropped the tablist role.
        root.setAttribute('aria-label', 'Primary mobile navigation');
        const currentV = _currentView();
        tabs.forEach(function (item) {
            root.appendChild(_buildTab(item, item.view === currentV));
        });
        parent.appendChild(root);
        // #304 (2026-07-28): publish the bar's LIVE height (offsetHeight
        // already includes the bar's own safe-area padding) as
        // --ol-bottom-tab-h. Bottom-anchored chrome (sticky-resume CTA,
        // cookie banner, the body content reserve) perched on hardcoded
        // 56/64px guesses that never matched the real bar (33px compact /
        // ~45px default) — on mobile news the guess left a 10-23px slot of
        // scrolling content between two bordered bars (OWNER QA). Same
        // defect class, same cure as app-init's updateTopbarHeight for the
        // 80px --topbar-height fallback (2026-05-17).
        function _publishBarHeight() {
            try {
                const bar = document.getElementById(ROOT_ID);
                if (bar && bar.offsetHeight) {
                    document.documentElement.style.setProperty('--ol-bottom-tab-h', bar.offsetHeight + 'px');
                }
            }
            catch (_e) { /* non-fatal — the CSS fallback formulas apply */ }
        }
        _publishBarHeight();
        try {
            const w = window;
            if (!w._olBottomTabHWired) {
                w._olBottomTabHWired = true;
                window.addEventListener('resize', function () {
                    if (w._olBottomTabHRAF)
                        return;
                    w._olBottomTabHRAF = requestAnimationFrame(function () {
                        w._olBottomTabHRAF = null;
                        _publishBarHeight();
                    });
                });
            }
        }
        catch (_e) { /* listener wiring is best-effort */ }
        // Wrap setView ONCE so active-state syncs on any subsequent view
        // change. Same idempotent pattern as mobile-helpers.ts:240-271
        // — guard with a sigil so concurrent mounters don't double-wrap.
        try {
            const g = (typeof window !== 'undefined' ? window : globalThis);
            const orig = g.setView;
            if (typeof orig === 'function' && !orig._olBottomTabPatched) {
                // Forward EVERY argument: popstate calls setView(view, true) and a
                // dropped skipHistory re-writes history on each Back press (prod
                // 2026-10-26: Back stripped deep-link params + wiped Forward).
                const wrapped = function (...args) {
                    const result = orig.apply(this, args);
                    _syncActive(root, args[0]);
                    return result;
                };
                wrapped._olBottomTabPatched = true;
                g.setView = wrapped;
            }
        }
        catch (e) {
            // Never silent-catch.
            // eslint-disable-next-line no-console
            console.error('[ol-bottom-tab] setView wrap threw:', e);
        }
        // 2026-06-19 audit Phase-1 [Med]: the window.setView wrap above only
        // catches transitions routed through window.setView. setView calls made
        // from INSIDE view-router (notably the macro→news 8s watchdog bounce,
        // view-router.ts ~1066) hit the lexical setView and bypass the wrap —
        // so the 'Markets' tab stayed lit while the view bounced to News.
        // Register a sync hook that view-router's setView calls for EVERY
        // transition (view-router.ts sync block). Belt-and-suspenders with the
        // wrap (the double _syncActive on window.setView paths is idempotent).
        try {
            const g2 = (typeof window !== 'undefined' ? window : globalThis);
            g2._olBottomTabSyncForView = function (view) {
                _syncActive(root, view);
            };
        }
        catch (e) {
            // Never silent-catch.
            // eslint-disable-next-line no-console
            console.error('[ol-bottom-tab] sync-hook register threw:', e);
        }
        return root;
    }
    // ── Expose on the OLProduct.chrome namespace (matches siblings) ──
    const r = (typeof window !== 'undefined' ? window : globalThis);
    r.OLProduct = r.OLProduct || {};
    r.OLProduct.chrome =
        r.OLProduct.chrome || {};
    r.OLProduct.chrome.mountBottomTab =
        mountBottomTab;
})();
//# sourceMappingURL=bottom-tab.js.map
;
// ═══ product/chrome/swipe-gestures.js ═══
;"use strict";
/**
 * static/js/product/chrome/swipe-gestures.ts — mobile edge-swipe gesture
 * navigation between bottom-tab views (SHIP-5 Phase 2 sub-slice 2c).
 *
 * Plan: docs/board/audit/2026-05-28_DESIGN_ship5_phase2_scoping.md §2c.
 * OWNER ratified Q3 = Option B (edge-swipe disambiguator) on 2026-05-28.
 *
 * What this is: a body-level touch handler that converts an edge-anchored
 * horizontal swipe into a setView() jump to the next/previous tab in
 * the same DEFAULT_TABS sequence the bottom-tab chrome renders.
 *
 * Why edge-swipe (per scoping §3 Q3 Option B): the LEARN module list,
 * the Markets ticker strip, the watchlist column slider, and several
 * other surfaces use horizontal touch-scroll inside the content area.
 * A naïve body-level swipe handler would steal those gestures and
 * silently break in-pane scroll. The edge-anchored disambiguator
 * (start within EDGE_WIDTH of either screen edge) avoids the conflict
 * without requiring every horizontal-scroll container to opt out —
 * matches the iOS Safari "swipe-back from edge" mental model.
 *
 * Visibility / activation rules (all enforced in JS — never in CSS):
 *   1. Mobile-only — viewport ≤ 767px (mirrors bottom-tab.css; 719→767 2026-06-11, nav-gap fix).
 *   2. NOT on /?view=learn — the LEARN panel owns its own pagination
 *      gestures (lesson next/prev within a journey); a body-level
 *      sibling swipe would collide.
 *   3. Edge-anchored — touchstart.clientX must be within EDGE_WIDTH
 *      (32px) of the RIGHT viewport edge. #31 (2026-06-28): the LEFT edge
 *      is yielded to iOS Safari's system back-swipe (which shares that
 *      zone + drag-right direction); only the right edge is captured.
 *      Anything else passes through to in-pane scroll handlers untouched.
 *   4. Threshold — net horizontal distance > SWIPE_MIN (50px) AND
 *      elapsed time < SWIPE_MAX_MS (400ms). Filters out slow drags +
 *      tiny finger jitter.
 *   5. prefers-reduced-motion: reduce — the handler short-circuits.
 *      Users who request reduced motion typically also want fewer
 *      kinetic navigation surprises; we honor that here per WCAG 2.1
 *      SC 2.3.3 (matching the bottom-tab.css §"Reduced-motion" precedent).
 *
 * Direction → tab change (#31 2026-06-28: right-edge only):
 *   • Touch starts at RIGHT edge, drags LEFT — advance to NEXT tab
 *     (deltaX negative, magnitude > SWIPE_MIN).
 *   • Boundary wrap: from the last tab → first (NEXT cycles the whole set).
 *   • The former left-edge → PREV gesture was removed — it collided with
 *     iOS Safari's left-edge back-swipe. The bottom-tab bar covers reverse
 *     + direct jumps; _resolveNextView still implements 'prev' (used by the
 *     wrap math + reachable if a future non-edge gesture re-enables it).
 *
 * Per FOUNDATIONAL `feedback_module_top_level_window_global_race`:
 * defensive getters for `window.setView` / `window.currentView`. The
 * tab order comes from a hard-coded copy of DEFAULT_TABS (see below) —
 * keeping the array literal local avoids a circular reads-the-other-
 * module race at top-level script eval time. The contract test pins
 * that the two arrays remain in sync.
 *
 * Per FOUNDATIONAL `feedback_zero_ux_friction`: on desktop + on
 * /?view=learn + when reduced-motion is set, the handler is a complete
 * no-op (no listeners attached either, when the gate fails at mount).
 *
 * Per FOUNDATIONAL `feedback_never_destroy_dom`: this module owns no
 * DOM; it only listens. Nothing to destroy.
 *
 * Exposed as `window.OLProduct.chrome.mountSwipeGestures` for
 * orchestrator tests; self-mounts on DOMContentLoaded so the page boot
 * doesn't need wiring elsewhere (matches the sticky-resume-cta.ts
 * pattern at line ~327).
 */
(function () {
    'use strict';
    // ── Tunable constants (CONTRACT-TEST-PINNED literals) ─────────────
    // Edge-swipe disambiguator: touchstart.clientX must be within this
    // many pixels of either viewport edge. Per scoping §3 Q3 Option B
    // recommendation ("~32px of the screen edge"). Mirrors the iOS
    // Safari "swipe-back from edge" hit-zone roughly.
    const EDGE_WIDTH = 32;
    // Net horizontal distance threshold — anything below is finger
    // jitter / accidental drag.
    const SWIPE_MIN = 50;
    // Maximum elapsed time. A "swipe" is intentional + brisk; a "drag"
    // is slow + exploratory. We only treat brisk gestures as navigation.
    const SWIPE_MAX_MS = 400;
    // Mobile-only breakpoint — mirrors bottom-tab.css (767) +
    // sticky-resume-cta.ts MOBILE_MAX_PX (767). Keep in sync
    // (contract: tests/test_mobile_nav_breakpoint_contract.py).
    const MOBILE_MAX_PX = 767;
    // Tab order — MUST mirror bottom-tab.ts DEFAULT_TABS (the canonical
    // source). Hard-coded locally to avoid a cross-module top-level
    // window-global race; the contract test pins the two arrays in sync.
    const SWIPE_TABS = [
        // #113 (2026-08-12): 'ticker' was MISSING here while bottom-tab.ts
        // listed it. The consequence was not a cosmetic mismatch: on Ticker --
        // the app's primary view -- _currentTabIndex() returned -1, so a swipe
        // took the "current view isn't a tab" branch and dumped the user into
        // Learn, and NO swipe from any view could ever return to Ticker. The
        // sync contract could not see this: it hard-coded the four OTHER views
        // as the canonical set, so the one view that had drifted was outside
        // what it checked.
        //
        // N12 (mobile/tablet audit 2026-09-25): order re-mirrored to the bar's
        // new Markets / Stocks / Learn / News / Portfolio (bottom-tab.ts
        // DEFAULT_TABS). The ring, skipping the inert 'learn', is now
        // macro -> ticker -> news -> portfolio -> macro.
        { view: 'macro' }, // Markets — 'macro' is the existing view-id
        { view: 'ticker' }, // the "Stocks" tab
        { view: 'learn' },
        { view: 'news' },
        { view: 'portfolio' },
    ];
    // ── Defensive getters per feedback_module_top_level_window_global_race ──
    function _currentView() {
        try {
            const g = (typeof window !== 'undefined' ? window : globalThis);
            const cv = g.currentView;
            return typeof cv === 'string' ? cv : null;
        }
        catch (_e) {
            return null;
        }
    }
    function _setView(view) {
        const g = (typeof window !== 'undefined' ? window : globalThis);
        const fn = g.setView;
        if (typeof fn === 'function') {
            try {
                fn(view);
            }
            catch (e) {
                // Never silent-catch per FOUNDATIONAL.
                // eslint-disable-next-line no-console
                console.error('[ol-swipe-gestures] setView threw:', e);
            }
        }
        else {
            // Standalone load (no app-init): fall back to a hash so the
            // gesture is still meaningful.
            try {
                // EXT-AUDIT 1.2b (#47): the old '#view=' hash write was a FALSE
                // fallback — nothing reads the fragment (the router reads
                // location.search). Real navigation instead: the server's SPA
                // routes accept ?view=, so a failed/slow app-init bundle still
                // gets the user where they tapped (full reload, but WORKING).
                window.location.search = '?view=' + encodeURIComponent(view);
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error('[ol-swipe-gestures] hash-fallback threw:', e);
            }
        }
    }
    // ── Gate checks (re-evaluated per gesture, not just at mount) ─────
    function _isMobileBreakpoint() {
        try {
            if (typeof window === 'undefined' || !window.matchMedia)
                return false;
            return window.matchMedia('(max-width: ' + MOBILE_MAX_PX + 'px)').matches;
        }
        catch (_e) {
            return false;
        }
    }
    function _prefersReducedMotion() {
        try {
            if (typeof window === 'undefined' || !window.matchMedia)
                return false;
            return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }
        catch (_e) {
            return false;
        }
    }
    // Gate-6 (N13, mobile/tablet audit 2026-09-25): an OPEN overlay owns the
    // screen. The gates above read breakpoint / view / motion / finger count
    // only, so a right-edge swipe under an open sidecar, settings drawer,
    // command palette or modal changed the view BEHIND the dialog -- the user
    // closed it onto a page they never chose. Every such surface is marked
    // role="dialog" aria-modal="true" (dashboard.html + static/templates/*);
    // "open" is whatever makes it visible: no `hidden` attribute, not parked
    // as `data-open="false"` / `aria-hidden="true"` (the settings drawer), not display:none (the
    // d-none / .open-less closed states -- zero client rects), and not
    // visibility:hidden (the settings drawer's closed style). Read per
    // gesture, AFTER the edge check, so a content-area touch pays nothing.
    // Fails OPEN on a DOM error: a broken read must not strand navigation.
    // Contract: tests/test_mobile_audit_n13_swipe_overlay_gate_contract.py.
    function _isOverlayOpen() {
        try {
            if (typeof document === 'undefined' || typeof document.querySelectorAll !== 'function')
                return false;
            const dialogs = document.querySelectorAll('[aria-modal="true"]');
            for (let i = 0; i < dialogs.length; i++) {
                const d = dialogs[i];
                if (d.hidden)
                    continue;
                if (d.getAttribute('data-open') === 'false')
                    continue;
                // A dialog its owner marked closed for assistive tech is closed
                // (the settings drawer writes aria-hidden="true" on close).
                if (d.getAttribute('aria-hidden') === 'true')
                    continue;
                if (typeof d.getClientRects === 'function' && d.getClientRects().length === 0)
                    continue;
                if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function') {
                    const cs = window.getComputedStyle(d);
                    if (cs && cs.visibility === 'hidden')
                        continue;
                }
                return true;
            }
            return false;
        }
        catch (_e) {
            return false;
        }
    }
    // Views where the gesture is deliberately INERT (Gate-2 below). Declared
    // once and consumed by BOTH the gate and the resolver, because keeping
    // them in separate places is what produced the dead end.
    //
    // #F3 (browser QA 2026-08-15). Gate-2 disables swiping while ON 'learn'
    // (the LEARN panel owns its own pagination gestures), but 'learn' sits at
    // DEFAULT_TABS index 1 — immediately after 'ticker', the boot view. So the
    // measured walk from Ticker was: one swipe to Learn, then SIX further
    // swipes doing nothing. macro / news / portfolio were unreachable by
    // swipe from the app's primary view, and the comment below (lines ~315)
    // claiming "repeated right-edge swipes cycle the whole set" was false.
    //
    // WHY NOT REORDER THE ARRAY, which was the first plan: SWIPE_TABS is
    // pinned equal-and-in-order to bottom-tab.ts DEFAULT_TABS
    // (tests/test_ship5_phase2_2c_swipe_gestures_contract.py), and that
    // ordering is load-bearing — the bar shows the order the swipe walks. So
    // moving 'learn' last in the ring would have moved it last in the visible
    // BAR too, undoing the documented "LEARN-first register" choice recorded
    // at bottom-tab.ts DEFAULT_TABS. Skipping the inert view instead gets the
    // whole-set cycle with no change to either array, the bar, or the sync
    // contract: ticker -> macro -> news -> portfolio -> ticker. 'learn' stays
    // one tap away on the bar, which is how a user reaches it anyway — they
    // could never swipe OUT of it.
    const SWIPE_INERT_VIEWS = ['learn'];
    function _isSwipeInert(view) {
        return !!view && SWIPE_INERT_VIEWS.indexOf(view) !== -1;
    }
    // Find the current tab index. Returns -1 if currentView doesn't
    // map to any tab (e.g., a non-tab view like '/?view=ticker').
    function _currentTabIndex() {
        const v = _currentView();
        if (!v)
            return -1;
        for (let i = 0; i < SWIPE_TABS.length; i++) {
            if (SWIPE_TABS[i].view === v)
                return i;
        }
        return -1;
    }
    // Resolve next/prev tab view, wrapping at boundaries (Portfolio →
    // Markets on next; Markets → Portfolio on prev — since N12 the ring
    // starts at Markets; #113's lesson stands: the ring must close THROUGH
    // 'ticker', never past it).
    function _resolveNextView(direction) {
        const idx = _currentTabIndex();
        const n = SWIPE_TABS.length;
        if (n <= 0)
            return null;
        if (idx < 0) {
            // Current view isn't a tab — anchor at first/last for a
            // reasonable navigation fallback.
            return direction === 'next' ? SWIPE_TABS[0].view : SWIPE_TABS[n - 1].view;
        }
        // Wrap-around: (idx ± 1 + n) % n keeps the result in [0, n).
        // Step PAST any swipe-inert view (see SWIPE_INERT_VIEWS): routing a
        // swipe INTO a view the user cannot swipe out of is the dead end #F3
        // measured. Bounded by n so an all-inert array cannot spin.
        let nextIdx = idx;
        for (let step = 0; step < n; step++) {
            nextIdx = direction === 'next' ? (nextIdx + 1) % n : (nextIdx - 1 + n) % n;
            if (!_isSwipeInert(SWIPE_TABS[nextIdx].view))
                return SWIPE_TABS[nextIdx].view;
        }
        // Every tab is inert (or the ring is a single inert tab) — no move.
        return null;
    }
    function _newTouchState() {
        return {
            startX: 0,
            startY: 0,
            startT: 0,
            startedAtLeftEdge: false,
            startedAtRightEdge: false,
            active: false,
        };
    }
    let state = _newTouchState();
    function _onTouchStart(e) {
        // Gate-1 + Gate-2 (mobile + not-on-learn) — re-check per gesture
        // because viewport + currentView can change at any time.
        if (!_isMobileBreakpoint()) {
            state.active = false;
            return;
        }
        // Gate-2 — reads the SAME SWIPE_INERT_VIEWS the resolver skips, so the
        // "disabled here" and "never routed here" halves cannot drift apart
        // (they had: the gate knew about 'learn', the resolver did not).
        if (_isSwipeInert(_currentView())) {
            state.active = false;
            return;
        }
        // Gate-5: prefers-reduced-motion — short-circuit entirely.
        if (_prefersReducedMotion()) {
            state.active = false;
            return;
        }
        // Multi-finger gestures aren't ours — pinch-zoom etc. pass through.
        if (!e.touches || e.touches.length !== 1) {
            state.active = false;
            return;
        }
        const t = e.touches[0];
        const vw = (typeof window !== 'undefined' && window.innerWidth)
            ? window.innerWidth
            : 0;
        if (vw <= 0) {
            state.active = false;
            return;
        }
        const x = t.clientX;
        const startedAtLeftEdge = x <= EDGE_WIDTH;
        const startedAtRightEdge = x >= (vw - EDGE_WIDTH);
        // Gate-3: edge-anchored, RIGHT EDGE ONLY. #31 (2026-06-28, OWNER): the
        // former left-edge → PREV gesture shared iOS Safari's left-edge
        // back-swipe hit-zone AND its drag-right direction, so a left-edge
        // swipe-right jumped a tab WHILE the browser also navigated back — a
        // double-action collision. We now yield the left edge entirely to the
        // OS back-gesture and capture ONLY the right edge (iOS Safari has no
        // system gesture there). A left-edge or content-area start passes
        // through untouched — in-pane scroll + the OS back-swipe keep full
        // capture. (startedAtLeftEdge is still computed for diagnostics + the
        // edge-disambiguator contract, but never routes to navigation now.)
        if (!startedAtRightEdge) {
            state.active = false;
            return;
        }
        // Gate-6 (N13): never navigate under an open dialog / drawer.
        if (_isOverlayOpen()) {
            state.active = false;
            return;
        }
        state = {
            startX: x,
            startY: t.clientY,
            startT: Date.now(),
            startedAtLeftEdge: startedAtLeftEdge,
            startedAtRightEdge: startedAtRightEdge,
            active: true,
        };
    }
    function _onTouchEnd(e) {
        if (!state.active)
            return;
        const s = state;
        // Reset early so any re-entrant call sees a clean slate.
        state = _newTouchState();
        // changedTouches has the lift-off point for touchend.
        const ct = e.changedTouches && e.changedTouches[0];
        if (!ct)
            return;
        const endX = ct.clientX;
        const endY = ct.clientY;
        const dt = Date.now() - s.startT;
        if (dt > SWIPE_MAX_MS)
            return; // too slow → drag, not swipe
        if (dt <= 0)
            return; // clock weirdness — bail
        const deltaX = endX - s.startX;
        const deltaY = endY - s.startY;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);
        if (absX < SWIPE_MIN)
            return; // below threshold
        if (absY >= absX)
            return; // more vertical than horizontal — ignore
        // Direction → tab change. #31 (2026-06-28): ONLY the right-edge
        // swipe-LEFT → NEXT gesture remains. The former left-edge swipe-RIGHT
        // → PREV was removed because it collided with iOS Safari's left-edge
        // back-swipe (see Gate-3).
        //
        // #F3 (2026-08-15) CORRECTED this comment, which used to read "NEXT
        // wraps (Portfolio → Learn), so repeated right-edge swipes cycle the
        // whole set". That was MEASURED FALSE in prod: the ring stopped dead
        // on 'learn'. It is true now, by a different route — the resolver
        // skips SWIPE_INERT_VIEWS, so the cycle is (since the N12 re-order)
        // macro → ticker → news → portfolio → macro. 'learn' is deliberately
        // NOT in that cycle (Gate-2 makes it unswipeable); the bottom-tab bar
        // covers it, plus direct + reverse jumps.
        let direction = null;
        if (s.startedAtRightEdge && deltaX < 0) {
            direction = 'next';
        }
        if (!direction)
            return;
        const target = _resolveNextView(direction);
        if (!target)
            return;
        _setView(target);
    }
    function _onTouchCancel() {
        // Gesture interrupted by the OS / browser — reset.
        state = _newTouchState();
    }
    let _mounted = false;
    function mountSwipeGestures() {
        if (_mounted)
            return;
        _mounted = true;
        if (typeof document === 'undefined')
            return;
        // #47 1.7 (2026-07-06): the old mount-time Gate-1/Gate-5 short-
        // circuits contradicted their own rationale — "the per-gesture
        // re-check handles the mid-session widen/narrow case" is only true
        // if the listeners were ATTACHED. A page loaded >767px (desktop
        // window later narrowed, tablet rotation, DevTools emulation)
        // skipped attachment entirely, so swipe was permanently dead for
        // that session. Listeners are passive + observational,
        // _onTouchStart re-checks BOTH the breakpoint (Gate-1) and
        // prefers-reduced-motion (Gate-5) per gesture, and touchstart
        // doesn't fire on non-touch hardware — unconditional attachment
        // costs nothing and is correct in both directions.
        try {
            // passive: true — we never preventDefault(); the gesture is
            // strictly observational. Helps the browser keep scroll
            // smooth on touchmove (which we don't even listen for).
            document.addEventListener('touchstart', _onTouchStart, { passive: true });
            document.addEventListener('touchend', _onTouchEnd, { passive: true });
            document.addEventListener('touchcancel', _onTouchCancel, { passive: true });
        }
        catch (e) {
            // Never silent-catch.
            // eslint-disable-next-line no-console
            console.error('[ol-swipe-gestures] listener attach threw:', e);
        }
    }
    // ── Self-mount on DOMContentLoaded ────────────────────────────────
    function _autoMount() {
        try {
            mountSwipeGestures();
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('[ol-swipe-gestures] auto-mount threw:', e);
        }
    }
    if (typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', _autoMount);
        }
        else {
            _autoMount();
        }
    }
    // ── Expose on OLProduct.chrome (matches siblings) ─────────────────
    const r = (typeof window !== 'undefined' ? window : globalThis);
    r.OLProduct = r.OLProduct || {};
    r.OLProduct.chrome = r.OLProduct.chrome || {};
    r.OLProduct.chrome.mountSwipeGestures = mountSwipeGestures;
})();
//# sourceMappingURL=swipe-gestures.js.map
;
// ═══ product/chrome/sticky-resume-cta.js ═══
;"use strict";
/**
 * static/js/product/chrome/sticky-resume-cta.ts — mobile sticky-Resume CTA
 * (SHIP-5 Phase 2 sub-slice 2d).
 *
 * Plan: docs/board/audit/2026-05-28_DESIGN_ship5_phase2_scoping.md §2d.
 * OWNER ratified the Phase-2 build 2026-05-28; second-batch ships 2d + 2g.
 *
 * What this is: a thin, fixed-position chrome strip that sits ABOVE the
 * mobile bottom-tab bar and offers a one-tap "Resume: <module>" jump
 * back into the user's in-progress LEARN journey.
 *
 * Visibility rules (all enforced in JS — never in CSS, per the brief):
 *   1. Mobile-only — viewport width ≤ 719px (matches the bottom-tab
 *      breakpoint in static/css/bottom-tab.css). NOT a CSS-only hide;
 *      we skip the DOM mount entirely on desktop so the markup never
 *      ships on viewports that don't need it.
 *   2. In-progress LEARN journey — fetched from /api/learning/progress/all
 *      which returns `{modules: {...}, last_active: {moduleId, pathId}}`.
 *      "In progress" means 0 < %completed < 100; we use the per-module
 *      mastery state (mastery_passed=true → completed) and require that
 *      `last_active.moduleId` points at a module the user has NOT
 *      mastered. If every visited module is mastered, the CTA hides.
 *   3. NOT on /?view=learn — the LEARN panel itself is where the user
 *      resumes from anyway; the chrome would be redundant.
 *
 * Style: minimal — cream background, top border (matching the bottom-tab
 * border-top), Garamond italic module name, mono "RESUME" label, "→"
 * arrow on the right. Compositor-friendly transitions only
 * (opacity / transform); no width/height/top/left transitions per the
 * 60fps budget on iPhone-SE-class (same constraint as bottom-tab.ts §2a).
 *
 * z-index: 999 (one below the bottom-tab's 1000) so it sits in the
 * stacking order ABOVE general content but BELOW the bottom-tab strip.
 * bottom: calc(56px + env(safe-area-inset-bottom, 0)) — perches on top
 * of the bottom-tab bar.
 *
 * Per FOUNDATIONAL `feedback_module_top_level_window_global_race`: the
 * caller side (this file) does not assume `window.setView` /
 * `window.currentView` are present at module-eval time; defensive
 * getters run inside the visibility check on each mount cycle.
 *
 * Per FOUNDATIONAL `feedback_never_destroy_dom`: mount is idempotent;
 * subsequent updates touch a single `.ol-resume-cta__module` textContent
 * + the strip's hidden-class toggle. No innerHTML on the parent. Hide =
 * `display: none` via class toggle; never DOM-remove (the parent stays
 * for revisit cycles).
 *
 * Exposed as `window.OLProduct.chrome.mountStickyResumeCta` for
 * orchestrator tests; self-mounts on DOMContentLoaded so the page boot
 * doesn't need wiring elsewhere.
 */
(function () {
    'use strict';
    const ROOT_ID = 'ol-sticky-resume-cta';
    const HIDDEN_CLASS = 'ol-sticky-resume-cta--hidden';
    const MOBILE_MAX_PX = 767; // mirrors static/css/bottom-tab.css breakpoint (719→767 2026-06-11)
    const FETCH_TIMEOUT_MS = 8000;
    // N9 (mobile/tablet audit 2026-09-25): the strip had no way off the screen
    // on a phone -- it perched above the bottom-tab bar for the whole session,
    // and the body reserved room for the bar only, so the strip covered the
    // last ~50px of every view. Two fixes: a "Dismiss" text button that hides
    // it for the SESSION (sessionStorage, so a fresh visit offers the resume
    // again; try/catch because storage can be blocked), and the strip's live
    // height published as --ol-resume-cta-h, which bottom-tab.css adds to the
    // body reserve (same mechanism as --ol-bottom-tab-h, #304).
    // Contract: tests/test_mobile_audit_n9_sticky_resume_dismiss_contract.py.
    const DISMISS_KEY = 'ol_resume_cta_dismissed';
    // Through the OLStorage wrapper (storage.ts is the one file allowed to
    // touch sessionStorage: ol/no-direct-localstorage). typeof-guarded because
    // this chrome can load standalone, without the storage defer.
    function _isDismissedThisSession() {
        try {
            if (typeof OLStorage === 'undefined')
                return false;
            return OLStorage.getSessionString(DISMISS_KEY, null) === '1';
        }
        catch (_e) {
            return false;
        }
    }
    function _rememberDismissed() {
        try {
            if (typeof OLStorage !== 'undefined')
                OLStorage.setSessionString(DISMISS_KEY, '1');
        }
        catch (_e) { /* storage blocked: the in-memory hide still holds for this page */ }
    }
    // Publish the strip's live height (0 when hidden) so bottom-anchored
    // content reserve can include it; never throws.
    function _publishHeight(root) {
        try {
            const hidden = root.classList.contains(HIDDEN_CLASS);
            const h = hidden ? 0 : (root.offsetHeight || 0);
            // Literal name: tools/check_css_var_drift.py reads setProperty('--x') as the definition.
            document.documentElement.style.setProperty('--ol-resume-cta-h', h + 'px');
        }
        catch (_e) { /* the CSS fallback (0px) applies */ }
    }
    // ── Defensive getters per feedback_module_top_level_window_global_race ──
    function _currentView() {
        try {
            const g = (typeof window !== 'undefined' ? window : globalThis);
            const cv = g.currentView;
            return typeof cv === 'string' ? cv : null;
        }
        catch (_e) {
            return null;
        }
    }
    function _setView(view) {
        const g = (typeof window !== 'undefined' ? window : globalThis);
        const fn = g.setView;
        if (typeof fn === 'function') {
            try {
                fn(view);
            }
            catch (e) {
                // Never silent-catch.
                // eslint-disable-next-line no-console
                console.error('[ol-sticky-resume-cta] setView threw:', e);
            }
        }
        else {
            try {
                // EXT-AUDIT 1.2b (#47): the old '#view=' hash write was a FALSE
                // fallback — nothing reads the fragment (the router reads
                // location.search). Real navigation instead: the server's SPA
                // routes accept ?view=, so a failed/slow app-init bundle still
                // gets the user where they tapped (full reload, but WORKING).
                window.location.search = '?view=' + encodeURIComponent(view);
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error('[ol-sticky-resume-cta] hash-fallback threw:', e);
            }
        }
    }
    function _isMobileBreakpoint() {
        try {
            if (typeof window === 'undefined' || !window.matchMedia)
                return false;
            return window.matchMedia('(max-width: ' + MOBILE_MAX_PX + 'px)').matches;
        }
        catch (_e) {
            return false;
        }
    }
    // Visibility decision: all four gates must pass. Returns null when
    // hidden, or the {moduleId, moduleLabel} payload when visible.
    function _decideVisibility(progress) {
        // Gate 0 (N9) — dismissed for this session
        if (_isDismissedThisSession())
            return null;
        // Gate 1 — mobile breakpoint
        if (!_isMobileBreakpoint())
            return null;
        // Gate 2 — NOT on /?view=learn (redundant chrome there)
        const view = _currentView();
        if (view === 'learn')
            return null;
        // Gate 3 — have a last-active module to resume into
        if (!progress || !progress.last_active)
            return null;
        const lastMod = progress.last_active.moduleId;
        if (!lastMod || typeof lastMod !== 'string' || !lastMod.trim()) {
            return null;
        }
        // #81 C1: prefer the server-enriched display title over the
        // title-cased slug (the bar was rendering "Pf 4" instead of
        // "Index Funds: Why Most Active Funds Underperform").
        const _title = (progress.last_active.moduleTitle && String(progress.last_active.moduleTitle).trim())
            ? String(progress.last_active.moduleTitle)
            : _humanizeModuleId(lastMod);
        // Gate 4 — that module must be IN PROGRESS (0 < completion < 100).
        // We treat mastery_passed=true OR completed=true as "100% done";
        // a module the user has touched at least once but not mastered is
        // the canonical "in-progress" state per the scoping doc §2d.
        const modules = progress.modules || {};
        const entry = modules[lastMod];
        if (!entry) {
            // The user has a last_active pointer but no progress row yet —
            // treat as in-progress (first-touch with no quiz submission).
            return { moduleId: lastMod, moduleLabel: _title };
        }
        const isDone = Boolean(entry.masteryPassed) || Boolean(entry.completed);
        if (isDone)
            return null;
        return { moduleId: lastMod, moduleLabel: _title };
    }
    // Module IDs in learning-paths.json are kebab-case slugs (e.g.,
    // "bdc-credit-fundamentals"). Convert to a Title Case display label
    // for the CTA without a network fetch — we don't have the lessons
    // catalog client-side at chrome-mount time.
    function _humanizeModuleId(id) {
        return id
            .split('-')
            .filter(Boolean)
            .map(function (w) {
            return w.charAt(0).toUpperCase() + w.slice(1);
        })
            .join(' ');
    }
    function _build() {
        const root = document.createElement('div');
        root.id = ROOT_ID;
        root.className = 'ol-sticky-resume-cta ' + HIDDEN_CLASS;
        root.setAttribute('role', 'complementary');
        root.setAttribute('aria-label', 'Resume in-progress lesson');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ol-sticky-resume-cta__btn';
        // #81 (2026-07-06 OWNER console capture): the data-action attribute
        // was DECORATIVE — this component binds its own click handler
        // (_attachClickHandler), but the global delegated dispatcher also
        // saw the attribute, found no map entry, and warned
        // "[action] No handler for: sticky-resume-cta-tap" on every tap.
        // An unclaimed data-action is the #89 go-data-status orphan class:
        // either the map owns it or the attribute goes. The local handler
        // owns navigation here, so the attribute goes.
        const label = document.createElement('span');
        label.className = 'ol-sticky-resume-cta__label';
        label.textContent = 'RESUME';
        const mod = document.createElement('span');
        mod.className = 'ol-sticky-resume-cta__module';
        mod.textContent = '';
        const arrow = document.createElement('span');
        arrow.className = 'ol-sticky-resume-cta__arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→'; // right arrow
        btn.appendChild(label);
        btn.appendChild(mod);
        btn.appendChild(arrow);
        root.appendChild(btn);
        // N9: the session dismiss. A plain text button (no icon glyph to
        // guess at), its own tap target beside the resume button.
        const dismiss = document.createElement('button');
        dismiss.type = 'button';
        dismiss.className = 'ol-sticky-resume-cta__dismiss';
        dismiss.setAttribute('aria-label', 'Dismiss the resume reminder for this visit');
        dismiss.textContent = 'Dismiss';
        root.appendChild(dismiss);
        return root;
    }
    async function _fetchProgress() {
        // 2026-09-26 anon audit: a signed-out reader has no progress to resume;
        // the call was a guaranteed 401 on every view (a false "session
        // expired" toast once toasts became visible, and rate-limit budget).
        const _anonFn = window.olIsAnonymous;
        if (typeof _anonFn === 'function' && _anonFn())
            return null;
        try {
            // AbortController for timeout — never let a slow/hung request
            // keep the strip in a stale state.
            const controller = (typeof AbortController !== 'undefined')
                ? new AbortController()
                : null;
            const timer = controller
                ? setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT_MS)
                : null;
            const init = { credentials: 'include' };
            if (controller)
                init.signal = controller.signal;
            // #16 (2026-06-18): route through the shared getProgressAll singleton
            // (in-flight + 5s-TTL dedup) so the resume CTA shares ONE
            // /api/learning/progress/all request with the learn surfaces +
            // learning-paths on a learn paint. Boot-order fallback to a direct
            // fetch when window.OLApi isn't installed yet. getProgressAll throws
            // on non-2xx → the outer catch logs + returns null (same as !ok).
            let body;
            if (window.OLApi && typeof window.OLApi.getProgressAll === 'function') {
                body = await window.OLApi.getProgressAll(init);
                if (timer)
                    clearTimeout(timer);
            }
            else {
                const resp = await fetch('/api/learning/progress/all', init);
                if (timer)
                    clearTimeout(timer);
                if (!resp || !resp.ok)
                    return null;
                body = (await resp.json());
            }
            return body || null;
        }
        catch (e) {
            // Never silent-catch — the dev console + Sentry browser SDK
            // pick up the warning.
            // eslint-disable-next-line no-console
            console.warn('[ol-sticky-resume-cta] progress fetch failed:', e);
            return null;
        }
    }
    function _applyDecision(root, decision) {
        const moduleSpan = root.querySelector('.ol-sticky-resume-cta__module');
        const btn = root.querySelector('.ol-sticky-resume-cta__btn');
        if (!decision) {
            root.classList.add(HIDDEN_CLASS);
            if (btn)
                btn.removeAttribute('data-module-id');
            _publishHeight(root);
            return;
        }
        if (moduleSpan)
            moduleSpan.textContent = decision.moduleLabel;
        if (btn)
            btn.setAttribute('data-module-id', decision.moduleId);
        root.classList.remove(HIDDEN_CLASS);
        _publishHeight(root);
    }
    function _attachClickHandler(root) {
        const btn = root.querySelector('.ol-sticky-resume-cta__btn');
        if (!btn)
            return;
        btn.addEventListener('click', function () {
            // Tap routes to the LEARN panel. The panel itself handles
            // resuming into the right module from last_active state.
            _setView('learn');
            // Hide self post-tap; LEARN view is the new "redundant"
            // surface per Gate 2.
            root.classList.add(HIDDEN_CLASS);
            _publishHeight(root);
        });
        // N9: Dismiss hides the strip for this session and gives the reserved
        // space back. Not a navigation -- the user stays where they are.
        const dismiss = root.querySelector('.ol-sticky-resume-cta__dismiss');
        if (dismiss) {
            dismiss.addEventListener('click', function () {
                _rememberDismissed();
                root.classList.add(HIDDEN_CLASS);
                _publishHeight(root);
            });
        }
    }
    async function _refresh(root) {
        const progress = await _fetchProgress();
        _applyDecision(root, _decideVisibility(progress));
    }
    function mountStickyResumeCta() {
        // Idempotent — never remount per feedback_never_destroy_dom.
        const existing = document.getElementById(ROOT_ID);
        if (existing)
            return existing;
        // Gate-1 fast-skip — never mount markup on desktop. The
        // recheck-on-resize path (below) handles viewport widening.
        if (!_isMobileBreakpoint())
            return null;
        const parent = document.body;
        if (!parent)
            return null;
        const root = _build();
        parent.appendChild(root);
        _attachClickHandler(root);
        // Initial decision + fetch. Don't block — the strip stays hidden
        // until the fetch resolves.
        _refresh(root).catch(function (e) {
            // eslint-disable-next-line no-console
            console.warn('[ol-sticky-resume-cta] initial refresh failed:', e);
        });
        // Re-evaluate on view changes — Gate 2 is view-dependent.
        try {
            const g = (typeof window !== 'undefined' ? window : globalThis);
            const orig = g.setView;
            if (typeof orig === 'function' && !orig._olResumeCtaPatched) {
                // Forward EVERY argument (popstate's skipHistory) -- see bottom-tab.ts.
                const wrapped = function (...args) {
                    const result = orig.apply(this, args);
                    const view = args[0];
                    // Apply Gate-2 immediately (cheap), then re-fetch in
                    // case progress changed.
                    if (view === 'learn') {
                        root.classList.add(HIDDEN_CLASS);
                        _publishHeight(root);
                    }
                    else {
                        _refresh(root).catch(function () { });
                    }
                    return result;
                };
                wrapped._olResumeCtaPatched = true;
                g.setView = wrapped;
            }
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('[ol-sticky-resume-cta] setView wrap threw:', e);
        }
        // Re-evaluate on visibility-change (background → foreground; user
        // may have completed a module in another tab).
        try {
            document.addEventListener('visibilitychange', function () {
                if (document.visibilityState === 'visible') {
                    _refresh(root).catch(function () { });
                }
            });
        }
        catch (_e) { /* no-op */ }
        return root;
    }
    // ── Self-mount on DOMContentLoaded ────────────────────────────────
    function _autoMount() {
        try {
            mountStickyResumeCta();
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('[ol-sticky-resume-cta] auto-mount threw:', e);
        }
    }
    if (typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', _autoMount);
        }
        else {
            _autoMount();
        }
    }
    // ── Expose on OLProduct.chrome (matches siblings) ─────────────────
    const r = (typeof window !== 'undefined' ? window : globalThis);
    r.OLProduct = r.OLProduct || {};
    r.OLProduct.chrome = r.OLProduct.chrome || {};
    r.OLProduct.chrome.mountStickyResumeCta = mountStickyResumeCta;
})();
//# sourceMappingURL=sticky-resume-cta.js.map
;